var __defProp = Object.defineProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};

// src/lib/enums/discussions.ts
var DiscussionType = /* @__PURE__ */ ((DiscussionType2) => {
  DiscussionType2["PRIVATE"] = "private";
  DiscussionType2["GROUP"] = "group";
  DiscussionType2["CONTEXT"] = "context";
  return DiscussionType2;
})(DiscussionType || {});
var DiscussionContextType = /* @__PURE__ */ ((DiscussionContextType2) => {
  DiscussionContextType2["ADDRESS"] = "address";
  DiscussionContextType2["RESOURCE_COMBINATION"] = "resourceCombination";
  DiscussionContextType2["SALES_ORDER_LEG"] = "salesOrderLeg";
  DiscussionContextType2["STOP"] = "stop";
  return DiscussionContextType2;
})(DiscussionContextType || {});

// src/lib/enums/exceptionAction.ts
var ExceptionActionTypeKey = /* @__PURE__ */ ((ExceptionActionTypeKey2) => {
  ExceptionActionTypeKey2["COMMENT"] = "comment";
  ExceptionActionTypeKey2["STATUS_CHANGE"] = "statusChange";
  ExceptionActionTypeKey2["ASSIGNEE_CHANGE"] = "assigneeChange";
  ExceptionActionTypeKey2["SEVERITY_CHANGE"] = "severityChange";
  return ExceptionActionTypeKey2;
})(ExceptionActionTypeKey || {});

// src/lib/enums/messages.ts
var MessageTypeKey = /* @__PURE__ */ ((MessageTypeKey2) => {
  MessageTypeKey2["STANDARD"] = "standard";
  return MessageTypeKey2;
})(MessageTypeKey || {});

// src/lib/enums/instructions.ts
var InstructionKey = /* @__PURE__ */ ((InstructionKey2) => {
  InstructionKey2["ACTIVITY_DRIVER_INFO"] = "so_activity_driver_info";
  InstructionKey2["ACTIVITY_REMARKS"] = "so_activity_remarks";
  return InstructionKey2;
})(InstructionKey || {});

// src/lib/enums/notification.ts
var NotificationType = /* @__PURE__ */ ((NotificationType2) => {
  NotificationType2["CHANGES_TO_STOP"] = "changesToStop";
  NotificationType2["NEW_STOP"] = "newStop";
  NotificationType2["NEW_STOP_BEFORE_DRIVING"] = "newStopBeforeDriving";
  NotificationType2["NEW_STOP_BEFORE_LOCATION"] = "newStopBeforeOnLocation";
  NotificationType2["NEW_STOP_AFTER_CURRENT"] = "newStopAfterCurrent";
  NotificationType2["NEW_SHIPMENT"] = "newRow";
  NotificationType2["NEW_ROW_TO_CURRENT_STOP"] = "newRowToCurrentStop";
  NotificationType2["CANCELED_RESOURCE_COMBINATION"] = "canceledResourceCombination";
  NotificationType2["CANCELED_STOP"] = "canceledStop";
  NotificationType2["CANCELED_CURRENT_STOP"] = "canceledCurrentStop";
  NotificationType2["CANCELED_ROW"] = "canceledRow";
  NotificationType2["CHANGES_TO_CURRENT_STOP_DRIVING"] = "changesToCurrentStopDriving";
  NotificationType2["CHANGES_TO_CURRENT_STOP_ON_LOCATION"] = "changesToCurrentStopOnLocation";
  NotificationType2["NEW_TRIP"] = "newResourceCombination";
  NotificationType2["CANCELED_ROW_FROM_CURRENT_STOP"] = "canceledRowFromCurrentStop";
  return NotificationType2;
})(NotificationType || {});
var NotificationContext = /* @__PURE__ */ ((NotificationContext2) => {
  NotificationContext2["STOP"] = "stop";
  NotificationContext2["RESOURCE_COMBINATION"] = "resourceCombination";
  NotificationContext2["SHIPMENT"] = "tripActivity";
  return NotificationContext2;
})(NotificationContext || {});

// src/lib/enums/queryKeys.ts
var QUERY_KEYS = /* @__PURE__ */ ((QUERY_KEYS2) => {
  QUERY_KEYS2["ABSENCE_TYPES"] = "ABSENCE_TYPES";
  QUERY_KEYS2["ACTIVITIES"] = "ACTIVITIES";
  QUERY_KEYS2["ACTIVITY"] = "ACTIVITY";
  QUERY_KEYS2["ALL_EXCEPTIONS"] = "ALL_EXCEPTIONS";
  QUERY_KEYS2["APPLICATION_FEATURES"] = "APPLICATION_FEATURES";
  QUERY_KEYS2["COUNTRY_OPTIONS"] = "COUNTRY_OPTIONS";
  QUERY_KEYS2["DISCUSSION_CONTEXT"] = "DISCUSSION_CONTEXT";
  QUERY_KEYS2["DISCUSSION_PARTICIPANTS"] = "DISCUSSION_PARTICIPANTS";
  QUERY_KEYS2["DISCUSSIONS"] = "DISCUSSIONS";
  QUERY_KEYS2["DOCUMENTS"] = "DOCUMENTS";
  QUERY_KEYS2["EPICS"] = "EPICS";
  QUERY_KEYS2["EXCEPTION_ACTIONS"] = "EXCEPTION_ACTIONS";
  QUERY_KEYS2["EXCEPTION_CAUSES"] = "EXCEPTION_CAUSES";
  QUERY_KEYS2["EXCEPTION_CAUSES_OPTIONS"] = "CAUSE_OF_ISSUE_OPTIONS";
  QUERY_KEYS2["EXCEPTION_CLASSES"] = "EXCEPTION_CLASSES";
  QUERY_KEYS2["EXCEPTION_COSTS"] = "EXCEPTION_COSTS";
  QUERY_KEYS2["EXCEPTION_CONTEXTS"] = "EXCEPTION_CONTEXTS";
  QUERY_KEYS2["EXCEPTION_FORM_INSTRUCTIONS"] = "EXCEPTION_FORM_INSTRUCTIONS";
  QUERY_KEYS2["EXCEPTION_REASON_OPTIONS"] = "EXCEPTION_REASON_OPTIONS";
  QUERY_KEYS2["EXCEPTION_REASONS"] = "EXCEPTION_REASONS";
  QUERY_KEYS2["EXCEPTION_TYPE_OPTIONS"] = "EXCEPTION_TYPE_OPTIONS";
  QUERY_KEYS2["EXCEPTION_TYPES"] = "EXCEPTION_TYPES";
  QUERY_KEYS2["EXCEPTION_WAITING_REASONS"] = "EXCEPTION_WAITING_REASONS";
  QUERY_KEYS2["EXCEPTION_RESPONSIBLE_USERS"] = "EXCEPTION_RESPONSIBLE_USERS";
  QUERY_KEYS2["EXCEPTION_WAITING_REASONS_OPTIONS"] = "EXCEPTION_WAITING_REASON_OPTIONS";
  QUERY_KEYS2["EXTRA_SHIPMENTS"] = "EXTRA_SHIPMENTS";
  QUERY_KEYS2["FEATURES"] = "FEATURES";
  QUERY_KEYS2["LANGUAGES"] = "LANGUAGES";
  QUERY_KEYS2["MESSAGES"] = "MESSAGES";
  QUERY_KEYS2["NOTIFICATIONS"] = "NOTIFICATIONS";
  QUERY_KEYS2["PAY_GROUP_MEMBERS"] = "PAY_GROUP_MEMBERS";
  QUERY_KEYS2["PAY_GROUPS"] = "PAY_GROUPS";
  QUERY_KEYS2["PAYROLL_TYPES"] = "PAYROLL_TYPES";
  QUERY_KEYS2["RELATED_EXCEPTIONS"] = "RELATED_EXCEPTIONS";
  QUERY_KEYS2["RIGHTS"] = "RIGHTS";
  QUERY_KEYS2["ROLES"] = "ROLES";
  QUERY_KEYS2["SHIPMENT"] = "SHIPMENT";
  QUERY_KEYS2["SHIPMENT_OPTIONS"] = "SHIPMENT_OPTIONS";
  QUERY_KEYS2["SHIPMENTS"] = "SHIPMENTS";
  QUERY_KEYS2["SIGNUP"] = "SIGNUP";
  QUERY_KEYS2["STAKEHOLDERS"] = "STAKEHOLDERS";
  QUERY_KEYS2["STOP"] = "STOP";
  QUERY_KEYS2["STOPS"] = "STOPS";
  QUERY_KEYS2["STORIES"] = "STORIES";
  QUERY_KEYS2["STORY_VOTE"] = "STORIES:VOTE";
  QUERY_KEYS2["STORY_COMMENTS"] = "STORIES:COMMENTS";
  QUERY_KEYS2["TERMINAL_ACTIVITIES"] = "TERMINAL_ACTIVITIES";
  QUERY_KEYS2["TERMINAL_DOCKS"] = "TERMINAL_DOCKS";
  QUERY_KEYS2["TERMINAL_OPTIONS"] = "TERMINAL_OPTIONS";
  QUERY_KEYS2["TERMINAL_STOCK_PLACES"] = "TERMINAL_STOCK_PLACES";
  QUERY_KEYS2["TERMINAL_STOPS"] = "TERMINAL_STOPS";
  QUERY_KEYS2["TERMINALS"] = "TERMINALS";
  QUERY_KEYS2["USER_APPLICATION_ROLES"] = "USER_APPLICATION_ROLES";
  QUERY_KEYS2["USERS"] = "USERS";
  QUERY_KEYS2["WORK_TYPES"] = "WORK_TYPES";
  return QUERY_KEYS2;
})(QUERY_KEYS || {});

// src/lib/enums/shipment.ts
var ShipmentStatus = /* @__PURE__ */ ((ShipmentStatus2) => {
  ShipmentStatus2[ShipmentStatus2["NOT_STARTED"] = 0] = "NOT_STARTED";
  ShipmentStatus2[ShipmentStatus2["STARTED"] = 1] = "STARTED";
  ShipmentStatus2[ShipmentStatus2["FINISHED"] = 2] = "FINISHED";
  ShipmentStatus2[ShipmentStatus2["ABORTED"] = 3] = "ABORTED";
  return ShipmentStatus2;
})(ShipmentStatus || {});

// src/lib/enums/socketEvents.ts
var SOCKET_EVENTS = /* @__PURE__ */ ((SOCKET_EVENTS2) => {
  SOCKET_EVENTS2["REVALIDATE_QUERY_KEYS"] = "revalidate-query-keys";
  SOCKET_EVENTS2["BULK_FINALISE_PROGRESS"] = "bulk-finalise-progress";
  SOCKET_EVENTS2["BULK_FINALISE_DONE"] = "bulk-finalise-done";
  SOCKET_EVENTS2["BULK_FINALISE_ERROR"] = "bulk-finalise-error";
  return SOCKET_EVENTS2;
})(SOCKET_EVENTS || {});

// src/lib/enums/stop.ts
var StopStatus = /* @__PURE__ */ ((StopStatus2) => {
  StopStatus2[StopStatus2["NOT_STARTED"] = 0] = "NOT_STARTED";
  StopStatus2[StopStatus2["STARTED"] = 1] = "STARTED";
  StopStatus2[StopStatus2["ON_LOCATION"] = 2] = "ON_LOCATION";
  StopStatus2[StopStatus2["LOADING_UNLOADING_STARTED"] = 3] = "LOADING_UNLOADING_STARTED";
  StopStatus2[StopStatus2["FINISHED"] = 4] = "FINISHED";
  StopStatus2[StopStatus2["ABORTED"] = 5] = "ABORTED";
  return StopStatus2;
})(StopStatus || {});
var ActivityStage = /* @__PURE__ */ ((ActivityStage2) => {
  ActivityStage2["DRIVING"] = "stopDriving";
  ActivityStage2["LOADING"] = "stopLoading";
  ActivityStage2["UNLOADING"] = "stopUnloading";
  ActivityStage2["ON_LOCATION"] = "stopOnLocation";
  ActivityStage2["WAITING"] = "stopWaiting";
  ActivityStage2["AUTOMATIC_WAITING"] = "stopAutomaticWaiting";
  return ActivityStage2;
})(ActivityStage || {});

// src/lib/enums/tripActivity.ts
var TripActivityStatus = /* @__PURE__ */ ((TripActivityStatus2) => {
  TripActivityStatus2[TripActivityStatus2["NOT_DONE"] = 0] = "NOT_DONE";
  TripActivityStatus2[TripActivityStatus2["DONE"] = 1] = "DONE";
  TripActivityStatus2[TripActivityStatus2["UNLOADED"] = 2] = "UNLOADED";
  TripActivityStatus2[TripActivityStatus2["UNCLEAR"] = 3] = "UNCLEAR";
  return TripActivityStatus2;
})(TripActivityStatus || {});
var ActivityStep = /* @__PURE__ */ ((ActivityStep2) => {
  ActivityStep2["COUPLING"] = "AANK";
  ActivityStep2["LOADING"] = "LAD";
  ActivityStep2["UNLOADING"] = "LOS";
  ActivityStep2["DECOUPLING"] = "AFK";
  ActivityStep2["DIVIDER"] = "WALL";
  ActivityStep2["DIVIDER_HARD"] = "HARD WALL";
  ActivityStep2["TO_SHIP"] = "BOOTOP";
  ActivityStep2["FROM_SHIP"] = "BOOTAF";
  ActivityStep2["TO_TRAIN"] = "TREINOP";
  ActivityStep2["FROM_TRAIN"] = "TREINAF";
  ActivityStep2["CUSTOMS"] = "CUSTOMS";
  ActivityStep2["REST"] = "REST";
  ActivityStep2["STOPPED"] = "STOP";
  ActivityStep2["MAINTENANCE"] = "HUOLTO";
  ActivityStep2["RETURNED"] = "RETURN EM";
  ActivityStep2["INFO"] = "INFO";
  ActivityStep2["DRIVER_CHANGE"] = "DRIVER CHA";
  ActivityStep2["UNCLEAR"] = "UNCLEAR";
  return ActivityStep2;
})(ActivityStep || {});
var MassFunctionality = /* @__PURE__ */ ((MassFunctionality2) => {
  MassFunctionality2["YES"] = "YES";
  MassFunctionality2["PARTIALLY"] = "PARTIALLY";
  MassFunctionality2["NO"] = "NO";
  return MassFunctionality2;
})(MassFunctionality || {});
var TranspasActivityStatus = /* @__PURE__ */ ((TranspasActivityStatus2) => {
  TranspasActivityStatus2[TranspasActivityStatus2["ASSET_RETURN"] = 10] = "ASSET_RETURN";
  TranspasActivityStatus2[TranspasActivityStatus2["EXTRA_GEAR"] = 14] = "EXTRA_GEAR";
  TranspasActivityStatus2[TranspasActivityStatus2["ON_LOCATION_COUPLING"] = 22] = "ON_LOCATION_COUPLING";
  TranspasActivityStatus2[TranspasActivityStatus2["COUPLING_DONE"] = 23] = "COUPLING_DONE";
  TranspasActivityStatus2[TranspasActivityStatus2["ON_LOCATION_DECOUPLING"] = 24] = "ON_LOCATION_DECOUPLING";
  TranspasActivityStatus2[TranspasActivityStatus2["DECOUPLING_DONE"] = 25] = "DECOUPLING_DONE";
  TranspasActivityStatus2[TranspasActivityStatus2["START_DRIVING"] = 26] = "START_DRIVING";
  TranspasActivityStatus2[TranspasActivityStatus2["ON_LOCATION_LOADING"] = 27] = "ON_LOCATION_LOADING";
  TranspasActivityStatus2[TranspasActivityStatus2["ON_LOCATION_UNLOADING"] = 27] = "ON_LOCATION_UNLOADING";
  TranspasActivityStatus2[TranspasActivityStatus2["LOADING_STARTED"] = 28] = "LOADING_STARTED";
  TranspasActivityStatus2[TranspasActivityStatus2["LOADED"] = 29] = "LOADED";
  TranspasActivityStatus2[TranspasActivityStatus2["LOADING_FINISHED"] = 30] = "LOADING_FINISHED";
  TranspasActivityStatus2[TranspasActivityStatus2["UNLOADING_STARTED"] = 31] = "UNLOADING_STARTED";
  TranspasActivityStatus2[TranspasActivityStatus2["UNLOADED"] = 32] = "UNLOADED";
  TranspasActivityStatus2[TranspasActivityStatus2["UNLOADING_FINISHED"] = 33] = "UNLOADING_FINISHED";
  TranspasActivityStatus2[TranspasActivityStatus2["ON_LOCATION_REST"] = 34] = "ON_LOCATION_REST";
  TranspasActivityStatus2[TranspasActivityStatus2["REST_DONE"] = 35] = "REST_DONE";
  TranspasActivityStatus2[TranspasActivityStatus2["ON_LOCATION_OTHER"] = 36] = "ON_LOCATION_OTHER";
  TranspasActivityStatus2[TranspasActivityStatus2["OTHER_ACTIVITY_DONE"] = 37] = "OTHER_ACTIVITY_DONE";
  TranspasActivityStatus2[TranspasActivityStatus2["WAITING_AUTOMATIC"] = 38] = "WAITING_AUTOMATIC";
  TranspasActivityStatus2[TranspasActivityStatus2["WAITING_MANUAL"] = 39] = "WAITING_MANUAL";
  return TranspasActivityStatus2;
})(TranspasActivityStatus || {});

// src/lib/queries/dw.ts
var updateLoadMetersQuery = `
DROP TEMPORARY TABLE IF EXISTS trips;
DROP TEMPORARY TABLE IF EXISTS tripActivities;


CREATE TEMPORARY TABLE trips ENGINE=MEMORY AS
(SELECT DISTINCT(tripId) FROM tripActivity 
	  WHERE tpTripActivityNr IN (:tpTripActivityNumbers));
		
CREATE TEMPORARY TABLE tripActivities ENGINE=MEMORY AS
(SELECT
	trips.tripId,
	tripActivity.id AS tripActivityId,
	tripActivity.salesOrderLegId, 
	tripActivity.stopId,
	tripActivity.communicationStatus, 
	tripActivity.sequence, 
	activityKind.activityCode,
	CASE 
	WHEN activityKind.activityCode = 'LOS' THEN -1
	WHEN activityKind.activityCode = 'LAD' THEN 1
	ELSE 0
	END AS loadingMeterFactor,
	ROUND(tripActivity.loadingMeter, 2) AS loadingMeter,
	CAST(0 AS DECIMAL(13,2)) AS cargoSpace1LoadingMeter,
  CAST(0 AS DECIMAL(13,2)) AS cargoSpace2LoadingMeter,
	CAST(tripActivity.cumulativeLoadMeter AS DECIMAL(13,2)) AS cumulativeLoadMeter, 
	CASE 
	WHEN (tripActivity.cargoSpace = 0 OR tripActivity.cargoSpace IS NULL) THEN 2
	WHEN tripActivity.cargoSpace = 1 THEN 1
	END AS cargoSpace,
	tripActivity.cargoSpace1CumulativeLoadMeter, 
	tripActivity.cargoSpace2CumulativeLoadMeter, 
	tripActivity.archived
FROM trips 
INNER JOIN tripActivity ON trips.tripId = tripActivity.tripId
INNER JOIN activityKind ON tripActivity.activityKindId = activityKind.id
WHERE
    (tripActivity.communicationStatus IS NULL OR tripActivity.communicationStatus NOT IN (50,70))
    AND tripActivity.archived = 0);
		
UPDATE tripActivities
LEFT JOIN
		(SELECT
			tripActivities.tripActivityId,
			salesOrderLeg.id AS salesOrderLegId, 
			ROUND(COALESCE(salesOrderCargo.loadingMeter,0) , 2) AS loadingMeter,
			IF(tripActivities.cargoSpace = 1, ROUND(COALESCE(salesOrderCargo.loadingMeter,0) , 2), 0.00) AS cargoSpace1LoadingMeter,
			IF(tripActivities.cargoSpace = 2, ROUND(COALESCE(salesOrderCargo.loadingMeter,0) , 2), 0.00) AS cargoSpace2LoadingMeter
		FROM
		tripActivities
		INNER JOIN salesOrderLeg ON tripActivities.salesOrderLegId = salesOrderLeg.id
		INNER JOIN salesOrderCargo ON salesOrderLeg.salesOrderCargoId = salesOrderCargo.id
		WHERE salesOrderLeg.archived = 0 AND salesOrderCargo.archived = 0) AS loadingMeters ON tripActivities.tripActivityId = loadingMeters.tripActivityId
SET
	tripActivities.loadingMeter = ROUND(COALESCE(loadingMeters.loadingMeter,0),2),
	tripActivities.cargoSpace1LoadingMeter = ROUND(COALESCE(loadingMeters.cargoSpace1LoadingMeter,0),2),
	tripActivities.cargoSpace2LoadingMeter = ROUND(COALESCE(loadingMeters.cargoSpace2LoadingMeter,0),2),
	tripActivities.cumulativeLoadMeter = 0.00,
	tripActivities.cargoSpace1CumulativeLoadMeter = 0.00,
	tripActivities.cargoSpace2CumulativeLoadMeter = 0.00;	

UPDATE tripActivities
JOIN
	(SELECT
	tripActivityId,
	ROUND(SUM(loadingMeter*loadingMeterFactor) OVER (PARTITION BY tripId ORDER BY sequence, tripActivityId ROWS UNBOUNDED PRECEDING), 2) AS cumulativeLoadMeter,
	ROUND(SUM(tripActivities.cargoSpace1LoadingMeter*loadingMeterFactor) OVER (PARTITION BY tripId ORDER BY sequence, tripActivityId ROWS UNBOUNDED PRECEDING), 2) AS cargoSpace1CumulativeLoadMeter,
	ROUND(SUM(tripActivities.cargoSpace2LoadingMeter*loadingMeterFactor) OVER (PARTITION BY tripId ORDER BY sequence, tripActivityId ROWS UNBOUNDED PRECEDING), 2) AS cargoSpace2CumulativeLoadMeter
	FROM tripActivities) AS cumLdm ON tripActivities.tripActivityId = cumLdm.tripActivityId
SET 
tripActivities.cumulativeLoadMeter = cumLdm.cumulativeLoadMeter,
tripActivities.cargoSpace1CumulativeLoadMeter = cumLdm.cargoSpace1CumulativeLoadMeter,
tripActivities.cargoSpace2CumulativeLoadMeter = cumLdm.cargoSpace2CumulativeLoadMeter
;

UPDATE tripActivity
JOIN tripActivities ON tripActivity.id = tripActivities.tripActivityId
SET
	tripActivity.loadingMeter = tripActivities.loadingMeter,
	tripActivity.cumulativeLoadMeter = tripActivities.cumulativeLoadMeter,
	tripActivity.cargoSpace1CumulativeLoadMeter = tripActivities.cargoSpace1CumulativeLoadMeter,
	tripActivity.cargoSpace2CumulativeLoadMeter = tripActivities.cargoSpace2CumulativeLoadMeter;

UPDATE stop
JOIN
	(SELECT
	stopData.stopId,
	stopData.maxSequence,
	CASE 
	WHEN cargo1 > 0 AND cargo2 > 0 THEN 3
	WHEN cargo1 > 0 AND cargo2 = 0 THEN 1
	ELSE 2
	END AS cargoSpace,
	stopData.loadingMeter,
	tripActivities.cumulativeLoadMeter,
	tripActivities.cargoSpace1CumulativeLoadMeter,
	tripActivities.cargoSpace2CumulativeLoadMeter
	FROM
	(SELECT
	stopId,
	MAX(sequence) AS maxSequence,
	SUM(IF(cargoSpace = 1, 1,0)) AS cargo1,
	SUM(IF(cargoSpace = 2, 1,0)) AS cargo2,
	SUM(loadingMeter) AS loadingMeter
	FROM tripActivities
	GROUP BY stopId) AS stopData
	INNER JOIN tripActivities ON stopData.stopId = tripActivities.stopId AND tripActivities.sequence = stopData.maxSequence) AS stopUpdates ON stop.id = stopUpdates.stopId
SET
stop.cargoSpace = stopUpdates.cargoSpace,
stop.loadingMeter = stopUpdates.loadingMeter,
stop.cumulativeLoadMeter = stopUpdates.cumulativeLoadMeter,
stop.cargoSpace1CumulativeLoadMeter = stopUpdates.cargoSpace1CumulativeLoadMeter,
stop.cargoSpace2CumulativeLoadMeter = stopUpdates.cargoSpace2CumulativeLoadMeter
;`;

// ../../node_modules/.pnpm/zod@3.25.76/node_modules/zod/index.js
var zod_exports = {};
__export(zod_exports, {
  BRAND: () => BRAND,
  DIRTY: () => DIRTY,
  EMPTY_PATH: () => EMPTY_PATH,
  INVALID: () => INVALID,
  NEVER: () => NEVER,
  OK: () => OK,
  ParseStatus: () => ParseStatus,
  Schema: () => ZodType,
  ZodAny: () => ZodAny,
  ZodArray: () => ZodArray,
  ZodBigInt: () => ZodBigInt,
  ZodBoolean: () => ZodBoolean,
  ZodBranded: () => ZodBranded,
  ZodCatch: () => ZodCatch,
  ZodDate: () => ZodDate,
  ZodDefault: () => ZodDefault,
  ZodDiscriminatedUnion: () => ZodDiscriminatedUnion,
  ZodEffects: () => ZodEffects,
  ZodEnum: () => ZodEnum,
  ZodError: () => ZodError,
  ZodFirstPartyTypeKind: () => ZodFirstPartyTypeKind,
  ZodFunction: () => ZodFunction,
  ZodIntersection: () => ZodIntersection,
  ZodIssueCode: () => ZodIssueCode,
  ZodLazy: () => ZodLazy,
  ZodLiteral: () => ZodLiteral,
  ZodMap: () => ZodMap,
  ZodNaN: () => ZodNaN,
  ZodNativeEnum: () => ZodNativeEnum,
  ZodNever: () => ZodNever,
  ZodNull: () => ZodNull,
  ZodNullable: () => ZodNullable,
  ZodNumber: () => ZodNumber,
  ZodObject: () => ZodObject,
  ZodOptional: () => ZodOptional,
  ZodParsedType: () => ZodParsedType,
  ZodPipeline: () => ZodPipeline,
  ZodPromise: () => ZodPromise,
  ZodReadonly: () => ZodReadonly,
  ZodRecord: () => ZodRecord,
  ZodSchema: () => ZodType,
  ZodSet: () => ZodSet,
  ZodString: () => ZodString,
  ZodSymbol: () => ZodSymbol,
  ZodTransformer: () => ZodEffects,
  ZodTuple: () => ZodTuple,
  ZodType: () => ZodType,
  ZodUndefined: () => ZodUndefined,
  ZodUnion: () => ZodUnion,
  ZodUnknown: () => ZodUnknown,
  ZodVoid: () => ZodVoid,
  addIssueToContext: () => addIssueToContext,
  any: () => anyType,
  array: () => arrayType,
  bigint: () => bigIntType,
  boolean: () => booleanType,
  coerce: () => coerce,
  custom: () => custom,
  date: () => dateType,
  datetimeRegex: () => datetimeRegex,
  default: () => zod_default,
  defaultErrorMap: () => en_default,
  discriminatedUnion: () => discriminatedUnionType,
  effect: () => effectsType,
  enum: () => enumType,
  function: () => functionType,
  getErrorMap: () => getErrorMap,
  getParsedType: () => getParsedType,
  instanceof: () => instanceOfType,
  intersection: () => intersectionType,
  isAborted: () => isAborted,
  isAsync: () => isAsync,
  isDirty: () => isDirty,
  isValid: () => isValid,
  late: () => late,
  lazy: () => lazyType,
  literal: () => literalType,
  makeIssue: () => makeIssue,
  map: () => mapType,
  nan: () => nanType,
  nativeEnum: () => nativeEnumType,
  never: () => neverType,
  null: () => nullType,
  nullable: () => nullableType,
  number: () => numberType,
  object: () => objectType,
  objectUtil: () => objectUtil,
  oboolean: () => oboolean,
  onumber: () => onumber,
  optional: () => optionalType,
  ostring: () => ostring,
  pipeline: () => pipelineType,
  preprocess: () => preprocessType,
  promise: () => promiseType,
  quotelessJson: () => quotelessJson,
  record: () => recordType,
  set: () => setType,
  setErrorMap: () => setErrorMap,
  strictObject: () => strictObjectType,
  string: () => stringType,
  symbol: () => symbolType,
  transformer: () => effectsType,
  tuple: () => tupleType,
  undefined: () => undefinedType,
  union: () => unionType,
  unknown: () => unknownType,
  util: () => util,
  void: () => voidType,
  z: () => external_exports
});

// ../../node_modules/.pnpm/zod@3.25.76/node_modules/zod/v3/external.js
var external_exports = {};
__export(external_exports, {
  BRAND: () => BRAND,
  DIRTY: () => DIRTY,
  EMPTY_PATH: () => EMPTY_PATH,
  INVALID: () => INVALID,
  NEVER: () => NEVER,
  OK: () => OK,
  ParseStatus: () => ParseStatus,
  Schema: () => ZodType,
  ZodAny: () => ZodAny,
  ZodArray: () => ZodArray,
  ZodBigInt: () => ZodBigInt,
  ZodBoolean: () => ZodBoolean,
  ZodBranded: () => ZodBranded,
  ZodCatch: () => ZodCatch,
  ZodDate: () => ZodDate,
  ZodDefault: () => ZodDefault,
  ZodDiscriminatedUnion: () => ZodDiscriminatedUnion,
  ZodEffects: () => ZodEffects,
  ZodEnum: () => ZodEnum,
  ZodError: () => ZodError,
  ZodFirstPartyTypeKind: () => ZodFirstPartyTypeKind,
  ZodFunction: () => ZodFunction,
  ZodIntersection: () => ZodIntersection,
  ZodIssueCode: () => ZodIssueCode,
  ZodLazy: () => ZodLazy,
  ZodLiteral: () => ZodLiteral,
  ZodMap: () => ZodMap,
  ZodNaN: () => ZodNaN,
  ZodNativeEnum: () => ZodNativeEnum,
  ZodNever: () => ZodNever,
  ZodNull: () => ZodNull,
  ZodNullable: () => ZodNullable,
  ZodNumber: () => ZodNumber,
  ZodObject: () => ZodObject,
  ZodOptional: () => ZodOptional,
  ZodParsedType: () => ZodParsedType,
  ZodPipeline: () => ZodPipeline,
  ZodPromise: () => ZodPromise,
  ZodReadonly: () => ZodReadonly,
  ZodRecord: () => ZodRecord,
  ZodSchema: () => ZodType,
  ZodSet: () => ZodSet,
  ZodString: () => ZodString,
  ZodSymbol: () => ZodSymbol,
  ZodTransformer: () => ZodEffects,
  ZodTuple: () => ZodTuple,
  ZodType: () => ZodType,
  ZodUndefined: () => ZodUndefined,
  ZodUnion: () => ZodUnion,
  ZodUnknown: () => ZodUnknown,
  ZodVoid: () => ZodVoid,
  addIssueToContext: () => addIssueToContext,
  any: () => anyType,
  array: () => arrayType,
  bigint: () => bigIntType,
  boolean: () => booleanType,
  coerce: () => coerce,
  custom: () => custom,
  date: () => dateType,
  datetimeRegex: () => datetimeRegex,
  defaultErrorMap: () => en_default,
  discriminatedUnion: () => discriminatedUnionType,
  effect: () => effectsType,
  enum: () => enumType,
  function: () => functionType,
  getErrorMap: () => getErrorMap,
  getParsedType: () => getParsedType,
  instanceof: () => instanceOfType,
  intersection: () => intersectionType,
  isAborted: () => isAborted,
  isAsync: () => isAsync,
  isDirty: () => isDirty,
  isValid: () => isValid,
  late: () => late,
  lazy: () => lazyType,
  literal: () => literalType,
  makeIssue: () => makeIssue,
  map: () => mapType,
  nan: () => nanType,
  nativeEnum: () => nativeEnumType,
  never: () => neverType,
  null: () => nullType,
  nullable: () => nullableType,
  number: () => numberType,
  object: () => objectType,
  objectUtil: () => objectUtil,
  oboolean: () => oboolean,
  onumber: () => onumber,
  optional: () => optionalType,
  ostring: () => ostring,
  pipeline: () => pipelineType,
  preprocess: () => preprocessType,
  promise: () => promiseType,
  quotelessJson: () => quotelessJson,
  record: () => recordType,
  set: () => setType,
  setErrorMap: () => setErrorMap,
  strictObject: () => strictObjectType,
  string: () => stringType,
  symbol: () => symbolType,
  transformer: () => effectsType,
  tuple: () => tupleType,
  undefined: () => undefinedType,
  union: () => unionType,
  unknown: () => unknownType,
  util: () => util,
  void: () => voidType
});

// ../../node_modules/.pnpm/zod@3.25.76/node_modules/zod/v3/helpers/util.js
var util;
(function(util2) {
  util2.assertEqual = (_) => {
  };
  function assertIs(_arg) {
  }
  util2.assertIs = assertIs;
  function assertNever(_x) {
    throw new Error();
  }
  util2.assertNever = assertNever;
  util2.arrayToEnum = (items) => {
    const obj = {};
    for (const item of items) {
      obj[item] = item;
    }
    return obj;
  };
  util2.getValidEnumValues = (obj) => {
    const validKeys = util2.objectKeys(obj).filter((k) => typeof obj[obj[k]] !== "number");
    const filtered = {};
    for (const k of validKeys) {
      filtered[k] = obj[k];
    }
    return util2.objectValues(filtered);
  };
  util2.objectValues = (obj) => {
    return util2.objectKeys(obj).map(function(e) {
      return obj[e];
    });
  };
  util2.objectKeys = typeof Object.keys === "function" ? (obj) => Object.keys(obj) : (object) => {
    const keys = [];
    for (const key in object) {
      if (Object.prototype.hasOwnProperty.call(object, key)) {
        keys.push(key);
      }
    }
    return keys;
  };
  util2.find = (arr, checker) => {
    for (const item of arr) {
      if (checker(item))
        return item;
    }
    return void 0;
  };
  util2.isInteger = typeof Number.isInteger === "function" ? (val) => Number.isInteger(val) : (val) => typeof val === "number" && Number.isFinite(val) && Math.floor(val) === val;
  function joinValues(array, separator = " | ") {
    return array.map((val) => typeof val === "string" ? `'${val}'` : val).join(separator);
  }
  util2.joinValues = joinValues;
  util2.jsonStringifyReplacer = (_, value) => {
    if (typeof value === "bigint") {
      return value.toString();
    }
    return value;
  };
})(util || (util = {}));
var objectUtil;
(function(objectUtil2) {
  objectUtil2.mergeShapes = (first, second) => {
    return {
      ...first,
      ...second
      // second overwrites first
    };
  };
})(objectUtil || (objectUtil = {}));
var ZodParsedType = util.arrayToEnum([
  "string",
  "nan",
  "number",
  "integer",
  "float",
  "boolean",
  "date",
  "bigint",
  "symbol",
  "function",
  "undefined",
  "null",
  "array",
  "object",
  "unknown",
  "promise",
  "void",
  "never",
  "map",
  "set"
]);
var getParsedType = (data) => {
  const t = typeof data;
  switch (t) {
    case "undefined":
      return ZodParsedType.undefined;
    case "string":
      return ZodParsedType.string;
    case "number":
      return Number.isNaN(data) ? ZodParsedType.nan : ZodParsedType.number;
    case "boolean":
      return ZodParsedType.boolean;
    case "function":
      return ZodParsedType.function;
    case "bigint":
      return ZodParsedType.bigint;
    case "symbol":
      return ZodParsedType.symbol;
    case "object":
      if (Array.isArray(data)) {
        return ZodParsedType.array;
      }
      if (data === null) {
        return ZodParsedType.null;
      }
      if (data.then && typeof data.then === "function" && data.catch && typeof data.catch === "function") {
        return ZodParsedType.promise;
      }
      if (typeof Map !== "undefined" && data instanceof Map) {
        return ZodParsedType.map;
      }
      if (typeof Set !== "undefined" && data instanceof Set) {
        return ZodParsedType.set;
      }
      if (typeof Date !== "undefined" && data instanceof Date) {
        return ZodParsedType.date;
      }
      return ZodParsedType.object;
    default:
      return ZodParsedType.unknown;
  }
};

// ../../node_modules/.pnpm/zod@3.25.76/node_modules/zod/v3/ZodError.js
var ZodIssueCode = util.arrayToEnum([
  "invalid_type",
  "invalid_literal",
  "custom",
  "invalid_union",
  "invalid_union_discriminator",
  "invalid_enum_value",
  "unrecognized_keys",
  "invalid_arguments",
  "invalid_return_type",
  "invalid_date",
  "invalid_string",
  "too_small",
  "too_big",
  "invalid_intersection_types",
  "not_multiple_of",
  "not_finite"
]);
var quotelessJson = (obj) => {
  const json = JSON.stringify(obj, null, 2);
  return json.replace(/"([^"]+)":/g, "$1:");
};
var ZodError = class _ZodError extends Error {
  get errors() {
    return this.issues;
  }
  constructor(issues) {
    super();
    this.issues = [];
    this.addIssue = (sub) => {
      this.issues = [...this.issues, sub];
    };
    this.addIssues = (subs = []) => {
      this.issues = [...this.issues, ...subs];
    };
    const actualProto = new.target.prototype;
    if (Object.setPrototypeOf) {
      Object.setPrototypeOf(this, actualProto);
    } else {
      this.__proto__ = actualProto;
    }
    this.name = "ZodError";
    this.issues = issues;
  }
  format(_mapper) {
    const mapper = _mapper || function(issue) {
      return issue.message;
    };
    const fieldErrors = { _errors: [] };
    const processError = (error) => {
      for (const issue of error.issues) {
        if (issue.code === "invalid_union") {
          issue.unionErrors.map(processError);
        } else if (issue.code === "invalid_return_type") {
          processError(issue.returnTypeError);
        } else if (issue.code === "invalid_arguments") {
          processError(issue.argumentsError);
        } else if (issue.path.length === 0) {
          fieldErrors._errors.push(mapper(issue));
        } else {
          let curr = fieldErrors;
          let i = 0;
          while (i < issue.path.length) {
            const el = issue.path[i];
            const terminal = i === issue.path.length - 1;
            if (!terminal) {
              curr[el] = curr[el] || { _errors: [] };
            } else {
              curr[el] = curr[el] || { _errors: [] };
              curr[el]._errors.push(mapper(issue));
            }
            curr = curr[el];
            i++;
          }
        }
      }
    };
    processError(this);
    return fieldErrors;
  }
  static assert(value) {
    if (!(value instanceof _ZodError)) {
      throw new Error(`Not a ZodError: ${value}`);
    }
  }
  toString() {
    return this.message;
  }
  get message() {
    return JSON.stringify(this.issues, util.jsonStringifyReplacer, 2);
  }
  get isEmpty() {
    return this.issues.length === 0;
  }
  flatten(mapper = (issue) => issue.message) {
    const fieldErrors = {};
    const formErrors = [];
    for (const sub of this.issues) {
      if (sub.path.length > 0) {
        const firstEl = sub.path[0];
        fieldErrors[firstEl] = fieldErrors[firstEl] || [];
        fieldErrors[firstEl].push(mapper(sub));
      } else {
        formErrors.push(mapper(sub));
      }
    }
    return { formErrors, fieldErrors };
  }
  get formErrors() {
    return this.flatten();
  }
};
ZodError.create = (issues) => {
  const error = new ZodError(issues);
  return error;
};

// ../../node_modules/.pnpm/zod@3.25.76/node_modules/zod/v3/locales/en.js
var errorMap = (issue, _ctx) => {
  let message;
  switch (issue.code) {
    case ZodIssueCode.invalid_type:
      if (issue.received === ZodParsedType.undefined) {
        message = "Required";
      } else {
        message = `Expected ${issue.expected}, received ${issue.received}`;
      }
      break;
    case ZodIssueCode.invalid_literal:
      message = `Invalid literal value, expected ${JSON.stringify(issue.expected, util.jsonStringifyReplacer)}`;
      break;
    case ZodIssueCode.unrecognized_keys:
      message = `Unrecognized key(s) in object: ${util.joinValues(issue.keys, ", ")}`;
      break;
    case ZodIssueCode.invalid_union:
      message = `Invalid input`;
      break;
    case ZodIssueCode.invalid_union_discriminator:
      message = `Invalid discriminator value. Expected ${util.joinValues(issue.options)}`;
      break;
    case ZodIssueCode.invalid_enum_value:
      message = `Invalid enum value. Expected ${util.joinValues(issue.options)}, received '${issue.received}'`;
      break;
    case ZodIssueCode.invalid_arguments:
      message = `Invalid function arguments`;
      break;
    case ZodIssueCode.invalid_return_type:
      message = `Invalid function return type`;
      break;
    case ZodIssueCode.invalid_date:
      message = `Invalid date`;
      break;
    case ZodIssueCode.invalid_string:
      if (typeof issue.validation === "object") {
        if ("includes" in issue.validation) {
          message = `Invalid input: must include "${issue.validation.includes}"`;
          if (typeof issue.validation.position === "number") {
            message = `${message} at one or more positions greater than or equal to ${issue.validation.position}`;
          }
        } else if ("startsWith" in issue.validation) {
          message = `Invalid input: must start with "${issue.validation.startsWith}"`;
        } else if ("endsWith" in issue.validation) {
          message = `Invalid input: must end with "${issue.validation.endsWith}"`;
        } else {
          util.assertNever(issue.validation);
        }
      } else if (issue.validation !== "regex") {
        message = `Invalid ${issue.validation}`;
      } else {
        message = "Invalid";
      }
      break;
    case ZodIssueCode.too_small:
      if (issue.type === "array")
        message = `Array must contain ${issue.exact ? "exactly" : issue.inclusive ? `at least` : `more than`} ${issue.minimum} element(s)`;
      else if (issue.type === "string")
        message = `String must contain ${issue.exact ? "exactly" : issue.inclusive ? `at least` : `over`} ${issue.minimum} character(s)`;
      else if (issue.type === "number")
        message = `Number must be ${issue.exact ? `exactly equal to ` : issue.inclusive ? `greater than or equal to ` : `greater than `}${issue.minimum}`;
      else if (issue.type === "bigint")
        message = `Number must be ${issue.exact ? `exactly equal to ` : issue.inclusive ? `greater than or equal to ` : `greater than `}${issue.minimum}`;
      else if (issue.type === "date")
        message = `Date must be ${issue.exact ? `exactly equal to ` : issue.inclusive ? `greater than or equal to ` : `greater than `}${new Date(Number(issue.minimum))}`;
      else
        message = "Invalid input";
      break;
    case ZodIssueCode.too_big:
      if (issue.type === "array")
        message = `Array must contain ${issue.exact ? `exactly` : issue.inclusive ? `at most` : `less than`} ${issue.maximum} element(s)`;
      else if (issue.type === "string")
        message = `String must contain ${issue.exact ? `exactly` : issue.inclusive ? `at most` : `under`} ${issue.maximum} character(s)`;
      else if (issue.type === "number")
        message = `Number must be ${issue.exact ? `exactly` : issue.inclusive ? `less than or equal to` : `less than`} ${issue.maximum}`;
      else if (issue.type === "bigint")
        message = `BigInt must be ${issue.exact ? `exactly` : issue.inclusive ? `less than or equal to` : `less than`} ${issue.maximum}`;
      else if (issue.type === "date")
        message = `Date must be ${issue.exact ? `exactly` : issue.inclusive ? `smaller than or equal to` : `smaller than`} ${new Date(Number(issue.maximum))}`;
      else
        message = "Invalid input";
      break;
    case ZodIssueCode.custom:
      message = `Invalid input`;
      break;
    case ZodIssueCode.invalid_intersection_types:
      message = `Intersection results could not be merged`;
      break;
    case ZodIssueCode.not_multiple_of:
      message = `Number must be a multiple of ${issue.multipleOf}`;
      break;
    case ZodIssueCode.not_finite:
      message = "Number must be finite";
      break;
    default:
      message = _ctx.defaultError;
      util.assertNever(issue);
  }
  return { message };
};
var en_default = errorMap;

// ../../node_modules/.pnpm/zod@3.25.76/node_modules/zod/v3/errors.js
var overrideErrorMap = en_default;
function setErrorMap(map) {
  overrideErrorMap = map;
}
function getErrorMap() {
  return overrideErrorMap;
}

// ../../node_modules/.pnpm/zod@3.25.76/node_modules/zod/v3/helpers/parseUtil.js
var makeIssue = (params) => {
  const { data, path, errorMaps, issueData } = params;
  const fullPath = [...path, ...issueData.path || []];
  const fullIssue = {
    ...issueData,
    path: fullPath
  };
  if (issueData.message !== void 0) {
    return {
      ...issueData,
      path: fullPath,
      message: issueData.message
    };
  }
  let errorMessage = "";
  const maps = errorMaps.filter((m) => !!m).slice().reverse();
  for (const map of maps) {
    errorMessage = map(fullIssue, { data, defaultError: errorMessage }).message;
  }
  return {
    ...issueData,
    path: fullPath,
    message: errorMessage
  };
};
var EMPTY_PATH = [];
function addIssueToContext(ctx, issueData) {
  const overrideMap = getErrorMap();
  const issue = makeIssue({
    issueData,
    data: ctx.data,
    path: ctx.path,
    errorMaps: [
      ctx.common.contextualErrorMap,
      // contextual error map is first priority
      ctx.schemaErrorMap,
      // then schema-bound map if available
      overrideMap,
      // then global override map
      overrideMap === en_default ? void 0 : en_default
      // then global default map
    ].filter((x) => !!x)
  });
  ctx.common.issues.push(issue);
}
var ParseStatus = class _ParseStatus {
  constructor() {
    this.value = "valid";
  }
  dirty() {
    if (this.value === "valid")
      this.value = "dirty";
  }
  abort() {
    if (this.value !== "aborted")
      this.value = "aborted";
  }
  static mergeArray(status, results) {
    const arrayValue = [];
    for (const s of results) {
      if (s.status === "aborted")
        return INVALID;
      if (s.status === "dirty")
        status.dirty();
      arrayValue.push(s.value);
    }
    return { status: status.value, value: arrayValue };
  }
  static async mergeObjectAsync(status, pairs) {
    const syncPairs = [];
    for (const pair of pairs) {
      const key = await pair.key;
      const value = await pair.value;
      syncPairs.push({
        key,
        value
      });
    }
    return _ParseStatus.mergeObjectSync(status, syncPairs);
  }
  static mergeObjectSync(status, pairs) {
    const finalObject = {};
    for (const pair of pairs) {
      const { key, value } = pair;
      if (key.status === "aborted")
        return INVALID;
      if (value.status === "aborted")
        return INVALID;
      if (key.status === "dirty")
        status.dirty();
      if (value.status === "dirty")
        status.dirty();
      if (key.value !== "__proto__" && (typeof value.value !== "undefined" || pair.alwaysSet)) {
        finalObject[key.value] = value.value;
      }
    }
    return { status: status.value, value: finalObject };
  }
};
var INVALID = Object.freeze({
  status: "aborted"
});
var DIRTY = (value) => ({ status: "dirty", value });
var OK = (value) => ({ status: "valid", value });
var isAborted = (x) => x.status === "aborted";
var isDirty = (x) => x.status === "dirty";
var isValid = (x) => x.status === "valid";
var isAsync = (x) => typeof Promise !== "undefined" && x instanceof Promise;

// ../../node_modules/.pnpm/zod@3.25.76/node_modules/zod/v3/helpers/errorUtil.js
var errorUtil;
(function(errorUtil2) {
  errorUtil2.errToObj = (message) => typeof message === "string" ? { message } : message || {};
  errorUtil2.toString = (message) => typeof message === "string" ? message : message?.message;
})(errorUtil || (errorUtil = {}));

// ../../node_modules/.pnpm/zod@3.25.76/node_modules/zod/v3/types.js
var ParseInputLazyPath = class {
  constructor(parent, value, path, key) {
    this._cachedPath = [];
    this.parent = parent;
    this.data = value;
    this._path = path;
    this._key = key;
  }
  get path() {
    if (!this._cachedPath.length) {
      if (Array.isArray(this._key)) {
        this._cachedPath.push(...this._path, ...this._key);
      } else {
        this._cachedPath.push(...this._path, this._key);
      }
    }
    return this._cachedPath;
  }
};
var handleResult = (ctx, result) => {
  if (isValid(result)) {
    return { success: true, data: result.value };
  } else {
    if (!ctx.common.issues.length) {
      throw new Error("Validation failed but no issues detected.");
    }
    return {
      success: false,
      get error() {
        if (this._error)
          return this._error;
        const error = new ZodError(ctx.common.issues);
        this._error = error;
        return this._error;
      }
    };
  }
};
function processCreateParams(params) {
  if (!params)
    return {};
  const { errorMap: errorMap2, invalid_type_error, required_error, description } = params;
  if (errorMap2 && (invalid_type_error || required_error)) {
    throw new Error(`Can't use "invalid_type_error" or "required_error" in conjunction with custom error map.`);
  }
  if (errorMap2)
    return { errorMap: errorMap2, description };
  const customMap = (iss, ctx) => {
    const { message } = params;
    if (iss.code === "invalid_enum_value") {
      return { message: message ?? ctx.defaultError };
    }
    if (typeof ctx.data === "undefined") {
      return { message: message ?? required_error ?? ctx.defaultError };
    }
    if (iss.code !== "invalid_type")
      return { message: ctx.defaultError };
    return { message: message ?? invalid_type_error ?? ctx.defaultError };
  };
  return { errorMap: customMap, description };
}
var ZodType = class {
  get description() {
    return this._def.description;
  }
  _getType(input) {
    return getParsedType(input.data);
  }
  _getOrReturnCtx(input, ctx) {
    return ctx || {
      common: input.parent.common,
      data: input.data,
      parsedType: getParsedType(input.data),
      schemaErrorMap: this._def.errorMap,
      path: input.path,
      parent: input.parent
    };
  }
  _processInputParams(input) {
    return {
      status: new ParseStatus(),
      ctx: {
        common: input.parent.common,
        data: input.data,
        parsedType: getParsedType(input.data),
        schemaErrorMap: this._def.errorMap,
        path: input.path,
        parent: input.parent
      }
    };
  }
  _parseSync(input) {
    const result = this._parse(input);
    if (isAsync(result)) {
      throw new Error("Synchronous parse encountered promise.");
    }
    return result;
  }
  _parseAsync(input) {
    const result = this._parse(input);
    return Promise.resolve(result);
  }
  parse(data, params) {
    const result = this.safeParse(data, params);
    if (result.success)
      return result.data;
    throw result.error;
  }
  safeParse(data, params) {
    const ctx = {
      common: {
        issues: [],
        async: params?.async ?? false,
        contextualErrorMap: params?.errorMap
      },
      path: params?.path || [],
      schemaErrorMap: this._def.errorMap,
      parent: null,
      data,
      parsedType: getParsedType(data)
    };
    const result = this._parseSync({ data, path: ctx.path, parent: ctx });
    return handleResult(ctx, result);
  }
  "~validate"(data) {
    const ctx = {
      common: {
        issues: [],
        async: !!this["~standard"].async
      },
      path: [],
      schemaErrorMap: this._def.errorMap,
      parent: null,
      data,
      parsedType: getParsedType(data)
    };
    if (!this["~standard"].async) {
      try {
        const result = this._parseSync({ data, path: [], parent: ctx });
        return isValid(result) ? {
          value: result.value
        } : {
          issues: ctx.common.issues
        };
      } catch (err) {
        if (err?.message?.toLowerCase()?.includes("encountered")) {
          this["~standard"].async = true;
        }
        ctx.common = {
          issues: [],
          async: true
        };
      }
    }
    return this._parseAsync({ data, path: [], parent: ctx }).then((result) => isValid(result) ? {
      value: result.value
    } : {
      issues: ctx.common.issues
    });
  }
  async parseAsync(data, params) {
    const result = await this.safeParseAsync(data, params);
    if (result.success)
      return result.data;
    throw result.error;
  }
  async safeParseAsync(data, params) {
    const ctx = {
      common: {
        issues: [],
        contextualErrorMap: params?.errorMap,
        async: true
      },
      path: params?.path || [],
      schemaErrorMap: this._def.errorMap,
      parent: null,
      data,
      parsedType: getParsedType(data)
    };
    const maybeAsyncResult = this._parse({ data, path: ctx.path, parent: ctx });
    const result = await (isAsync(maybeAsyncResult) ? maybeAsyncResult : Promise.resolve(maybeAsyncResult));
    return handleResult(ctx, result);
  }
  refine(check, message) {
    const getIssueProperties = (val) => {
      if (typeof message === "string" || typeof message === "undefined") {
        return { message };
      } else if (typeof message === "function") {
        return message(val);
      } else {
        return message;
      }
    };
    return this._refinement((val, ctx) => {
      const result = check(val);
      const setError = () => ctx.addIssue({
        code: ZodIssueCode.custom,
        ...getIssueProperties(val)
      });
      if (typeof Promise !== "undefined" && result instanceof Promise) {
        return result.then((data) => {
          if (!data) {
            setError();
            return false;
          } else {
            return true;
          }
        });
      }
      if (!result) {
        setError();
        return false;
      } else {
        return true;
      }
    });
  }
  refinement(check, refinementData) {
    return this._refinement((val, ctx) => {
      if (!check(val)) {
        ctx.addIssue(typeof refinementData === "function" ? refinementData(val, ctx) : refinementData);
        return false;
      } else {
        return true;
      }
    });
  }
  _refinement(refinement) {
    return new ZodEffects({
      schema: this,
      typeName: ZodFirstPartyTypeKind.ZodEffects,
      effect: { type: "refinement", refinement }
    });
  }
  superRefine(refinement) {
    return this._refinement(refinement);
  }
  constructor(def) {
    this.spa = this.safeParseAsync;
    this._def = def;
    this.parse = this.parse.bind(this);
    this.safeParse = this.safeParse.bind(this);
    this.parseAsync = this.parseAsync.bind(this);
    this.safeParseAsync = this.safeParseAsync.bind(this);
    this.spa = this.spa.bind(this);
    this.refine = this.refine.bind(this);
    this.refinement = this.refinement.bind(this);
    this.superRefine = this.superRefine.bind(this);
    this.optional = this.optional.bind(this);
    this.nullable = this.nullable.bind(this);
    this.nullish = this.nullish.bind(this);
    this.array = this.array.bind(this);
    this.promise = this.promise.bind(this);
    this.or = this.or.bind(this);
    this.and = this.and.bind(this);
    this.transform = this.transform.bind(this);
    this.brand = this.brand.bind(this);
    this.default = this.default.bind(this);
    this.catch = this.catch.bind(this);
    this.describe = this.describe.bind(this);
    this.pipe = this.pipe.bind(this);
    this.readonly = this.readonly.bind(this);
    this.isNullable = this.isNullable.bind(this);
    this.isOptional = this.isOptional.bind(this);
    this["~standard"] = {
      version: 1,
      vendor: "zod",
      validate: (data) => this["~validate"](data)
    };
  }
  optional() {
    return ZodOptional.create(this, this._def);
  }
  nullable() {
    return ZodNullable.create(this, this._def);
  }
  nullish() {
    return this.nullable().optional();
  }
  array() {
    return ZodArray.create(this);
  }
  promise() {
    return ZodPromise.create(this, this._def);
  }
  or(option) {
    return ZodUnion.create([this, option], this._def);
  }
  and(incoming) {
    return ZodIntersection.create(this, incoming, this._def);
  }
  transform(transform) {
    return new ZodEffects({
      ...processCreateParams(this._def),
      schema: this,
      typeName: ZodFirstPartyTypeKind.ZodEffects,
      effect: { type: "transform", transform }
    });
  }
  default(def) {
    const defaultValueFunc = typeof def === "function" ? def : () => def;
    return new ZodDefault({
      ...processCreateParams(this._def),
      innerType: this,
      defaultValue: defaultValueFunc,
      typeName: ZodFirstPartyTypeKind.ZodDefault
    });
  }
  brand() {
    return new ZodBranded({
      typeName: ZodFirstPartyTypeKind.ZodBranded,
      type: this,
      ...processCreateParams(this._def)
    });
  }
  catch(def) {
    const catchValueFunc = typeof def === "function" ? def : () => def;
    return new ZodCatch({
      ...processCreateParams(this._def),
      innerType: this,
      catchValue: catchValueFunc,
      typeName: ZodFirstPartyTypeKind.ZodCatch
    });
  }
  describe(description) {
    const This = this.constructor;
    return new This({
      ...this._def,
      description
    });
  }
  pipe(target) {
    return ZodPipeline.create(this, target);
  }
  readonly() {
    return ZodReadonly.create(this);
  }
  isOptional() {
    return this.safeParse(void 0).success;
  }
  isNullable() {
    return this.safeParse(null).success;
  }
};
var cuidRegex = /^c[^\s-]{8,}$/i;
var cuid2Regex = /^[0-9a-z]+$/;
var ulidRegex = /^[0-9A-HJKMNP-TV-Z]{26}$/i;
var uuidRegex = /^[0-9a-fA-F]{8}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{12}$/i;
var nanoidRegex = /^[a-z0-9_-]{21}$/i;
var jwtRegex = /^[A-Za-z0-9-_]+\.[A-Za-z0-9-_]+\.[A-Za-z0-9-_]*$/;
var durationRegex = /^[-+]?P(?!$)(?:(?:[-+]?\d+Y)|(?:[-+]?\d+[.,]\d+Y$))?(?:(?:[-+]?\d+M)|(?:[-+]?\d+[.,]\d+M$))?(?:(?:[-+]?\d+W)|(?:[-+]?\d+[.,]\d+W$))?(?:(?:[-+]?\d+D)|(?:[-+]?\d+[.,]\d+D$))?(?:T(?=[\d+-])(?:(?:[-+]?\d+H)|(?:[-+]?\d+[.,]\d+H$))?(?:(?:[-+]?\d+M)|(?:[-+]?\d+[.,]\d+M$))?(?:[-+]?\d+(?:[.,]\d+)?S)?)??$/;
var emailRegex = /^(?!\.)(?!.*\.\.)([A-Z0-9_'+\-\.]*)[A-Z0-9_+-]@([A-Z0-9][A-Z0-9\-]*\.)+[A-Z]{2,}$/i;
var _emojiRegex = `^(\\p{Extended_Pictographic}|\\p{Emoji_Component})+$`;
var emojiRegex;
var ipv4Regex = /^(?:(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])$/;
var ipv4CidrRegex = /^(?:(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\/(3[0-2]|[12]?[0-9])$/;
var ipv6Regex = /^(([0-9a-fA-F]{1,4}:){7,7}[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,7}:|([0-9a-fA-F]{1,4}:){1,6}:[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,5}(:[0-9a-fA-F]{1,4}){1,2}|([0-9a-fA-F]{1,4}:){1,4}(:[0-9a-fA-F]{1,4}){1,3}|([0-9a-fA-F]{1,4}:){1,3}(:[0-9a-fA-F]{1,4}){1,4}|([0-9a-fA-F]{1,4}:){1,2}(:[0-9a-fA-F]{1,4}){1,5}|[0-9a-fA-F]{1,4}:((:[0-9a-fA-F]{1,4}){1,6})|:((:[0-9a-fA-F]{1,4}){1,7}|:)|fe80:(:[0-9a-fA-F]{0,4}){0,4}%[0-9a-zA-Z]{1,}|::(ffff(:0{1,4}){0,1}:){0,1}((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])|([0-9a-fA-F]{1,4}:){1,4}:((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9]))$/;
var ipv6CidrRegex = /^(([0-9a-fA-F]{1,4}:){7,7}[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,7}:|([0-9a-fA-F]{1,4}:){1,6}:[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,5}(:[0-9a-fA-F]{1,4}){1,2}|([0-9a-fA-F]{1,4}:){1,4}(:[0-9a-fA-F]{1,4}){1,3}|([0-9a-fA-F]{1,4}:){1,3}(:[0-9a-fA-F]{1,4}){1,4}|([0-9a-fA-F]{1,4}:){1,2}(:[0-9a-fA-F]{1,4}){1,5}|[0-9a-fA-F]{1,4}:((:[0-9a-fA-F]{1,4}){1,6})|:((:[0-9a-fA-F]{1,4}){1,7}|:)|fe80:(:[0-9a-fA-F]{0,4}){0,4}%[0-9a-zA-Z]{1,}|::(ffff(:0{1,4}){0,1}:){0,1}((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])|([0-9a-fA-F]{1,4}:){1,4}:((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9]))\/(12[0-8]|1[01][0-9]|[1-9]?[0-9])$/;
var base64Regex = /^([0-9a-zA-Z+/]{4})*(([0-9a-zA-Z+/]{2}==)|([0-9a-zA-Z+/]{3}=))?$/;
var base64urlRegex = /^([0-9a-zA-Z-_]{4})*(([0-9a-zA-Z-_]{2}(==)?)|([0-9a-zA-Z-_]{3}(=)?))?$/;
var dateRegexSource = `((\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-((0[13578]|1[02])-(0[1-9]|[12]\\d|3[01])|(0[469]|11)-(0[1-9]|[12]\\d|30)|(02)-(0[1-9]|1\\d|2[0-8])))`;
var dateRegex = new RegExp(`^${dateRegexSource}$`);
function timeRegexSource(args) {
  let secondsRegexSource = `[0-5]\\d`;
  if (args.precision) {
    secondsRegexSource = `${secondsRegexSource}\\.\\d{${args.precision}}`;
  } else if (args.precision == null) {
    secondsRegexSource = `${secondsRegexSource}(\\.\\d+)?`;
  }
  const secondsQuantifier = args.precision ? "+" : "?";
  return `([01]\\d|2[0-3]):[0-5]\\d(:${secondsRegexSource})${secondsQuantifier}`;
}
function timeRegex(args) {
  return new RegExp(`^${timeRegexSource(args)}$`);
}
function datetimeRegex(args) {
  let regex = `${dateRegexSource}T${timeRegexSource(args)}`;
  const opts = [];
  opts.push(args.local ? `Z?` : `Z`);
  if (args.offset)
    opts.push(`([+-]\\d{2}:?\\d{2})`);
  regex = `${regex}(${opts.join("|")})`;
  return new RegExp(`^${regex}$`);
}
function isValidIP(ip, version) {
  if ((version === "v4" || !version) && ipv4Regex.test(ip)) {
    return true;
  }
  if ((version === "v6" || !version) && ipv6Regex.test(ip)) {
    return true;
  }
  return false;
}
function isValidJWT(jwt, alg) {
  if (!jwtRegex.test(jwt))
    return false;
  try {
    const [header] = jwt.split(".");
    if (!header)
      return false;
    const base64 = header.replace(/-/g, "+").replace(/_/g, "/").padEnd(header.length + (4 - header.length % 4) % 4, "=");
    const decoded = JSON.parse(atob(base64));
    if (typeof decoded !== "object" || decoded === null)
      return false;
    if ("typ" in decoded && decoded?.typ !== "JWT")
      return false;
    if (!decoded.alg)
      return false;
    if (alg && decoded.alg !== alg)
      return false;
    return true;
  } catch {
    return false;
  }
}
function isValidCidr(ip, version) {
  if ((version === "v4" || !version) && ipv4CidrRegex.test(ip)) {
    return true;
  }
  if ((version === "v6" || !version) && ipv6CidrRegex.test(ip)) {
    return true;
  }
  return false;
}
var ZodString = class _ZodString extends ZodType {
  _parse(input) {
    if (this._def.coerce) {
      input.data = String(input.data);
    }
    const parsedType = this._getType(input);
    if (parsedType !== ZodParsedType.string) {
      const ctx2 = this._getOrReturnCtx(input);
      addIssueToContext(ctx2, {
        code: ZodIssueCode.invalid_type,
        expected: ZodParsedType.string,
        received: ctx2.parsedType
      });
      return INVALID;
    }
    const status = new ParseStatus();
    let ctx = void 0;
    for (const check of this._def.checks) {
      if (check.kind === "min") {
        if (input.data.length < check.value) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            code: ZodIssueCode.too_small,
            minimum: check.value,
            type: "string",
            inclusive: true,
            exact: false,
            message: check.message
          });
          status.dirty();
        }
      } else if (check.kind === "max") {
        if (input.data.length > check.value) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            code: ZodIssueCode.too_big,
            maximum: check.value,
            type: "string",
            inclusive: true,
            exact: false,
            message: check.message
          });
          status.dirty();
        }
      } else if (check.kind === "length") {
        const tooBig = input.data.length > check.value;
        const tooSmall = input.data.length < check.value;
        if (tooBig || tooSmall) {
          ctx = this._getOrReturnCtx(input, ctx);
          if (tooBig) {
            addIssueToContext(ctx, {
              code: ZodIssueCode.too_big,
              maximum: check.value,
              type: "string",
              inclusive: true,
              exact: true,
              message: check.message
            });
          } else if (tooSmall) {
            addIssueToContext(ctx, {
              code: ZodIssueCode.too_small,
              minimum: check.value,
              type: "string",
              inclusive: true,
              exact: true,
              message: check.message
            });
          }
          status.dirty();
        }
      } else if (check.kind === "email") {
        if (!emailRegex.test(input.data)) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            validation: "email",
            code: ZodIssueCode.invalid_string,
            message: check.message
          });
          status.dirty();
        }
      } else if (check.kind === "emoji") {
        if (!emojiRegex) {
          emojiRegex = new RegExp(_emojiRegex, "u");
        }
        if (!emojiRegex.test(input.data)) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            validation: "emoji",
            code: ZodIssueCode.invalid_string,
            message: check.message
          });
          status.dirty();
        }
      } else if (check.kind === "uuid") {
        if (!uuidRegex.test(input.data)) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            validation: "uuid",
            code: ZodIssueCode.invalid_string,
            message: check.message
          });
          status.dirty();
        }
      } else if (check.kind === "nanoid") {
        if (!nanoidRegex.test(input.data)) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            validation: "nanoid",
            code: ZodIssueCode.invalid_string,
            message: check.message
          });
          status.dirty();
        }
      } else if (check.kind === "cuid") {
        if (!cuidRegex.test(input.data)) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            validation: "cuid",
            code: ZodIssueCode.invalid_string,
            message: check.message
          });
          status.dirty();
        }
      } else if (check.kind === "cuid2") {
        if (!cuid2Regex.test(input.data)) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            validation: "cuid2",
            code: ZodIssueCode.invalid_string,
            message: check.message
          });
          status.dirty();
        }
      } else if (check.kind === "ulid") {
        if (!ulidRegex.test(input.data)) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            validation: "ulid",
            code: ZodIssueCode.invalid_string,
            message: check.message
          });
          status.dirty();
        }
      } else if (check.kind === "url") {
        try {
          new URL(input.data);
        } catch {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            validation: "url",
            code: ZodIssueCode.invalid_string,
            message: check.message
          });
          status.dirty();
        }
      } else if (check.kind === "regex") {
        check.regex.lastIndex = 0;
        const testResult = check.regex.test(input.data);
        if (!testResult) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            validation: "regex",
            code: ZodIssueCode.invalid_string,
            message: check.message
          });
          status.dirty();
        }
      } else if (check.kind === "trim") {
        input.data = input.data.trim();
      } else if (check.kind === "includes") {
        if (!input.data.includes(check.value, check.position)) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            code: ZodIssueCode.invalid_string,
            validation: { includes: check.value, position: check.position },
            message: check.message
          });
          status.dirty();
        }
      } else if (check.kind === "toLowerCase") {
        input.data = input.data.toLowerCase();
      } else if (check.kind === "toUpperCase") {
        input.data = input.data.toUpperCase();
      } else if (check.kind === "startsWith") {
        if (!input.data.startsWith(check.value)) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            code: ZodIssueCode.invalid_string,
            validation: { startsWith: check.value },
            message: check.message
          });
          status.dirty();
        }
      } else if (check.kind === "endsWith") {
        if (!input.data.endsWith(check.value)) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            code: ZodIssueCode.invalid_string,
            validation: { endsWith: check.value },
            message: check.message
          });
          status.dirty();
        }
      } else if (check.kind === "datetime") {
        const regex = datetimeRegex(check);
        if (!regex.test(input.data)) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            code: ZodIssueCode.invalid_string,
            validation: "datetime",
            message: check.message
          });
          status.dirty();
        }
      } else if (check.kind === "date") {
        const regex = dateRegex;
        if (!regex.test(input.data)) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            code: ZodIssueCode.invalid_string,
            validation: "date",
            message: check.message
          });
          status.dirty();
        }
      } else if (check.kind === "time") {
        const regex = timeRegex(check);
        if (!regex.test(input.data)) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            code: ZodIssueCode.invalid_string,
            validation: "time",
            message: check.message
          });
          status.dirty();
        }
      } else if (check.kind === "duration") {
        if (!durationRegex.test(input.data)) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            validation: "duration",
            code: ZodIssueCode.invalid_string,
            message: check.message
          });
          status.dirty();
        }
      } else if (check.kind === "ip") {
        if (!isValidIP(input.data, check.version)) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            validation: "ip",
            code: ZodIssueCode.invalid_string,
            message: check.message
          });
          status.dirty();
        }
      } else if (check.kind === "jwt") {
        if (!isValidJWT(input.data, check.alg)) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            validation: "jwt",
            code: ZodIssueCode.invalid_string,
            message: check.message
          });
          status.dirty();
        }
      } else if (check.kind === "cidr") {
        if (!isValidCidr(input.data, check.version)) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            validation: "cidr",
            code: ZodIssueCode.invalid_string,
            message: check.message
          });
          status.dirty();
        }
      } else if (check.kind === "base64") {
        if (!base64Regex.test(input.data)) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            validation: "base64",
            code: ZodIssueCode.invalid_string,
            message: check.message
          });
          status.dirty();
        }
      } else if (check.kind === "base64url") {
        if (!base64urlRegex.test(input.data)) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            validation: "base64url",
            code: ZodIssueCode.invalid_string,
            message: check.message
          });
          status.dirty();
        }
      } else {
        util.assertNever(check);
      }
    }
    return { status: status.value, value: input.data };
  }
  _regex(regex, validation, message) {
    return this.refinement((data) => regex.test(data), {
      validation,
      code: ZodIssueCode.invalid_string,
      ...errorUtil.errToObj(message)
    });
  }
  _addCheck(check) {
    return new _ZodString({
      ...this._def,
      checks: [...this._def.checks, check]
    });
  }
  email(message) {
    return this._addCheck({ kind: "email", ...errorUtil.errToObj(message) });
  }
  url(message) {
    return this._addCheck({ kind: "url", ...errorUtil.errToObj(message) });
  }
  emoji(message) {
    return this._addCheck({ kind: "emoji", ...errorUtil.errToObj(message) });
  }
  uuid(message) {
    return this._addCheck({ kind: "uuid", ...errorUtil.errToObj(message) });
  }
  nanoid(message) {
    return this._addCheck({ kind: "nanoid", ...errorUtil.errToObj(message) });
  }
  cuid(message) {
    return this._addCheck({ kind: "cuid", ...errorUtil.errToObj(message) });
  }
  cuid2(message) {
    return this._addCheck({ kind: "cuid2", ...errorUtil.errToObj(message) });
  }
  ulid(message) {
    return this._addCheck({ kind: "ulid", ...errorUtil.errToObj(message) });
  }
  base64(message) {
    return this._addCheck({ kind: "base64", ...errorUtil.errToObj(message) });
  }
  base64url(message) {
    return this._addCheck({
      kind: "base64url",
      ...errorUtil.errToObj(message)
    });
  }
  jwt(options) {
    return this._addCheck({ kind: "jwt", ...errorUtil.errToObj(options) });
  }
  ip(options) {
    return this._addCheck({ kind: "ip", ...errorUtil.errToObj(options) });
  }
  cidr(options) {
    return this._addCheck({ kind: "cidr", ...errorUtil.errToObj(options) });
  }
  datetime(options) {
    if (typeof options === "string") {
      return this._addCheck({
        kind: "datetime",
        precision: null,
        offset: false,
        local: false,
        message: options
      });
    }
    return this._addCheck({
      kind: "datetime",
      precision: typeof options?.precision === "undefined" ? null : options?.precision,
      offset: options?.offset ?? false,
      local: options?.local ?? false,
      ...errorUtil.errToObj(options?.message)
    });
  }
  date(message) {
    return this._addCheck({ kind: "date", message });
  }
  time(options) {
    if (typeof options === "string") {
      return this._addCheck({
        kind: "time",
        precision: null,
        message: options
      });
    }
    return this._addCheck({
      kind: "time",
      precision: typeof options?.precision === "undefined" ? null : options?.precision,
      ...errorUtil.errToObj(options?.message)
    });
  }
  duration(message) {
    return this._addCheck({ kind: "duration", ...errorUtil.errToObj(message) });
  }
  regex(regex, message) {
    return this._addCheck({
      kind: "regex",
      regex,
      ...errorUtil.errToObj(message)
    });
  }
  includes(value, options) {
    return this._addCheck({
      kind: "includes",
      value,
      position: options?.position,
      ...errorUtil.errToObj(options?.message)
    });
  }
  startsWith(value, message) {
    return this._addCheck({
      kind: "startsWith",
      value,
      ...errorUtil.errToObj(message)
    });
  }
  endsWith(value, message) {
    return this._addCheck({
      kind: "endsWith",
      value,
      ...errorUtil.errToObj(message)
    });
  }
  min(minLength, message) {
    return this._addCheck({
      kind: "min",
      value: minLength,
      ...errorUtil.errToObj(message)
    });
  }
  max(maxLength, message) {
    return this._addCheck({
      kind: "max",
      value: maxLength,
      ...errorUtil.errToObj(message)
    });
  }
  length(len, message) {
    return this._addCheck({
      kind: "length",
      value: len,
      ...errorUtil.errToObj(message)
    });
  }
  /**
   * Equivalent to `.min(1)`
   */
  nonempty(message) {
    return this.min(1, errorUtil.errToObj(message));
  }
  trim() {
    return new _ZodString({
      ...this._def,
      checks: [...this._def.checks, { kind: "trim" }]
    });
  }
  toLowerCase() {
    return new _ZodString({
      ...this._def,
      checks: [...this._def.checks, { kind: "toLowerCase" }]
    });
  }
  toUpperCase() {
    return new _ZodString({
      ...this._def,
      checks: [...this._def.checks, { kind: "toUpperCase" }]
    });
  }
  get isDatetime() {
    return !!this._def.checks.find((ch) => ch.kind === "datetime");
  }
  get isDate() {
    return !!this._def.checks.find((ch) => ch.kind === "date");
  }
  get isTime() {
    return !!this._def.checks.find((ch) => ch.kind === "time");
  }
  get isDuration() {
    return !!this._def.checks.find((ch) => ch.kind === "duration");
  }
  get isEmail() {
    return !!this._def.checks.find((ch) => ch.kind === "email");
  }
  get isURL() {
    return !!this._def.checks.find((ch) => ch.kind === "url");
  }
  get isEmoji() {
    return !!this._def.checks.find((ch) => ch.kind === "emoji");
  }
  get isUUID() {
    return !!this._def.checks.find((ch) => ch.kind === "uuid");
  }
  get isNANOID() {
    return !!this._def.checks.find((ch) => ch.kind === "nanoid");
  }
  get isCUID() {
    return !!this._def.checks.find((ch) => ch.kind === "cuid");
  }
  get isCUID2() {
    return !!this._def.checks.find((ch) => ch.kind === "cuid2");
  }
  get isULID() {
    return !!this._def.checks.find((ch) => ch.kind === "ulid");
  }
  get isIP() {
    return !!this._def.checks.find((ch) => ch.kind === "ip");
  }
  get isCIDR() {
    return !!this._def.checks.find((ch) => ch.kind === "cidr");
  }
  get isBase64() {
    return !!this._def.checks.find((ch) => ch.kind === "base64");
  }
  get isBase64url() {
    return !!this._def.checks.find((ch) => ch.kind === "base64url");
  }
  get minLength() {
    let min = null;
    for (const ch of this._def.checks) {
      if (ch.kind === "min") {
        if (min === null || ch.value > min)
          min = ch.value;
      }
    }
    return min;
  }
  get maxLength() {
    let max = null;
    for (const ch of this._def.checks) {
      if (ch.kind === "max") {
        if (max === null || ch.value < max)
          max = ch.value;
      }
    }
    return max;
  }
};
ZodString.create = (params) => {
  return new ZodString({
    checks: [],
    typeName: ZodFirstPartyTypeKind.ZodString,
    coerce: params?.coerce ?? false,
    ...processCreateParams(params)
  });
};
function floatSafeRemainder(val, step) {
  const valDecCount = (val.toString().split(".")[1] || "").length;
  const stepDecCount = (step.toString().split(".")[1] || "").length;
  const decCount = valDecCount > stepDecCount ? valDecCount : stepDecCount;
  const valInt = Number.parseInt(val.toFixed(decCount).replace(".", ""));
  const stepInt = Number.parseInt(step.toFixed(decCount).replace(".", ""));
  return valInt % stepInt / 10 ** decCount;
}
var ZodNumber = class _ZodNumber extends ZodType {
  constructor() {
    super(...arguments);
    this.min = this.gte;
    this.max = this.lte;
    this.step = this.multipleOf;
  }
  _parse(input) {
    if (this._def.coerce) {
      input.data = Number(input.data);
    }
    const parsedType = this._getType(input);
    if (parsedType !== ZodParsedType.number) {
      const ctx2 = this._getOrReturnCtx(input);
      addIssueToContext(ctx2, {
        code: ZodIssueCode.invalid_type,
        expected: ZodParsedType.number,
        received: ctx2.parsedType
      });
      return INVALID;
    }
    let ctx = void 0;
    const status = new ParseStatus();
    for (const check of this._def.checks) {
      if (check.kind === "int") {
        if (!util.isInteger(input.data)) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            code: ZodIssueCode.invalid_type,
            expected: "integer",
            received: "float",
            message: check.message
          });
          status.dirty();
        }
      } else if (check.kind === "min") {
        const tooSmall = check.inclusive ? input.data < check.value : input.data <= check.value;
        if (tooSmall) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            code: ZodIssueCode.too_small,
            minimum: check.value,
            type: "number",
            inclusive: check.inclusive,
            exact: false,
            message: check.message
          });
          status.dirty();
        }
      } else if (check.kind === "max") {
        const tooBig = check.inclusive ? input.data > check.value : input.data >= check.value;
        if (tooBig) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            code: ZodIssueCode.too_big,
            maximum: check.value,
            type: "number",
            inclusive: check.inclusive,
            exact: false,
            message: check.message
          });
          status.dirty();
        }
      } else if (check.kind === "multipleOf") {
        if (floatSafeRemainder(input.data, check.value) !== 0) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            code: ZodIssueCode.not_multiple_of,
            multipleOf: check.value,
            message: check.message
          });
          status.dirty();
        }
      } else if (check.kind === "finite") {
        if (!Number.isFinite(input.data)) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            code: ZodIssueCode.not_finite,
            message: check.message
          });
          status.dirty();
        }
      } else {
        util.assertNever(check);
      }
    }
    return { status: status.value, value: input.data };
  }
  gte(value, message) {
    return this.setLimit("min", value, true, errorUtil.toString(message));
  }
  gt(value, message) {
    return this.setLimit("min", value, false, errorUtil.toString(message));
  }
  lte(value, message) {
    return this.setLimit("max", value, true, errorUtil.toString(message));
  }
  lt(value, message) {
    return this.setLimit("max", value, false, errorUtil.toString(message));
  }
  setLimit(kind, value, inclusive, message) {
    return new _ZodNumber({
      ...this._def,
      checks: [
        ...this._def.checks,
        {
          kind,
          value,
          inclusive,
          message: errorUtil.toString(message)
        }
      ]
    });
  }
  _addCheck(check) {
    return new _ZodNumber({
      ...this._def,
      checks: [...this._def.checks, check]
    });
  }
  int(message) {
    return this._addCheck({
      kind: "int",
      message: errorUtil.toString(message)
    });
  }
  positive(message) {
    return this._addCheck({
      kind: "min",
      value: 0,
      inclusive: false,
      message: errorUtil.toString(message)
    });
  }
  negative(message) {
    return this._addCheck({
      kind: "max",
      value: 0,
      inclusive: false,
      message: errorUtil.toString(message)
    });
  }
  nonpositive(message) {
    return this._addCheck({
      kind: "max",
      value: 0,
      inclusive: true,
      message: errorUtil.toString(message)
    });
  }
  nonnegative(message) {
    return this._addCheck({
      kind: "min",
      value: 0,
      inclusive: true,
      message: errorUtil.toString(message)
    });
  }
  multipleOf(value, message) {
    return this._addCheck({
      kind: "multipleOf",
      value,
      message: errorUtil.toString(message)
    });
  }
  finite(message) {
    return this._addCheck({
      kind: "finite",
      message: errorUtil.toString(message)
    });
  }
  safe(message) {
    return this._addCheck({
      kind: "min",
      inclusive: true,
      value: Number.MIN_SAFE_INTEGER,
      message: errorUtil.toString(message)
    })._addCheck({
      kind: "max",
      inclusive: true,
      value: Number.MAX_SAFE_INTEGER,
      message: errorUtil.toString(message)
    });
  }
  get minValue() {
    let min = null;
    for (const ch of this._def.checks) {
      if (ch.kind === "min") {
        if (min === null || ch.value > min)
          min = ch.value;
      }
    }
    return min;
  }
  get maxValue() {
    let max = null;
    for (const ch of this._def.checks) {
      if (ch.kind === "max") {
        if (max === null || ch.value < max)
          max = ch.value;
      }
    }
    return max;
  }
  get isInt() {
    return !!this._def.checks.find((ch) => ch.kind === "int" || ch.kind === "multipleOf" && util.isInteger(ch.value));
  }
  get isFinite() {
    let max = null;
    let min = null;
    for (const ch of this._def.checks) {
      if (ch.kind === "finite" || ch.kind === "int" || ch.kind === "multipleOf") {
        return true;
      } else if (ch.kind === "min") {
        if (min === null || ch.value > min)
          min = ch.value;
      } else if (ch.kind === "max") {
        if (max === null || ch.value < max)
          max = ch.value;
      }
    }
    return Number.isFinite(min) && Number.isFinite(max);
  }
};
ZodNumber.create = (params) => {
  return new ZodNumber({
    checks: [],
    typeName: ZodFirstPartyTypeKind.ZodNumber,
    coerce: params?.coerce || false,
    ...processCreateParams(params)
  });
};
var ZodBigInt = class _ZodBigInt extends ZodType {
  constructor() {
    super(...arguments);
    this.min = this.gte;
    this.max = this.lte;
  }
  _parse(input) {
    if (this._def.coerce) {
      try {
        input.data = BigInt(input.data);
      } catch {
        return this._getInvalidInput(input);
      }
    }
    const parsedType = this._getType(input);
    if (parsedType !== ZodParsedType.bigint) {
      return this._getInvalidInput(input);
    }
    let ctx = void 0;
    const status = new ParseStatus();
    for (const check of this._def.checks) {
      if (check.kind === "min") {
        const tooSmall = check.inclusive ? input.data < check.value : input.data <= check.value;
        if (tooSmall) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            code: ZodIssueCode.too_small,
            type: "bigint",
            minimum: check.value,
            inclusive: check.inclusive,
            message: check.message
          });
          status.dirty();
        }
      } else if (check.kind === "max") {
        const tooBig = check.inclusive ? input.data > check.value : input.data >= check.value;
        if (tooBig) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            code: ZodIssueCode.too_big,
            type: "bigint",
            maximum: check.value,
            inclusive: check.inclusive,
            message: check.message
          });
          status.dirty();
        }
      } else if (check.kind === "multipleOf") {
        if (input.data % check.value !== BigInt(0)) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            code: ZodIssueCode.not_multiple_of,
            multipleOf: check.value,
            message: check.message
          });
          status.dirty();
        }
      } else {
        util.assertNever(check);
      }
    }
    return { status: status.value, value: input.data };
  }
  _getInvalidInput(input) {
    const ctx = this._getOrReturnCtx(input);
    addIssueToContext(ctx, {
      code: ZodIssueCode.invalid_type,
      expected: ZodParsedType.bigint,
      received: ctx.parsedType
    });
    return INVALID;
  }
  gte(value, message) {
    return this.setLimit("min", value, true, errorUtil.toString(message));
  }
  gt(value, message) {
    return this.setLimit("min", value, false, errorUtil.toString(message));
  }
  lte(value, message) {
    return this.setLimit("max", value, true, errorUtil.toString(message));
  }
  lt(value, message) {
    return this.setLimit("max", value, false, errorUtil.toString(message));
  }
  setLimit(kind, value, inclusive, message) {
    return new _ZodBigInt({
      ...this._def,
      checks: [
        ...this._def.checks,
        {
          kind,
          value,
          inclusive,
          message: errorUtil.toString(message)
        }
      ]
    });
  }
  _addCheck(check) {
    return new _ZodBigInt({
      ...this._def,
      checks: [...this._def.checks, check]
    });
  }
  positive(message) {
    return this._addCheck({
      kind: "min",
      value: BigInt(0),
      inclusive: false,
      message: errorUtil.toString(message)
    });
  }
  negative(message) {
    return this._addCheck({
      kind: "max",
      value: BigInt(0),
      inclusive: false,
      message: errorUtil.toString(message)
    });
  }
  nonpositive(message) {
    return this._addCheck({
      kind: "max",
      value: BigInt(0),
      inclusive: true,
      message: errorUtil.toString(message)
    });
  }
  nonnegative(message) {
    return this._addCheck({
      kind: "min",
      value: BigInt(0),
      inclusive: true,
      message: errorUtil.toString(message)
    });
  }
  multipleOf(value, message) {
    return this._addCheck({
      kind: "multipleOf",
      value,
      message: errorUtil.toString(message)
    });
  }
  get minValue() {
    let min = null;
    for (const ch of this._def.checks) {
      if (ch.kind === "min") {
        if (min === null || ch.value > min)
          min = ch.value;
      }
    }
    return min;
  }
  get maxValue() {
    let max = null;
    for (const ch of this._def.checks) {
      if (ch.kind === "max") {
        if (max === null || ch.value < max)
          max = ch.value;
      }
    }
    return max;
  }
};
ZodBigInt.create = (params) => {
  return new ZodBigInt({
    checks: [],
    typeName: ZodFirstPartyTypeKind.ZodBigInt,
    coerce: params?.coerce ?? false,
    ...processCreateParams(params)
  });
};
var ZodBoolean = class extends ZodType {
  _parse(input) {
    if (this._def.coerce) {
      input.data = Boolean(input.data);
    }
    const parsedType = this._getType(input);
    if (parsedType !== ZodParsedType.boolean) {
      const ctx = this._getOrReturnCtx(input);
      addIssueToContext(ctx, {
        code: ZodIssueCode.invalid_type,
        expected: ZodParsedType.boolean,
        received: ctx.parsedType
      });
      return INVALID;
    }
    return OK(input.data);
  }
};
ZodBoolean.create = (params) => {
  return new ZodBoolean({
    typeName: ZodFirstPartyTypeKind.ZodBoolean,
    coerce: params?.coerce || false,
    ...processCreateParams(params)
  });
};
var ZodDate = class _ZodDate extends ZodType {
  _parse(input) {
    if (this._def.coerce) {
      input.data = new Date(input.data);
    }
    const parsedType = this._getType(input);
    if (parsedType !== ZodParsedType.date) {
      const ctx2 = this._getOrReturnCtx(input);
      addIssueToContext(ctx2, {
        code: ZodIssueCode.invalid_type,
        expected: ZodParsedType.date,
        received: ctx2.parsedType
      });
      return INVALID;
    }
    if (Number.isNaN(input.data.getTime())) {
      const ctx2 = this._getOrReturnCtx(input);
      addIssueToContext(ctx2, {
        code: ZodIssueCode.invalid_date
      });
      return INVALID;
    }
    const status = new ParseStatus();
    let ctx = void 0;
    for (const check of this._def.checks) {
      if (check.kind === "min") {
        if (input.data.getTime() < check.value) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            code: ZodIssueCode.too_small,
            message: check.message,
            inclusive: true,
            exact: false,
            minimum: check.value,
            type: "date"
          });
          status.dirty();
        }
      } else if (check.kind === "max") {
        if (input.data.getTime() > check.value) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            code: ZodIssueCode.too_big,
            message: check.message,
            inclusive: true,
            exact: false,
            maximum: check.value,
            type: "date"
          });
          status.dirty();
        }
      } else {
        util.assertNever(check);
      }
    }
    return {
      status: status.value,
      value: new Date(input.data.getTime())
    };
  }
  _addCheck(check) {
    return new _ZodDate({
      ...this._def,
      checks: [...this._def.checks, check]
    });
  }
  min(minDate, message) {
    return this._addCheck({
      kind: "min",
      value: minDate.getTime(),
      message: errorUtil.toString(message)
    });
  }
  max(maxDate, message) {
    return this._addCheck({
      kind: "max",
      value: maxDate.getTime(),
      message: errorUtil.toString(message)
    });
  }
  get minDate() {
    let min = null;
    for (const ch of this._def.checks) {
      if (ch.kind === "min") {
        if (min === null || ch.value > min)
          min = ch.value;
      }
    }
    return min != null ? new Date(min) : null;
  }
  get maxDate() {
    let max = null;
    for (const ch of this._def.checks) {
      if (ch.kind === "max") {
        if (max === null || ch.value < max)
          max = ch.value;
      }
    }
    return max != null ? new Date(max) : null;
  }
};
ZodDate.create = (params) => {
  return new ZodDate({
    checks: [],
    coerce: params?.coerce || false,
    typeName: ZodFirstPartyTypeKind.ZodDate,
    ...processCreateParams(params)
  });
};
var ZodSymbol = class extends ZodType {
  _parse(input) {
    const parsedType = this._getType(input);
    if (parsedType !== ZodParsedType.symbol) {
      const ctx = this._getOrReturnCtx(input);
      addIssueToContext(ctx, {
        code: ZodIssueCode.invalid_type,
        expected: ZodParsedType.symbol,
        received: ctx.parsedType
      });
      return INVALID;
    }
    return OK(input.data);
  }
};
ZodSymbol.create = (params) => {
  return new ZodSymbol({
    typeName: ZodFirstPartyTypeKind.ZodSymbol,
    ...processCreateParams(params)
  });
};
var ZodUndefined = class extends ZodType {
  _parse(input) {
    const parsedType = this._getType(input);
    if (parsedType !== ZodParsedType.undefined) {
      const ctx = this._getOrReturnCtx(input);
      addIssueToContext(ctx, {
        code: ZodIssueCode.invalid_type,
        expected: ZodParsedType.undefined,
        received: ctx.parsedType
      });
      return INVALID;
    }
    return OK(input.data);
  }
};
ZodUndefined.create = (params) => {
  return new ZodUndefined({
    typeName: ZodFirstPartyTypeKind.ZodUndefined,
    ...processCreateParams(params)
  });
};
var ZodNull = class extends ZodType {
  _parse(input) {
    const parsedType = this._getType(input);
    if (parsedType !== ZodParsedType.null) {
      const ctx = this._getOrReturnCtx(input);
      addIssueToContext(ctx, {
        code: ZodIssueCode.invalid_type,
        expected: ZodParsedType.null,
        received: ctx.parsedType
      });
      return INVALID;
    }
    return OK(input.data);
  }
};
ZodNull.create = (params) => {
  return new ZodNull({
    typeName: ZodFirstPartyTypeKind.ZodNull,
    ...processCreateParams(params)
  });
};
var ZodAny = class extends ZodType {
  constructor() {
    super(...arguments);
    this._any = true;
  }
  _parse(input) {
    return OK(input.data);
  }
};
ZodAny.create = (params) => {
  return new ZodAny({
    typeName: ZodFirstPartyTypeKind.ZodAny,
    ...processCreateParams(params)
  });
};
var ZodUnknown = class extends ZodType {
  constructor() {
    super(...arguments);
    this._unknown = true;
  }
  _parse(input) {
    return OK(input.data);
  }
};
ZodUnknown.create = (params) => {
  return new ZodUnknown({
    typeName: ZodFirstPartyTypeKind.ZodUnknown,
    ...processCreateParams(params)
  });
};
var ZodNever = class extends ZodType {
  _parse(input) {
    const ctx = this._getOrReturnCtx(input);
    addIssueToContext(ctx, {
      code: ZodIssueCode.invalid_type,
      expected: ZodParsedType.never,
      received: ctx.parsedType
    });
    return INVALID;
  }
};
ZodNever.create = (params) => {
  return new ZodNever({
    typeName: ZodFirstPartyTypeKind.ZodNever,
    ...processCreateParams(params)
  });
};
var ZodVoid = class extends ZodType {
  _parse(input) {
    const parsedType = this._getType(input);
    if (parsedType !== ZodParsedType.undefined) {
      const ctx = this._getOrReturnCtx(input);
      addIssueToContext(ctx, {
        code: ZodIssueCode.invalid_type,
        expected: ZodParsedType.void,
        received: ctx.parsedType
      });
      return INVALID;
    }
    return OK(input.data);
  }
};
ZodVoid.create = (params) => {
  return new ZodVoid({
    typeName: ZodFirstPartyTypeKind.ZodVoid,
    ...processCreateParams(params)
  });
};
var ZodArray = class _ZodArray extends ZodType {
  _parse(input) {
    const { ctx, status } = this._processInputParams(input);
    const def = this._def;
    if (ctx.parsedType !== ZodParsedType.array) {
      addIssueToContext(ctx, {
        code: ZodIssueCode.invalid_type,
        expected: ZodParsedType.array,
        received: ctx.parsedType
      });
      return INVALID;
    }
    if (def.exactLength !== null) {
      const tooBig = ctx.data.length > def.exactLength.value;
      const tooSmall = ctx.data.length < def.exactLength.value;
      if (tooBig || tooSmall) {
        addIssueToContext(ctx, {
          code: tooBig ? ZodIssueCode.too_big : ZodIssueCode.too_small,
          minimum: tooSmall ? def.exactLength.value : void 0,
          maximum: tooBig ? def.exactLength.value : void 0,
          type: "array",
          inclusive: true,
          exact: true,
          message: def.exactLength.message
        });
        status.dirty();
      }
    }
    if (def.minLength !== null) {
      if (ctx.data.length < def.minLength.value) {
        addIssueToContext(ctx, {
          code: ZodIssueCode.too_small,
          minimum: def.minLength.value,
          type: "array",
          inclusive: true,
          exact: false,
          message: def.minLength.message
        });
        status.dirty();
      }
    }
    if (def.maxLength !== null) {
      if (ctx.data.length > def.maxLength.value) {
        addIssueToContext(ctx, {
          code: ZodIssueCode.too_big,
          maximum: def.maxLength.value,
          type: "array",
          inclusive: true,
          exact: false,
          message: def.maxLength.message
        });
        status.dirty();
      }
    }
    if (ctx.common.async) {
      return Promise.all([...ctx.data].map((item, i) => {
        return def.type._parseAsync(new ParseInputLazyPath(ctx, item, ctx.path, i));
      })).then((result2) => {
        return ParseStatus.mergeArray(status, result2);
      });
    }
    const result = [...ctx.data].map((item, i) => {
      return def.type._parseSync(new ParseInputLazyPath(ctx, item, ctx.path, i));
    });
    return ParseStatus.mergeArray(status, result);
  }
  get element() {
    return this._def.type;
  }
  min(minLength, message) {
    return new _ZodArray({
      ...this._def,
      minLength: { value: minLength, message: errorUtil.toString(message) }
    });
  }
  max(maxLength, message) {
    return new _ZodArray({
      ...this._def,
      maxLength: { value: maxLength, message: errorUtil.toString(message) }
    });
  }
  length(len, message) {
    return new _ZodArray({
      ...this._def,
      exactLength: { value: len, message: errorUtil.toString(message) }
    });
  }
  nonempty(message) {
    return this.min(1, message);
  }
};
ZodArray.create = (schema, params) => {
  return new ZodArray({
    type: schema,
    minLength: null,
    maxLength: null,
    exactLength: null,
    typeName: ZodFirstPartyTypeKind.ZodArray,
    ...processCreateParams(params)
  });
};
function deepPartialify(schema) {
  if (schema instanceof ZodObject) {
    const newShape = {};
    for (const key in schema.shape) {
      const fieldSchema = schema.shape[key];
      newShape[key] = ZodOptional.create(deepPartialify(fieldSchema));
    }
    return new ZodObject({
      ...schema._def,
      shape: () => newShape
    });
  } else if (schema instanceof ZodArray) {
    return new ZodArray({
      ...schema._def,
      type: deepPartialify(schema.element)
    });
  } else if (schema instanceof ZodOptional) {
    return ZodOptional.create(deepPartialify(schema.unwrap()));
  } else if (schema instanceof ZodNullable) {
    return ZodNullable.create(deepPartialify(schema.unwrap()));
  } else if (schema instanceof ZodTuple) {
    return ZodTuple.create(schema.items.map((item) => deepPartialify(item)));
  } else {
    return schema;
  }
}
var ZodObject = class _ZodObject extends ZodType {
  constructor() {
    super(...arguments);
    this._cached = null;
    this.nonstrict = this.passthrough;
    this.augment = this.extend;
  }
  _getCached() {
    if (this._cached !== null)
      return this._cached;
    const shape = this._def.shape();
    const keys = util.objectKeys(shape);
    this._cached = { shape, keys };
    return this._cached;
  }
  _parse(input) {
    const parsedType = this._getType(input);
    if (parsedType !== ZodParsedType.object) {
      const ctx2 = this._getOrReturnCtx(input);
      addIssueToContext(ctx2, {
        code: ZodIssueCode.invalid_type,
        expected: ZodParsedType.object,
        received: ctx2.parsedType
      });
      return INVALID;
    }
    const { status, ctx } = this._processInputParams(input);
    const { shape, keys: shapeKeys } = this._getCached();
    const extraKeys = [];
    if (!(this._def.catchall instanceof ZodNever && this._def.unknownKeys === "strip")) {
      for (const key in ctx.data) {
        if (!shapeKeys.includes(key)) {
          extraKeys.push(key);
        }
      }
    }
    const pairs = [];
    for (const key of shapeKeys) {
      const keyValidator = shape[key];
      const value = ctx.data[key];
      pairs.push({
        key: { status: "valid", value: key },
        value: keyValidator._parse(new ParseInputLazyPath(ctx, value, ctx.path, key)),
        alwaysSet: key in ctx.data
      });
    }
    if (this._def.catchall instanceof ZodNever) {
      const unknownKeys = this._def.unknownKeys;
      if (unknownKeys === "passthrough") {
        for (const key of extraKeys) {
          pairs.push({
            key: { status: "valid", value: key },
            value: { status: "valid", value: ctx.data[key] }
          });
        }
      } else if (unknownKeys === "strict") {
        if (extraKeys.length > 0) {
          addIssueToContext(ctx, {
            code: ZodIssueCode.unrecognized_keys,
            keys: extraKeys
          });
          status.dirty();
        }
      } else if (unknownKeys === "strip") {
      } else {
        throw new Error(`Internal ZodObject error: invalid unknownKeys value.`);
      }
    } else {
      const catchall = this._def.catchall;
      for (const key of extraKeys) {
        const value = ctx.data[key];
        pairs.push({
          key: { status: "valid", value: key },
          value: catchall._parse(
            new ParseInputLazyPath(ctx, value, ctx.path, key)
            //, ctx.child(key), value, getParsedType(value)
          ),
          alwaysSet: key in ctx.data
        });
      }
    }
    if (ctx.common.async) {
      return Promise.resolve().then(async () => {
        const syncPairs = [];
        for (const pair of pairs) {
          const key = await pair.key;
          const value = await pair.value;
          syncPairs.push({
            key,
            value,
            alwaysSet: pair.alwaysSet
          });
        }
        return syncPairs;
      }).then((syncPairs) => {
        return ParseStatus.mergeObjectSync(status, syncPairs);
      });
    } else {
      return ParseStatus.mergeObjectSync(status, pairs);
    }
  }
  get shape() {
    return this._def.shape();
  }
  strict(message) {
    errorUtil.errToObj;
    return new _ZodObject({
      ...this._def,
      unknownKeys: "strict",
      ...message !== void 0 ? {
        errorMap: (issue, ctx) => {
          const defaultError = this._def.errorMap?.(issue, ctx).message ?? ctx.defaultError;
          if (issue.code === "unrecognized_keys")
            return {
              message: errorUtil.errToObj(message).message ?? defaultError
            };
          return {
            message: defaultError
          };
        }
      } : {}
    });
  }
  strip() {
    return new _ZodObject({
      ...this._def,
      unknownKeys: "strip"
    });
  }
  passthrough() {
    return new _ZodObject({
      ...this._def,
      unknownKeys: "passthrough"
    });
  }
  // const AugmentFactory =
  //   <Def extends ZodObjectDef>(def: Def) =>
  //   <Augmentation extends ZodRawShape>(
  //     augmentation: Augmentation
  //   ): ZodObject<
  //     extendShape<ReturnType<Def["shape"]>, Augmentation>,
  //     Def["unknownKeys"],
  //     Def["catchall"]
  //   > => {
  //     return new ZodObject({
  //       ...def,
  //       shape: () => ({
  //         ...def.shape(),
  //         ...augmentation,
  //       }),
  //     }) as any;
  //   };
  extend(augmentation) {
    return new _ZodObject({
      ...this._def,
      shape: () => ({
        ...this._def.shape(),
        ...augmentation
      })
    });
  }
  /**
   * Prior to zod@1.0.12 there was a bug in the
   * inferred type of merged objects. Please
   * upgrade if you are experiencing issues.
   */
  merge(merging) {
    const merged = new _ZodObject({
      unknownKeys: merging._def.unknownKeys,
      catchall: merging._def.catchall,
      shape: () => ({
        ...this._def.shape(),
        ...merging._def.shape()
      }),
      typeName: ZodFirstPartyTypeKind.ZodObject
    });
    return merged;
  }
  // merge<
  //   Incoming extends AnyZodObject,
  //   Augmentation extends Incoming["shape"],
  //   NewOutput extends {
  //     [k in keyof Augmentation | keyof Output]: k extends keyof Augmentation
  //       ? Augmentation[k]["_output"]
  //       : k extends keyof Output
  //       ? Output[k]
  //       : never;
  //   },
  //   NewInput extends {
  //     [k in keyof Augmentation | keyof Input]: k extends keyof Augmentation
  //       ? Augmentation[k]["_input"]
  //       : k extends keyof Input
  //       ? Input[k]
  //       : never;
  //   }
  // >(
  //   merging: Incoming
  // ): ZodObject<
  //   extendShape<T, ReturnType<Incoming["_def"]["shape"]>>,
  //   Incoming["_def"]["unknownKeys"],
  //   Incoming["_def"]["catchall"],
  //   NewOutput,
  //   NewInput
  // > {
  //   const merged: any = new ZodObject({
  //     unknownKeys: merging._def.unknownKeys,
  //     catchall: merging._def.catchall,
  //     shape: () =>
  //       objectUtil.mergeShapes(this._def.shape(), merging._def.shape()),
  //     typeName: ZodFirstPartyTypeKind.ZodObject,
  //   }) as any;
  //   return merged;
  // }
  setKey(key, schema) {
    return this.augment({ [key]: schema });
  }
  // merge<Incoming extends AnyZodObject>(
  //   merging: Incoming
  // ): //ZodObject<T & Incoming["_shape"], UnknownKeys, Catchall> = (merging) => {
  // ZodObject<
  //   extendShape<T, ReturnType<Incoming["_def"]["shape"]>>,
  //   Incoming["_def"]["unknownKeys"],
  //   Incoming["_def"]["catchall"]
  // > {
  //   // const mergedShape = objectUtil.mergeShapes(
  //   //   this._def.shape(),
  //   //   merging._def.shape()
  //   // );
  //   const merged: any = new ZodObject({
  //     unknownKeys: merging._def.unknownKeys,
  //     catchall: merging._def.catchall,
  //     shape: () =>
  //       objectUtil.mergeShapes(this._def.shape(), merging._def.shape()),
  //     typeName: ZodFirstPartyTypeKind.ZodObject,
  //   }) as any;
  //   return merged;
  // }
  catchall(index) {
    return new _ZodObject({
      ...this._def,
      catchall: index
    });
  }
  pick(mask) {
    const shape = {};
    for (const key of util.objectKeys(mask)) {
      if (mask[key] && this.shape[key]) {
        shape[key] = this.shape[key];
      }
    }
    return new _ZodObject({
      ...this._def,
      shape: () => shape
    });
  }
  omit(mask) {
    const shape = {};
    for (const key of util.objectKeys(this.shape)) {
      if (!mask[key]) {
        shape[key] = this.shape[key];
      }
    }
    return new _ZodObject({
      ...this._def,
      shape: () => shape
    });
  }
  /**
   * @deprecated
   */
  deepPartial() {
    return deepPartialify(this);
  }
  partial(mask) {
    const newShape = {};
    for (const key of util.objectKeys(this.shape)) {
      const fieldSchema = this.shape[key];
      if (mask && !mask[key]) {
        newShape[key] = fieldSchema;
      } else {
        newShape[key] = fieldSchema.optional();
      }
    }
    return new _ZodObject({
      ...this._def,
      shape: () => newShape
    });
  }
  required(mask) {
    const newShape = {};
    for (const key of util.objectKeys(this.shape)) {
      if (mask && !mask[key]) {
        newShape[key] = this.shape[key];
      } else {
        const fieldSchema = this.shape[key];
        let newField = fieldSchema;
        while (newField instanceof ZodOptional) {
          newField = newField._def.innerType;
        }
        newShape[key] = newField;
      }
    }
    return new _ZodObject({
      ...this._def,
      shape: () => newShape
    });
  }
  keyof() {
    return createZodEnum(util.objectKeys(this.shape));
  }
};
ZodObject.create = (shape, params) => {
  return new ZodObject({
    shape: () => shape,
    unknownKeys: "strip",
    catchall: ZodNever.create(),
    typeName: ZodFirstPartyTypeKind.ZodObject,
    ...processCreateParams(params)
  });
};
ZodObject.strictCreate = (shape, params) => {
  return new ZodObject({
    shape: () => shape,
    unknownKeys: "strict",
    catchall: ZodNever.create(),
    typeName: ZodFirstPartyTypeKind.ZodObject,
    ...processCreateParams(params)
  });
};
ZodObject.lazycreate = (shape, params) => {
  return new ZodObject({
    shape,
    unknownKeys: "strip",
    catchall: ZodNever.create(),
    typeName: ZodFirstPartyTypeKind.ZodObject,
    ...processCreateParams(params)
  });
};
var ZodUnion = class extends ZodType {
  _parse(input) {
    const { ctx } = this._processInputParams(input);
    const options = this._def.options;
    function handleResults(results) {
      for (const result of results) {
        if (result.result.status === "valid") {
          return result.result;
        }
      }
      for (const result of results) {
        if (result.result.status === "dirty") {
          ctx.common.issues.push(...result.ctx.common.issues);
          return result.result;
        }
      }
      const unionErrors = results.map((result) => new ZodError(result.ctx.common.issues));
      addIssueToContext(ctx, {
        code: ZodIssueCode.invalid_union,
        unionErrors
      });
      return INVALID;
    }
    if (ctx.common.async) {
      return Promise.all(options.map(async (option) => {
        const childCtx = {
          ...ctx,
          common: {
            ...ctx.common,
            issues: []
          },
          parent: null
        };
        return {
          result: await option._parseAsync({
            data: ctx.data,
            path: ctx.path,
            parent: childCtx
          }),
          ctx: childCtx
        };
      })).then(handleResults);
    } else {
      let dirty = void 0;
      const issues = [];
      for (const option of options) {
        const childCtx = {
          ...ctx,
          common: {
            ...ctx.common,
            issues: []
          },
          parent: null
        };
        const result = option._parseSync({
          data: ctx.data,
          path: ctx.path,
          parent: childCtx
        });
        if (result.status === "valid") {
          return result;
        } else if (result.status === "dirty" && !dirty) {
          dirty = { result, ctx: childCtx };
        }
        if (childCtx.common.issues.length) {
          issues.push(childCtx.common.issues);
        }
      }
      if (dirty) {
        ctx.common.issues.push(...dirty.ctx.common.issues);
        return dirty.result;
      }
      const unionErrors = issues.map((issues2) => new ZodError(issues2));
      addIssueToContext(ctx, {
        code: ZodIssueCode.invalid_union,
        unionErrors
      });
      return INVALID;
    }
  }
  get options() {
    return this._def.options;
  }
};
ZodUnion.create = (types, params) => {
  return new ZodUnion({
    options: types,
    typeName: ZodFirstPartyTypeKind.ZodUnion,
    ...processCreateParams(params)
  });
};
var getDiscriminator = (type) => {
  if (type instanceof ZodLazy) {
    return getDiscriminator(type.schema);
  } else if (type instanceof ZodEffects) {
    return getDiscriminator(type.innerType());
  } else if (type instanceof ZodLiteral) {
    return [type.value];
  } else if (type instanceof ZodEnum) {
    return type.options;
  } else if (type instanceof ZodNativeEnum) {
    return util.objectValues(type.enum);
  } else if (type instanceof ZodDefault) {
    return getDiscriminator(type._def.innerType);
  } else if (type instanceof ZodUndefined) {
    return [void 0];
  } else if (type instanceof ZodNull) {
    return [null];
  } else if (type instanceof ZodOptional) {
    return [void 0, ...getDiscriminator(type.unwrap())];
  } else if (type instanceof ZodNullable) {
    return [null, ...getDiscriminator(type.unwrap())];
  } else if (type instanceof ZodBranded) {
    return getDiscriminator(type.unwrap());
  } else if (type instanceof ZodReadonly) {
    return getDiscriminator(type.unwrap());
  } else if (type instanceof ZodCatch) {
    return getDiscriminator(type._def.innerType);
  } else {
    return [];
  }
};
var ZodDiscriminatedUnion = class _ZodDiscriminatedUnion extends ZodType {
  _parse(input) {
    const { ctx } = this._processInputParams(input);
    if (ctx.parsedType !== ZodParsedType.object) {
      addIssueToContext(ctx, {
        code: ZodIssueCode.invalid_type,
        expected: ZodParsedType.object,
        received: ctx.parsedType
      });
      return INVALID;
    }
    const discriminator = this.discriminator;
    const discriminatorValue = ctx.data[discriminator];
    const option = this.optionsMap.get(discriminatorValue);
    if (!option) {
      addIssueToContext(ctx, {
        code: ZodIssueCode.invalid_union_discriminator,
        options: Array.from(this.optionsMap.keys()),
        path: [discriminator]
      });
      return INVALID;
    }
    if (ctx.common.async) {
      return option._parseAsync({
        data: ctx.data,
        path: ctx.path,
        parent: ctx
      });
    } else {
      return option._parseSync({
        data: ctx.data,
        path: ctx.path,
        parent: ctx
      });
    }
  }
  get discriminator() {
    return this._def.discriminator;
  }
  get options() {
    return this._def.options;
  }
  get optionsMap() {
    return this._def.optionsMap;
  }
  /**
   * The constructor of the discriminated union schema. Its behaviour is very similar to that of the normal z.union() constructor.
   * However, it only allows a union of objects, all of which need to share a discriminator property. This property must
   * have a different value for each object in the union.
   * @param discriminator the name of the discriminator property
   * @param types an array of object schemas
   * @param params
   */
  static create(discriminator, options, params) {
    const optionsMap = /* @__PURE__ */ new Map();
    for (const type of options) {
      const discriminatorValues = getDiscriminator(type.shape[discriminator]);
      if (!discriminatorValues.length) {
        throw new Error(`A discriminator value for key \`${discriminator}\` could not be extracted from all schema options`);
      }
      for (const value of discriminatorValues) {
        if (optionsMap.has(value)) {
          throw new Error(`Discriminator property ${String(discriminator)} has duplicate value ${String(value)}`);
        }
        optionsMap.set(value, type);
      }
    }
    return new _ZodDiscriminatedUnion({
      typeName: ZodFirstPartyTypeKind.ZodDiscriminatedUnion,
      discriminator,
      options,
      optionsMap,
      ...processCreateParams(params)
    });
  }
};
function mergeValues(a, b) {
  const aType = getParsedType(a);
  const bType = getParsedType(b);
  if (a === b) {
    return { valid: true, data: a };
  } else if (aType === ZodParsedType.object && bType === ZodParsedType.object) {
    const bKeys = util.objectKeys(b);
    const sharedKeys = util.objectKeys(a).filter((key) => bKeys.indexOf(key) !== -1);
    const newObj = { ...a, ...b };
    for (const key of sharedKeys) {
      const sharedValue = mergeValues(a[key], b[key]);
      if (!sharedValue.valid) {
        return { valid: false };
      }
      newObj[key] = sharedValue.data;
    }
    return { valid: true, data: newObj };
  } else if (aType === ZodParsedType.array && bType === ZodParsedType.array) {
    if (a.length !== b.length) {
      return { valid: false };
    }
    const newArray = [];
    for (let index = 0; index < a.length; index++) {
      const itemA = a[index];
      const itemB = b[index];
      const sharedValue = mergeValues(itemA, itemB);
      if (!sharedValue.valid) {
        return { valid: false };
      }
      newArray.push(sharedValue.data);
    }
    return { valid: true, data: newArray };
  } else if (aType === ZodParsedType.date && bType === ZodParsedType.date && +a === +b) {
    return { valid: true, data: a };
  } else {
    return { valid: false };
  }
}
var ZodIntersection = class extends ZodType {
  _parse(input) {
    const { status, ctx } = this._processInputParams(input);
    const handleParsed = (parsedLeft, parsedRight) => {
      if (isAborted(parsedLeft) || isAborted(parsedRight)) {
        return INVALID;
      }
      const merged = mergeValues(parsedLeft.value, parsedRight.value);
      if (!merged.valid) {
        addIssueToContext(ctx, {
          code: ZodIssueCode.invalid_intersection_types
        });
        return INVALID;
      }
      if (isDirty(parsedLeft) || isDirty(parsedRight)) {
        status.dirty();
      }
      return { status: status.value, value: merged.data };
    };
    if (ctx.common.async) {
      return Promise.all([
        this._def.left._parseAsync({
          data: ctx.data,
          path: ctx.path,
          parent: ctx
        }),
        this._def.right._parseAsync({
          data: ctx.data,
          path: ctx.path,
          parent: ctx
        })
      ]).then(([left, right]) => handleParsed(left, right));
    } else {
      return handleParsed(this._def.left._parseSync({
        data: ctx.data,
        path: ctx.path,
        parent: ctx
      }), this._def.right._parseSync({
        data: ctx.data,
        path: ctx.path,
        parent: ctx
      }));
    }
  }
};
ZodIntersection.create = (left, right, params) => {
  return new ZodIntersection({
    left,
    right,
    typeName: ZodFirstPartyTypeKind.ZodIntersection,
    ...processCreateParams(params)
  });
};
var ZodTuple = class _ZodTuple extends ZodType {
  _parse(input) {
    const { status, ctx } = this._processInputParams(input);
    if (ctx.parsedType !== ZodParsedType.array) {
      addIssueToContext(ctx, {
        code: ZodIssueCode.invalid_type,
        expected: ZodParsedType.array,
        received: ctx.parsedType
      });
      return INVALID;
    }
    if (ctx.data.length < this._def.items.length) {
      addIssueToContext(ctx, {
        code: ZodIssueCode.too_small,
        minimum: this._def.items.length,
        inclusive: true,
        exact: false,
        type: "array"
      });
      return INVALID;
    }
    const rest = this._def.rest;
    if (!rest && ctx.data.length > this._def.items.length) {
      addIssueToContext(ctx, {
        code: ZodIssueCode.too_big,
        maximum: this._def.items.length,
        inclusive: true,
        exact: false,
        type: "array"
      });
      status.dirty();
    }
    const items = [...ctx.data].map((item, itemIndex) => {
      const schema = this._def.items[itemIndex] || this._def.rest;
      if (!schema)
        return null;
      return schema._parse(new ParseInputLazyPath(ctx, item, ctx.path, itemIndex));
    }).filter((x) => !!x);
    if (ctx.common.async) {
      return Promise.all(items).then((results) => {
        return ParseStatus.mergeArray(status, results);
      });
    } else {
      return ParseStatus.mergeArray(status, items);
    }
  }
  get items() {
    return this._def.items;
  }
  rest(rest) {
    return new _ZodTuple({
      ...this._def,
      rest
    });
  }
};
ZodTuple.create = (schemas, params) => {
  if (!Array.isArray(schemas)) {
    throw new Error("You must pass an array of schemas to z.tuple([ ... ])");
  }
  return new ZodTuple({
    items: schemas,
    typeName: ZodFirstPartyTypeKind.ZodTuple,
    rest: null,
    ...processCreateParams(params)
  });
};
var ZodRecord = class _ZodRecord extends ZodType {
  get keySchema() {
    return this._def.keyType;
  }
  get valueSchema() {
    return this._def.valueType;
  }
  _parse(input) {
    const { status, ctx } = this._processInputParams(input);
    if (ctx.parsedType !== ZodParsedType.object) {
      addIssueToContext(ctx, {
        code: ZodIssueCode.invalid_type,
        expected: ZodParsedType.object,
        received: ctx.parsedType
      });
      return INVALID;
    }
    const pairs = [];
    const keyType = this._def.keyType;
    const valueType = this._def.valueType;
    for (const key in ctx.data) {
      pairs.push({
        key: keyType._parse(new ParseInputLazyPath(ctx, key, ctx.path, key)),
        value: valueType._parse(new ParseInputLazyPath(ctx, ctx.data[key], ctx.path, key)),
        alwaysSet: key in ctx.data
      });
    }
    if (ctx.common.async) {
      return ParseStatus.mergeObjectAsync(status, pairs);
    } else {
      return ParseStatus.mergeObjectSync(status, pairs);
    }
  }
  get element() {
    return this._def.valueType;
  }
  static create(first, second, third) {
    if (second instanceof ZodType) {
      return new _ZodRecord({
        keyType: first,
        valueType: second,
        typeName: ZodFirstPartyTypeKind.ZodRecord,
        ...processCreateParams(third)
      });
    }
    return new _ZodRecord({
      keyType: ZodString.create(),
      valueType: first,
      typeName: ZodFirstPartyTypeKind.ZodRecord,
      ...processCreateParams(second)
    });
  }
};
var ZodMap = class extends ZodType {
  get keySchema() {
    return this._def.keyType;
  }
  get valueSchema() {
    return this._def.valueType;
  }
  _parse(input) {
    const { status, ctx } = this._processInputParams(input);
    if (ctx.parsedType !== ZodParsedType.map) {
      addIssueToContext(ctx, {
        code: ZodIssueCode.invalid_type,
        expected: ZodParsedType.map,
        received: ctx.parsedType
      });
      return INVALID;
    }
    const keyType = this._def.keyType;
    const valueType = this._def.valueType;
    const pairs = [...ctx.data.entries()].map(([key, value], index) => {
      return {
        key: keyType._parse(new ParseInputLazyPath(ctx, key, ctx.path, [index, "key"])),
        value: valueType._parse(new ParseInputLazyPath(ctx, value, ctx.path, [index, "value"]))
      };
    });
    if (ctx.common.async) {
      const finalMap = /* @__PURE__ */ new Map();
      return Promise.resolve().then(async () => {
        for (const pair of pairs) {
          const key = await pair.key;
          const value = await pair.value;
          if (key.status === "aborted" || value.status === "aborted") {
            return INVALID;
          }
          if (key.status === "dirty" || value.status === "dirty") {
            status.dirty();
          }
          finalMap.set(key.value, value.value);
        }
        return { status: status.value, value: finalMap };
      });
    } else {
      const finalMap = /* @__PURE__ */ new Map();
      for (const pair of pairs) {
        const key = pair.key;
        const value = pair.value;
        if (key.status === "aborted" || value.status === "aborted") {
          return INVALID;
        }
        if (key.status === "dirty" || value.status === "dirty") {
          status.dirty();
        }
        finalMap.set(key.value, value.value);
      }
      return { status: status.value, value: finalMap };
    }
  }
};
ZodMap.create = (keyType, valueType, params) => {
  return new ZodMap({
    valueType,
    keyType,
    typeName: ZodFirstPartyTypeKind.ZodMap,
    ...processCreateParams(params)
  });
};
var ZodSet = class _ZodSet extends ZodType {
  _parse(input) {
    const { status, ctx } = this._processInputParams(input);
    if (ctx.parsedType !== ZodParsedType.set) {
      addIssueToContext(ctx, {
        code: ZodIssueCode.invalid_type,
        expected: ZodParsedType.set,
        received: ctx.parsedType
      });
      return INVALID;
    }
    const def = this._def;
    if (def.minSize !== null) {
      if (ctx.data.size < def.minSize.value) {
        addIssueToContext(ctx, {
          code: ZodIssueCode.too_small,
          minimum: def.minSize.value,
          type: "set",
          inclusive: true,
          exact: false,
          message: def.minSize.message
        });
        status.dirty();
      }
    }
    if (def.maxSize !== null) {
      if (ctx.data.size > def.maxSize.value) {
        addIssueToContext(ctx, {
          code: ZodIssueCode.too_big,
          maximum: def.maxSize.value,
          type: "set",
          inclusive: true,
          exact: false,
          message: def.maxSize.message
        });
        status.dirty();
      }
    }
    const valueType = this._def.valueType;
    function finalizeSet(elements2) {
      const parsedSet = /* @__PURE__ */ new Set();
      for (const element of elements2) {
        if (element.status === "aborted")
          return INVALID;
        if (element.status === "dirty")
          status.dirty();
        parsedSet.add(element.value);
      }
      return { status: status.value, value: parsedSet };
    }
    const elements = [...ctx.data.values()].map((item, i) => valueType._parse(new ParseInputLazyPath(ctx, item, ctx.path, i)));
    if (ctx.common.async) {
      return Promise.all(elements).then((elements2) => finalizeSet(elements2));
    } else {
      return finalizeSet(elements);
    }
  }
  min(minSize, message) {
    return new _ZodSet({
      ...this._def,
      minSize: { value: minSize, message: errorUtil.toString(message) }
    });
  }
  max(maxSize, message) {
    return new _ZodSet({
      ...this._def,
      maxSize: { value: maxSize, message: errorUtil.toString(message) }
    });
  }
  size(size, message) {
    return this.min(size, message).max(size, message);
  }
  nonempty(message) {
    return this.min(1, message);
  }
};
ZodSet.create = (valueType, params) => {
  return new ZodSet({
    valueType,
    minSize: null,
    maxSize: null,
    typeName: ZodFirstPartyTypeKind.ZodSet,
    ...processCreateParams(params)
  });
};
var ZodFunction = class _ZodFunction extends ZodType {
  constructor() {
    super(...arguments);
    this.validate = this.implement;
  }
  _parse(input) {
    const { ctx } = this._processInputParams(input);
    if (ctx.parsedType !== ZodParsedType.function) {
      addIssueToContext(ctx, {
        code: ZodIssueCode.invalid_type,
        expected: ZodParsedType.function,
        received: ctx.parsedType
      });
      return INVALID;
    }
    function makeArgsIssue(args, error) {
      return makeIssue({
        data: args,
        path: ctx.path,
        errorMaps: [ctx.common.contextualErrorMap, ctx.schemaErrorMap, getErrorMap(), en_default].filter((x) => !!x),
        issueData: {
          code: ZodIssueCode.invalid_arguments,
          argumentsError: error
        }
      });
    }
    function makeReturnsIssue(returns, error) {
      return makeIssue({
        data: returns,
        path: ctx.path,
        errorMaps: [ctx.common.contextualErrorMap, ctx.schemaErrorMap, getErrorMap(), en_default].filter((x) => !!x),
        issueData: {
          code: ZodIssueCode.invalid_return_type,
          returnTypeError: error
        }
      });
    }
    const params = { errorMap: ctx.common.contextualErrorMap };
    const fn = ctx.data;
    if (this._def.returns instanceof ZodPromise) {
      const me = this;
      return OK(async function(...args) {
        const error = new ZodError([]);
        const parsedArgs = await me._def.args.parseAsync(args, params).catch((e) => {
          error.addIssue(makeArgsIssue(args, e));
          throw error;
        });
        const result = await Reflect.apply(fn, this, parsedArgs);
        const parsedReturns = await me._def.returns._def.type.parseAsync(result, params).catch((e) => {
          error.addIssue(makeReturnsIssue(result, e));
          throw error;
        });
        return parsedReturns;
      });
    } else {
      const me = this;
      return OK(function(...args) {
        const parsedArgs = me._def.args.safeParse(args, params);
        if (!parsedArgs.success) {
          throw new ZodError([makeArgsIssue(args, parsedArgs.error)]);
        }
        const result = Reflect.apply(fn, this, parsedArgs.data);
        const parsedReturns = me._def.returns.safeParse(result, params);
        if (!parsedReturns.success) {
          throw new ZodError([makeReturnsIssue(result, parsedReturns.error)]);
        }
        return parsedReturns.data;
      });
    }
  }
  parameters() {
    return this._def.args;
  }
  returnType() {
    return this._def.returns;
  }
  args(...items) {
    return new _ZodFunction({
      ...this._def,
      args: ZodTuple.create(items).rest(ZodUnknown.create())
    });
  }
  returns(returnType) {
    return new _ZodFunction({
      ...this._def,
      returns: returnType
    });
  }
  implement(func) {
    const validatedFunc = this.parse(func);
    return validatedFunc;
  }
  strictImplement(func) {
    const validatedFunc = this.parse(func);
    return validatedFunc;
  }
  static create(args, returns, params) {
    return new _ZodFunction({
      args: args ? args : ZodTuple.create([]).rest(ZodUnknown.create()),
      returns: returns || ZodUnknown.create(),
      typeName: ZodFirstPartyTypeKind.ZodFunction,
      ...processCreateParams(params)
    });
  }
};
var ZodLazy = class extends ZodType {
  get schema() {
    return this._def.getter();
  }
  _parse(input) {
    const { ctx } = this._processInputParams(input);
    const lazySchema = this._def.getter();
    return lazySchema._parse({ data: ctx.data, path: ctx.path, parent: ctx });
  }
};
ZodLazy.create = (getter, params) => {
  return new ZodLazy({
    getter,
    typeName: ZodFirstPartyTypeKind.ZodLazy,
    ...processCreateParams(params)
  });
};
var ZodLiteral = class extends ZodType {
  _parse(input) {
    if (input.data !== this._def.value) {
      const ctx = this._getOrReturnCtx(input);
      addIssueToContext(ctx, {
        received: ctx.data,
        code: ZodIssueCode.invalid_literal,
        expected: this._def.value
      });
      return INVALID;
    }
    return { status: "valid", value: input.data };
  }
  get value() {
    return this._def.value;
  }
};
ZodLiteral.create = (value, params) => {
  return new ZodLiteral({
    value,
    typeName: ZodFirstPartyTypeKind.ZodLiteral,
    ...processCreateParams(params)
  });
};
function createZodEnum(values, params) {
  return new ZodEnum({
    values,
    typeName: ZodFirstPartyTypeKind.ZodEnum,
    ...processCreateParams(params)
  });
}
var ZodEnum = class _ZodEnum extends ZodType {
  _parse(input) {
    if (typeof input.data !== "string") {
      const ctx = this._getOrReturnCtx(input);
      const expectedValues = this._def.values;
      addIssueToContext(ctx, {
        expected: util.joinValues(expectedValues),
        received: ctx.parsedType,
        code: ZodIssueCode.invalid_type
      });
      return INVALID;
    }
    if (!this._cache) {
      this._cache = new Set(this._def.values);
    }
    if (!this._cache.has(input.data)) {
      const ctx = this._getOrReturnCtx(input);
      const expectedValues = this._def.values;
      addIssueToContext(ctx, {
        received: ctx.data,
        code: ZodIssueCode.invalid_enum_value,
        options: expectedValues
      });
      return INVALID;
    }
    return OK(input.data);
  }
  get options() {
    return this._def.values;
  }
  get enum() {
    const enumValues = {};
    for (const val of this._def.values) {
      enumValues[val] = val;
    }
    return enumValues;
  }
  get Values() {
    const enumValues = {};
    for (const val of this._def.values) {
      enumValues[val] = val;
    }
    return enumValues;
  }
  get Enum() {
    const enumValues = {};
    for (const val of this._def.values) {
      enumValues[val] = val;
    }
    return enumValues;
  }
  extract(values, newDef = this._def) {
    return _ZodEnum.create(values, {
      ...this._def,
      ...newDef
    });
  }
  exclude(values, newDef = this._def) {
    return _ZodEnum.create(this.options.filter((opt) => !values.includes(opt)), {
      ...this._def,
      ...newDef
    });
  }
};
ZodEnum.create = createZodEnum;
var ZodNativeEnum = class extends ZodType {
  _parse(input) {
    const nativeEnumValues = util.getValidEnumValues(this._def.values);
    const ctx = this._getOrReturnCtx(input);
    if (ctx.parsedType !== ZodParsedType.string && ctx.parsedType !== ZodParsedType.number) {
      const expectedValues = util.objectValues(nativeEnumValues);
      addIssueToContext(ctx, {
        expected: util.joinValues(expectedValues),
        received: ctx.parsedType,
        code: ZodIssueCode.invalid_type
      });
      return INVALID;
    }
    if (!this._cache) {
      this._cache = new Set(util.getValidEnumValues(this._def.values));
    }
    if (!this._cache.has(input.data)) {
      const expectedValues = util.objectValues(nativeEnumValues);
      addIssueToContext(ctx, {
        received: ctx.data,
        code: ZodIssueCode.invalid_enum_value,
        options: expectedValues
      });
      return INVALID;
    }
    return OK(input.data);
  }
  get enum() {
    return this._def.values;
  }
};
ZodNativeEnum.create = (values, params) => {
  return new ZodNativeEnum({
    values,
    typeName: ZodFirstPartyTypeKind.ZodNativeEnum,
    ...processCreateParams(params)
  });
};
var ZodPromise = class extends ZodType {
  unwrap() {
    return this._def.type;
  }
  _parse(input) {
    const { ctx } = this._processInputParams(input);
    if (ctx.parsedType !== ZodParsedType.promise && ctx.common.async === false) {
      addIssueToContext(ctx, {
        code: ZodIssueCode.invalid_type,
        expected: ZodParsedType.promise,
        received: ctx.parsedType
      });
      return INVALID;
    }
    const promisified = ctx.parsedType === ZodParsedType.promise ? ctx.data : Promise.resolve(ctx.data);
    return OK(promisified.then((data) => {
      return this._def.type.parseAsync(data, {
        path: ctx.path,
        errorMap: ctx.common.contextualErrorMap
      });
    }));
  }
};
ZodPromise.create = (schema, params) => {
  return new ZodPromise({
    type: schema,
    typeName: ZodFirstPartyTypeKind.ZodPromise,
    ...processCreateParams(params)
  });
};
var ZodEffects = class extends ZodType {
  innerType() {
    return this._def.schema;
  }
  sourceType() {
    return this._def.schema._def.typeName === ZodFirstPartyTypeKind.ZodEffects ? this._def.schema.sourceType() : this._def.schema;
  }
  _parse(input) {
    const { status, ctx } = this._processInputParams(input);
    const effect = this._def.effect || null;
    const checkCtx = {
      addIssue: (arg) => {
        addIssueToContext(ctx, arg);
        if (arg.fatal) {
          status.abort();
        } else {
          status.dirty();
        }
      },
      get path() {
        return ctx.path;
      }
    };
    checkCtx.addIssue = checkCtx.addIssue.bind(checkCtx);
    if (effect.type === "preprocess") {
      const processed = effect.transform(ctx.data, checkCtx);
      if (ctx.common.async) {
        return Promise.resolve(processed).then(async (processed2) => {
          if (status.value === "aborted")
            return INVALID;
          const result = await this._def.schema._parseAsync({
            data: processed2,
            path: ctx.path,
            parent: ctx
          });
          if (result.status === "aborted")
            return INVALID;
          if (result.status === "dirty")
            return DIRTY(result.value);
          if (status.value === "dirty")
            return DIRTY(result.value);
          return result;
        });
      } else {
        if (status.value === "aborted")
          return INVALID;
        const result = this._def.schema._parseSync({
          data: processed,
          path: ctx.path,
          parent: ctx
        });
        if (result.status === "aborted")
          return INVALID;
        if (result.status === "dirty")
          return DIRTY(result.value);
        if (status.value === "dirty")
          return DIRTY(result.value);
        return result;
      }
    }
    if (effect.type === "refinement") {
      const executeRefinement = (acc) => {
        const result = effect.refinement(acc, checkCtx);
        if (ctx.common.async) {
          return Promise.resolve(result);
        }
        if (result instanceof Promise) {
          throw new Error("Async refinement encountered during synchronous parse operation. Use .parseAsync instead.");
        }
        return acc;
      };
      if (ctx.common.async === false) {
        const inner = this._def.schema._parseSync({
          data: ctx.data,
          path: ctx.path,
          parent: ctx
        });
        if (inner.status === "aborted")
          return INVALID;
        if (inner.status === "dirty")
          status.dirty();
        executeRefinement(inner.value);
        return { status: status.value, value: inner.value };
      } else {
        return this._def.schema._parseAsync({ data: ctx.data, path: ctx.path, parent: ctx }).then((inner) => {
          if (inner.status === "aborted")
            return INVALID;
          if (inner.status === "dirty")
            status.dirty();
          return executeRefinement(inner.value).then(() => {
            return { status: status.value, value: inner.value };
          });
        });
      }
    }
    if (effect.type === "transform") {
      if (ctx.common.async === false) {
        const base = this._def.schema._parseSync({
          data: ctx.data,
          path: ctx.path,
          parent: ctx
        });
        if (!isValid(base))
          return INVALID;
        const result = effect.transform(base.value, checkCtx);
        if (result instanceof Promise) {
          throw new Error(`Asynchronous transform encountered during synchronous parse operation. Use .parseAsync instead.`);
        }
        return { status: status.value, value: result };
      } else {
        return this._def.schema._parseAsync({ data: ctx.data, path: ctx.path, parent: ctx }).then((base) => {
          if (!isValid(base))
            return INVALID;
          return Promise.resolve(effect.transform(base.value, checkCtx)).then((result) => ({
            status: status.value,
            value: result
          }));
        });
      }
    }
    util.assertNever(effect);
  }
};
ZodEffects.create = (schema, effect, params) => {
  return new ZodEffects({
    schema,
    typeName: ZodFirstPartyTypeKind.ZodEffects,
    effect,
    ...processCreateParams(params)
  });
};
ZodEffects.createWithPreprocess = (preprocess, schema, params) => {
  return new ZodEffects({
    schema,
    effect: { type: "preprocess", transform: preprocess },
    typeName: ZodFirstPartyTypeKind.ZodEffects,
    ...processCreateParams(params)
  });
};
var ZodOptional = class extends ZodType {
  _parse(input) {
    const parsedType = this._getType(input);
    if (parsedType === ZodParsedType.undefined) {
      return OK(void 0);
    }
    return this._def.innerType._parse(input);
  }
  unwrap() {
    return this._def.innerType;
  }
};
ZodOptional.create = (type, params) => {
  return new ZodOptional({
    innerType: type,
    typeName: ZodFirstPartyTypeKind.ZodOptional,
    ...processCreateParams(params)
  });
};
var ZodNullable = class extends ZodType {
  _parse(input) {
    const parsedType = this._getType(input);
    if (parsedType === ZodParsedType.null) {
      return OK(null);
    }
    return this._def.innerType._parse(input);
  }
  unwrap() {
    return this._def.innerType;
  }
};
ZodNullable.create = (type, params) => {
  return new ZodNullable({
    innerType: type,
    typeName: ZodFirstPartyTypeKind.ZodNullable,
    ...processCreateParams(params)
  });
};
var ZodDefault = class extends ZodType {
  _parse(input) {
    const { ctx } = this._processInputParams(input);
    let data = ctx.data;
    if (ctx.parsedType === ZodParsedType.undefined) {
      data = this._def.defaultValue();
    }
    return this._def.innerType._parse({
      data,
      path: ctx.path,
      parent: ctx
    });
  }
  removeDefault() {
    return this._def.innerType;
  }
};
ZodDefault.create = (type, params) => {
  return new ZodDefault({
    innerType: type,
    typeName: ZodFirstPartyTypeKind.ZodDefault,
    defaultValue: typeof params.default === "function" ? params.default : () => params.default,
    ...processCreateParams(params)
  });
};
var ZodCatch = class extends ZodType {
  _parse(input) {
    const { ctx } = this._processInputParams(input);
    const newCtx = {
      ...ctx,
      common: {
        ...ctx.common,
        issues: []
      }
    };
    const result = this._def.innerType._parse({
      data: newCtx.data,
      path: newCtx.path,
      parent: {
        ...newCtx
      }
    });
    if (isAsync(result)) {
      return result.then((result2) => {
        return {
          status: "valid",
          value: result2.status === "valid" ? result2.value : this._def.catchValue({
            get error() {
              return new ZodError(newCtx.common.issues);
            },
            input: newCtx.data
          })
        };
      });
    } else {
      return {
        status: "valid",
        value: result.status === "valid" ? result.value : this._def.catchValue({
          get error() {
            return new ZodError(newCtx.common.issues);
          },
          input: newCtx.data
        })
      };
    }
  }
  removeCatch() {
    return this._def.innerType;
  }
};
ZodCatch.create = (type, params) => {
  return new ZodCatch({
    innerType: type,
    typeName: ZodFirstPartyTypeKind.ZodCatch,
    catchValue: typeof params.catch === "function" ? params.catch : () => params.catch,
    ...processCreateParams(params)
  });
};
var ZodNaN = class extends ZodType {
  _parse(input) {
    const parsedType = this._getType(input);
    if (parsedType !== ZodParsedType.nan) {
      const ctx = this._getOrReturnCtx(input);
      addIssueToContext(ctx, {
        code: ZodIssueCode.invalid_type,
        expected: ZodParsedType.nan,
        received: ctx.parsedType
      });
      return INVALID;
    }
    return { status: "valid", value: input.data };
  }
};
ZodNaN.create = (params) => {
  return new ZodNaN({
    typeName: ZodFirstPartyTypeKind.ZodNaN,
    ...processCreateParams(params)
  });
};
var BRAND = Symbol("zod_brand");
var ZodBranded = class extends ZodType {
  _parse(input) {
    const { ctx } = this._processInputParams(input);
    const data = ctx.data;
    return this._def.type._parse({
      data,
      path: ctx.path,
      parent: ctx
    });
  }
  unwrap() {
    return this._def.type;
  }
};
var ZodPipeline = class _ZodPipeline extends ZodType {
  _parse(input) {
    const { status, ctx } = this._processInputParams(input);
    if (ctx.common.async) {
      const handleAsync = async () => {
        const inResult = await this._def.in._parseAsync({
          data: ctx.data,
          path: ctx.path,
          parent: ctx
        });
        if (inResult.status === "aborted")
          return INVALID;
        if (inResult.status === "dirty") {
          status.dirty();
          return DIRTY(inResult.value);
        } else {
          return this._def.out._parseAsync({
            data: inResult.value,
            path: ctx.path,
            parent: ctx
          });
        }
      };
      return handleAsync();
    } else {
      const inResult = this._def.in._parseSync({
        data: ctx.data,
        path: ctx.path,
        parent: ctx
      });
      if (inResult.status === "aborted")
        return INVALID;
      if (inResult.status === "dirty") {
        status.dirty();
        return {
          status: "dirty",
          value: inResult.value
        };
      } else {
        return this._def.out._parseSync({
          data: inResult.value,
          path: ctx.path,
          parent: ctx
        });
      }
    }
  }
  static create(a, b) {
    return new _ZodPipeline({
      in: a,
      out: b,
      typeName: ZodFirstPartyTypeKind.ZodPipeline
    });
  }
};
var ZodReadonly = class extends ZodType {
  _parse(input) {
    const result = this._def.innerType._parse(input);
    const freeze = (data) => {
      if (isValid(data)) {
        data.value = Object.freeze(data.value);
      }
      return data;
    };
    return isAsync(result) ? result.then((data) => freeze(data)) : freeze(result);
  }
  unwrap() {
    return this._def.innerType;
  }
};
ZodReadonly.create = (type, params) => {
  return new ZodReadonly({
    innerType: type,
    typeName: ZodFirstPartyTypeKind.ZodReadonly,
    ...processCreateParams(params)
  });
};
function cleanParams(params, data) {
  const p = typeof params === "function" ? params(data) : typeof params === "string" ? { message: params } : params;
  const p2 = typeof p === "string" ? { message: p } : p;
  return p2;
}
function custom(check, _params = {}, fatal) {
  if (check)
    return ZodAny.create().superRefine((data, ctx) => {
      const r = check(data);
      if (r instanceof Promise) {
        return r.then((r2) => {
          if (!r2) {
            const params = cleanParams(_params, data);
            const _fatal = params.fatal ?? fatal ?? true;
            ctx.addIssue({ code: "custom", ...params, fatal: _fatal });
          }
        });
      }
      if (!r) {
        const params = cleanParams(_params, data);
        const _fatal = params.fatal ?? fatal ?? true;
        ctx.addIssue({ code: "custom", ...params, fatal: _fatal });
      }
      return;
    });
  return ZodAny.create();
}
var late = {
  object: ZodObject.lazycreate
};
var ZodFirstPartyTypeKind;
(function(ZodFirstPartyTypeKind2) {
  ZodFirstPartyTypeKind2["ZodString"] = "ZodString";
  ZodFirstPartyTypeKind2["ZodNumber"] = "ZodNumber";
  ZodFirstPartyTypeKind2["ZodNaN"] = "ZodNaN";
  ZodFirstPartyTypeKind2["ZodBigInt"] = "ZodBigInt";
  ZodFirstPartyTypeKind2["ZodBoolean"] = "ZodBoolean";
  ZodFirstPartyTypeKind2["ZodDate"] = "ZodDate";
  ZodFirstPartyTypeKind2["ZodSymbol"] = "ZodSymbol";
  ZodFirstPartyTypeKind2["ZodUndefined"] = "ZodUndefined";
  ZodFirstPartyTypeKind2["ZodNull"] = "ZodNull";
  ZodFirstPartyTypeKind2["ZodAny"] = "ZodAny";
  ZodFirstPartyTypeKind2["ZodUnknown"] = "ZodUnknown";
  ZodFirstPartyTypeKind2["ZodNever"] = "ZodNever";
  ZodFirstPartyTypeKind2["ZodVoid"] = "ZodVoid";
  ZodFirstPartyTypeKind2["ZodArray"] = "ZodArray";
  ZodFirstPartyTypeKind2["ZodObject"] = "ZodObject";
  ZodFirstPartyTypeKind2["ZodUnion"] = "ZodUnion";
  ZodFirstPartyTypeKind2["ZodDiscriminatedUnion"] = "ZodDiscriminatedUnion";
  ZodFirstPartyTypeKind2["ZodIntersection"] = "ZodIntersection";
  ZodFirstPartyTypeKind2["ZodTuple"] = "ZodTuple";
  ZodFirstPartyTypeKind2["ZodRecord"] = "ZodRecord";
  ZodFirstPartyTypeKind2["ZodMap"] = "ZodMap";
  ZodFirstPartyTypeKind2["ZodSet"] = "ZodSet";
  ZodFirstPartyTypeKind2["ZodFunction"] = "ZodFunction";
  ZodFirstPartyTypeKind2["ZodLazy"] = "ZodLazy";
  ZodFirstPartyTypeKind2["ZodLiteral"] = "ZodLiteral";
  ZodFirstPartyTypeKind2["ZodEnum"] = "ZodEnum";
  ZodFirstPartyTypeKind2["ZodEffects"] = "ZodEffects";
  ZodFirstPartyTypeKind2["ZodNativeEnum"] = "ZodNativeEnum";
  ZodFirstPartyTypeKind2["ZodOptional"] = "ZodOptional";
  ZodFirstPartyTypeKind2["ZodNullable"] = "ZodNullable";
  ZodFirstPartyTypeKind2["ZodDefault"] = "ZodDefault";
  ZodFirstPartyTypeKind2["ZodCatch"] = "ZodCatch";
  ZodFirstPartyTypeKind2["ZodPromise"] = "ZodPromise";
  ZodFirstPartyTypeKind2["ZodBranded"] = "ZodBranded";
  ZodFirstPartyTypeKind2["ZodPipeline"] = "ZodPipeline";
  ZodFirstPartyTypeKind2["ZodReadonly"] = "ZodReadonly";
})(ZodFirstPartyTypeKind || (ZodFirstPartyTypeKind = {}));
var instanceOfType = (cls, params = {
  message: `Input not instance of ${cls.name}`
}) => custom((data) => data instanceof cls, params);
var stringType = ZodString.create;
var numberType = ZodNumber.create;
var nanType = ZodNaN.create;
var bigIntType = ZodBigInt.create;
var booleanType = ZodBoolean.create;
var dateType = ZodDate.create;
var symbolType = ZodSymbol.create;
var undefinedType = ZodUndefined.create;
var nullType = ZodNull.create;
var anyType = ZodAny.create;
var unknownType = ZodUnknown.create;
var neverType = ZodNever.create;
var voidType = ZodVoid.create;
var arrayType = ZodArray.create;
var objectType = ZodObject.create;
var strictObjectType = ZodObject.strictCreate;
var unionType = ZodUnion.create;
var discriminatedUnionType = ZodDiscriminatedUnion.create;
var intersectionType = ZodIntersection.create;
var tupleType = ZodTuple.create;
var recordType = ZodRecord.create;
var mapType = ZodMap.create;
var setType = ZodSet.create;
var functionType = ZodFunction.create;
var lazyType = ZodLazy.create;
var literalType = ZodLiteral.create;
var enumType = ZodEnum.create;
var nativeEnumType = ZodNativeEnum.create;
var promiseType = ZodPromise.create;
var effectsType = ZodEffects.create;
var optionalType = ZodOptional.create;
var nullableType = ZodNullable.create;
var preprocessType = ZodEffects.createWithPreprocess;
var pipelineType = ZodPipeline.create;
var ostring = () => stringType().optional();
var onumber = () => numberType().optional();
var oboolean = () => booleanType().optional();
var coerce = {
  string: ((arg) => ZodString.create({ ...arg, coerce: true })),
  number: ((arg) => ZodNumber.create({ ...arg, coerce: true })),
  boolean: ((arg) => ZodBoolean.create({
    ...arg,
    coerce: true
  })),
  bigint: ((arg) => ZodBigInt.create({ ...arg, coerce: true })),
  date: ((arg) => ZodDate.create({ ...arg, coerce: true }))
};
var NEVER = INVALID;

// ../../node_modules/.pnpm/zod@3.25.76/node_modules/zod/index.js
var zod_default = external_exports;

// src/lib/utils/regex.ts
var nameRegex = /^[0-9a-zA-ZàáâäãåąčćęèéêëėįìíîïłńòóôöõøùúûüųūÿýżźñçčšžÀÁÂÄÃÅĄĆČĖĘÈÉÊËÌÍÎÏĮŁŃÒÓÔÖÕØÙÚÛÜŲŪŸÝŻŹÑßÇŒÆČŠŽ∂ð\u0400-\u04FF (),.'&-]+$/u;
var exceptionLocalizedTextRegex = /^[0-9a-zA-ZàáâäãåąčćęèéêëėįìíîïłńòóôöõøùúûüųūÿýżźñçčšžÀÁÂÄÃÅĄĆČĖĘÈÉÊËÌÍÎÏĮŁŃÒÓÔÖÕØÙÚÛÜŲŪŸÝŻŹÑßÇŒÆČŠŽ∂ð\u0400-\u04FF (),.'&\/-]+$/u;
var keyRegex = /^[0-9a-zA-Z\u0400-\u04FF_-]+$/u;
var phoneRegex = /^[+][\d ]{10,18}$/;
var stringRegex = /^[0-9a-zA-ZåäöÅÄÖ\u0400-\u04FF \n=_(),.?!:\/'‘’"“”+-]*$/u;
var multilineTextRegex = /^[0-9a-zA-ZàáâäãåąčćęèéêëėįìíîïłńòóôöõøùúûüųūÿýżźñçčšžÀÁÂÄÃÅĄĆČĖĘÈÉÊËÌÍÎÏĮŁŃÒÓÔÖÕØÙÚÛÜŲŪŸÝŻŹÑßÇŒÆČŠŽ∂ð\u0400-\u04FF \r\n=_(),.?!:;\/'‘’"“”+%°&*#…–-]*$/u;
var optionalRegex = (regex) => zod_exports.string().refine((value) => !value || regex.test(value)).optional().nullable();
var optionalPhoneRegex = optionalRegex(phoneRegex);
var optionalStringRegex = optionalRegex(stringRegex);
var optionalExceptionLocalizedTextRegex = optionalRegex(
  exceptionLocalizedTextRegex
);

// src/lib/schemas/absenceType.schema.ts
var absenceTypeSchema = zod_exports.object({
  id: zod_exports.string(),
  code: zod_exports.string(),
  name: zod_exports.string(),
  description: zod_exports.string().nullable(),
  requiresApproval: zod_exports.coerce.number(),
  archived: zod_exports.coerce.number()
});
var absenceTypeCreateSchema = zod_exports.object({
  code: zod_exports.string().trim().min(1).max(100).regex(keyRegex),
  name: zod_exports.string().trim().min(1).max(255).regex(exceptionLocalizedTextRegex),
  description: optionalStringRegex,
  requiresApproval: zod_exports.number().int().min(0).max(1)
});

// src/lib/schemas/applicationMessage.schema.ts
var ApplicationMessageKey = /* @__PURE__ */ ((ApplicationMessageKey2) => {
  ApplicationMessageKey2["RECEIPTS"] = "receipts";
  ApplicationMessageKey2["SICK_LEAVE"] = "sickLeaveCertificate";
  ApplicationMessageKey2["TRAFFIC_ACCIDENTS"] = "trafficAccidents";
  return ApplicationMessageKey2;
})(ApplicationMessageKey || {});
var applicationMessageSchema = zod_exports.object({
  title: zod_exports.string(),
  message: zod_exports.string()
});
var trafficAccidentMessageSchema = zod_exports.object({
  title: zod_exports.string(),
  message: zod_exports.string(),
  accidentLocation: zod_exports.string(),
  otherPartyName: zod_exports.string().optional(),
  otherPartyPhone: zod_exports.string().optional(),
  otherPartyEmail: zod_exports.string().optional(),
  otherPartyOtherInfo: zod_exports.string().optional()
});

// src/lib/schemas/applicationRole.schema.ts
var roleCreationAttributesSchema = zod_exports.object({
  id: zod_exports.string().uuid(),
  applicationId: zod_exports.string().uuid(),
  organisationId: zod_exports.string().uuid(),
  name: zod_exports.string().regex(nameRegex),
  description: optionalStringRegex,
  phone: optionalPhoneRegex,
  createdTime: zod_exports.coerce.date(),
  createdBy: zod_exports.string().uuid(),
  modifiedTime: zod_exports.coerce.date().nullable(),
  modifiedBy: zod_exports.string().uuid().nullable(),
  archived: zod_exports.number()
});
var applicationRoleSchema = roleCreationAttributesSchema.extend({
  useRights: zod_exports.string().array(),
  exceptionClasses: zod_exports.string().array(),
  shipmentMessageCountries: zod_exports.string().array(),
  terminalIds: zod_exports.string().array()
});
var roleGroupSchema = zod_exports.object({
  id: zod_exports.string().uuid(),
  name: zod_exports.string()
});
var roleUserSchema = zod_exports.object({
  id: zod_exports.string().uuid(),
  firstName: zod_exports.string().optional().nullable(),
  lastName: zod_exports.string().optional().nullable(),
  title: optionalStringRegex,
  phone: optionalPhoneRegex,
  email: zod_exports.string().email(),
  avatar: zod_exports.string().optional().nullable(),
  archived: zod_exports.number().optional().nullable(),
  endDate: zod_exports.string().optional().nullable(),
  groups: zod_exports.array(roleGroupSchema)
});
var roleUsersSchema = zod_exports.array(roleUserSchema);
var roleCreateSchema = applicationRoleSchema.pick({
  name: true,
  description: true,
  phone: true,
  useRights: true,
  exceptionClasses: true,
  shipmentMessageCountries: true,
  terminalIds: true
});
var roleUpdateSchema = roleCreateSchema.partial();
var applicationRolesSchema = zod_exports.array(applicationRoleSchema);
var addUsersToRoleSchema = zod_exports.object({
  userIds: zod_exports.array(zod_exports.string().uuid()).min(1)
});

// src/lib/schemas/applicationRoleUseRight.schema.ts
var applicationRoleUseRightSchema = zod_exports.object({
  id: zod_exports.string().uuid().optional(),
  applicationRoleId: zod_exports.string().uuid(),
  useRightId: zod_exports.string().uuid(),
  startDate: zod_exports.date(),
  endDate: zod_exports.date().nullish(),
  createdTime: zod_exports.coerce.date().optional(),
  createdBy: zod_exports.string().uuid().optional(),
  modifiedTime: zod_exports.coerce.date().optional().nullable(),
  modifiedBy: zod_exports.string().uuid().optional().nullable(),
  archived: zod_exports.number().optional()
});
var applicationRoleUseRightsSchema = zod_exports.array(
  applicationRoleUseRightSchema
);
var applicationRoleUseRightsUpdateItemSchema = zod_exports.object({
  applicationRoleId: zod_exports.string().uuid(),
  useRightIds: zod_exports.array(zod_exports.string().uuid())
});
var applicationRoleUseRightsUpdateSchema = zod_exports.object({
  roles: zod_exports.array(applicationRoleUseRightsUpdateItemSchema).min(1)
});

// src/lib/schemas/auth.schema.ts
var authSchema = zod_exports.object({
  id: zod_exports.string().uuid(),
  email: zod_exports.string().email().optional(),
  token: zod_exports.string().optional()
});

// src/lib/schemas/bulkUpdateDocument.schema.ts
var bulkUpdateDocumentSchema = zod_exports.object({
  updates: zod_exports.array(
    zod_exports.object({
      documentId: zod_exports.string().uuid(),
      viewAdminOnly: zod_exports.number().int().min(0).max(1)
    })
  )
});

// src/lib/schemas/common.schema.ts
var emailSchema = zod_exports.string().email();
var idSchema = zod_exports.string().uuid();
var idsSchema = zod_exports.array(idSchema);
var langSchema = zod_exports.enum([
  "bg",
  "da",
  "de",
  "ee",
  "en",
  "es",
  "fi",
  "fr",
  "it",
  "lt",
  "lv",
  "nl",
  "pl",
  "ro",
  "ru",
  "se"
]);
var numberSchema = zod_exports.number();

// src/lib/schemas/company.schema.ts
var companySchema = zod_exports.object({
  id: zod_exports.string().uuid(),
  organisationApplicationID: zod_exports.string().uuid(),
  tpRelationNr: zod_exports.number(),
  name: zod_exports.string(),
  remarks: zod_exports.string().nullable(),
  creditor: zod_exports.number().nullable(),
  createdTime: zod_exports.coerce.date(),
  createdBy: zod_exports.string().uuid(),
  modifiedTime: zod_exports.coerce.date().optional().nullable(),
  modifiedBy: zod_exports.string().uuid().optional().nullable(),
  archived: zod_exports.number()
});
var companiesSchema = zod_exports.array(companySchema);

// src/lib/schemas/message.schema.ts
var messageSchema = zod_exports.object({
  id: zod_exports.string().uuid().optional(),
  organisationApplicationId: zod_exports.string().uuid(),
  discussionId: zod_exports.string().uuid().optional(),
  messageTypeId: zod_exports.string().uuid(),
  pinned: zod_exports.number().optional(),
  message: zod_exports.string().optional(),
  senderName: zod_exports.string().optional(),
  senderAvatar: zod_exports.string().optional(),
  createdTime: zod_exports.date().optional(),
  createdBy: zod_exports.string().optional(),
  modifiedTime: zod_exports.date().optional().nullable(),
  modifiedBy: zod_exports.string().optional().nullable(),
  archived: zod_exports.number().optional(),
  unread: zod_exports.boolean().optional(),
  attachments: zod_exports.array(
    zod_exports.object({
      id: zod_exports.string().uuid(),
      organisationApplicationId: zod_exports.string().uuid(),
      messageId: zod_exports.string().uuid(),
      documentId: zod_exports.string().uuid(),
      createdTime: zod_exports.date().optional(),
      createdBy: zod_exports.string().optional(),
      modifiedTime: zod_exports.date().optional().nullable(),
      modifiedBy: zod_exports.string().optional().nullable(),
      archived: zod_exports.number().optional(),
      document: zod_exports.object({
        id: zod_exports.string().uuid(),
        url: zod_exports.string().url()
      }).optional(),
      attachmentBase64: zod_exports.string().optional(),
      attachmentMimeType: zod_exports.string().optional(),
      attachmentBlob: zod_exports.instanceof(Blob).optional()
    })
  ).optional(),
  recipients: zod_exports.array(
    zod_exports.object({
      id: zod_exports.string().uuid(),
      organisationApplicationId: zod_exports.string().uuid(),
      messageId: zod_exports.string().uuid(),
      userId: zod_exports.string().uuid(),
      read: zod_exports.date().optional().nullable(),
      confirmed: zod_exports.date().optional().nullable(),
      createdTime: zod_exports.date().optional(),
      createdBy: zod_exports.string().optional(),
      modifiedTime: zod_exports.date().optional().nullable(),
      modifiedBy: zod_exports.string().optional().nullable(),
      archived: zod_exports.number().optional()
    })
  ).optional()
});
var messageCreateSchema = zod_exports.object({
  discussionId: zod_exports.string().max(50).optional(),
  context: zod_exports.nativeEnum(DiscussionContextType).optional(),
  contextId: zod_exports.string().max(50).optional(),
  messageTypeKey: zod_exports.nativeEnum(MessageTypeKey),
  pinned: zod_exports.number().optional(),
  message: zod_exports.string().optional()
});
var messageSendResponseSchema = zod_exports.object({
  id: zod_exports.string().uuid(),
  message: zod_exports.string(),
  discussionId: zod_exports.string().uuid().optional()
});
var messageUpdateSchema = zod_exports.object({
  message: zod_exports.string()
});

// src/lib/schemas/discussion.schema.ts
var discussionSchema = zod_exports.object({
  id: zod_exports.string().uuid().optional(),
  organisationApplicationId: zod_exports.string().uuid(),
  discussionType: zod_exports.nativeEnum(DiscussionType),
  parentDiscussionId: zod_exports.string().uuid().optional(),
  title: zod_exports.string().max(255).optional(),
  description: zod_exports.string().optional(),
  createdTime: zod_exports.date().optional(),
  createdBy: zod_exports.string().uuid().optional(),
  modifiedTime: zod_exports.date().optional().nullable(),
  modifiedBy: zod_exports.string().uuid().optional().nullable(),
  archived: zod_exports.number().optional()
});
var discussionSummarySchema = zod_exports.object({
  id: zod_exports.string().uuid(),
  discussionType: zod_exports.nativeEnum(DiscussionType),
  context: zod_exports.nativeEnum(DiscussionContextType).nullable().optional(),
  contextId: zod_exports.string().nullable().optional(),
  title: zod_exports.string().nullable().optional(),
  description: zod_exports.string().nullable().optional(),
  lastMessageCreatedBy: zod_exports.string().uuid().nullable(),
  lastMessageCreatedTime: zod_exports.date().nullable(),
  lastMessage: zod_exports.string().nullable(),
  lastMessageSenderAvatar: zod_exports.string().nullable(),
  lastMessageSenderInitials: zod_exports.string().nullable(),
  lastMessageSenderName: zod_exports.string().nullable(),
  isRead: zod_exports.number().nullable(),
  isConfirmed: zod_exports.number().nullable(),
  participantAvatar: zod_exports.string().nullable().optional(),
  participantInitials: zod_exports.string().nullable().optional(),
  participantName: zod_exports.string().nullable().optional(),
  participantEmail: zod_exports.string().nullable().optional(),
  unreadMessageCount: zod_exports.number().nullable(),
  stopActivityKind: zod_exports.string().nullable().optional(),
  titleTrailers: zod_exports.string().nullable().optional(),
  titleTrucks: zod_exports.string().nullable().optional(),
  titleDrivers: zod_exports.string().nullable().optional(),
  titleSender: zod_exports.string().nullable().optional(),
  titleReceiver: zod_exports.string().nullable().optional()
});
var discussionCreateSchema = zod_exports.object({
  discussionType: zod_exports.nativeEnum(DiscussionType).optional(),
  countryCode: zod_exports.string().optional(),
  applicationRoleId: zod_exports.string().uuid().optional(),
  participants: zod_exports.array(zod_exports.string().uuid()).optional(),
  title: zod_exports.string().optional(),
  description: zod_exports.string().optional(),
  message: zod_exports.string().optional(),
  latitude: zod_exports.string().optional(),
  longitude: zod_exports.string().optional()
});
var discussionMessagesSchema = zod_exports.object({
  id: zod_exports.string().uuid(),
  discussionType: zod_exports.nativeEnum(DiscussionType),
  contextType: zod_exports.string().optional(),
  context: zod_exports.nativeEnum(DiscussionContextType).optional(),
  stopActivityKind: zod_exports.string().nullable().optional(),
  title: zod_exports.string().max(255),
  description: zod_exports.string().optional(),
  image: optionalStringRegex,
  participantName: zod_exports.string().optional(),
  phone: zod_exports.string().optional(),
  unreadMessages: zod_exports.boolean().optional(),
  messages: zod_exports.array(messageSchema).optional()
});
var relatedContextCreateSchema = zod_exports.object({
  context: zod_exports.string(),
  contextId: zod_exports.string(),
  description: zod_exports.string()
});
var tripContextSchema = zod_exports.object({
  id: zod_exports.string(),
  tripIdentifier: zod_exports.string(),
  beginDateTime: zod_exports.string(),
  nextStopCountryCode: zod_exports.string().nullable(),
  temperatureSetPoints: zod_exports.string(),
  trailers: zod_exports.string(),
  trucks: zod_exports.string(),
  drivers: zod_exports.string()
});
var stopContextSchema = zod_exports.object({
  id: zod_exports.string(),
  resourceCombinationId: zod_exports.string(),
  activityString: zod_exports.string(),
  plannedDateTime: zod_exports.string(),
  palletGroupDescription: zod_exports.string(),
  temperatureSetPoint: zod_exports.string(),
  mailId: zod_exports.string(),
  bookingId: zod_exports.string(),
  sender: zod_exports.string().nullable(),
  senderName: zod_exports.string().nullable(),
  receiver: zod_exports.string().nullable(),
  receiverName: zod_exports.string().nullable(),
  productDescription: zod_exports.string(),
  locationName: zod_exports.string().nullable(),
  locationAddress: zod_exports.string().nullable(),
  locationZipCode: zod_exports.string().nullable(),
  locationCityName: zod_exports.string().nullable(),
  countryCode: zod_exports.string().nullable(),
  temperatureMin: zod_exports.number().nullable(),
  temperatureMax: zod_exports.number().nullable()
});
var tripActivityContextSchema = zod_exports.object({
  countryCode: zod_exports.string().nullable(),
  palletGroupDescription: zod_exports.string(),
  sender: zod_exports.string().nullable(),
  receiver: zod_exports.string().nullable(),
  senderName: zod_exports.string().nullable(),
  receiverName: zod_exports.string().nullable(),
  mailId: zod_exports.string().nullable().optional(),
  bookingId: zod_exports.string().nullable().optional()
});
var discussionContextSchema = zod_exports.object({
  context: zod_exports.string().optional(),
  contextId: zod_exports.string().optional(),
  tripId: zod_exports.string().optional(),
  time: zod_exports.string().optional(),
  trailer: zod_exports.string().optional(),
  truck: zod_exports.string().optional(),
  driver: zod_exports.string().optional(),
  activityKind: zod_exports.string().optional(),
  locationAddress: zod_exports.string().optional(),
  locationName: zod_exports.string().optional(),
  locationZipCode: zod_exports.string().optional(),
  locationCityName: zod_exports.string().optional(),
  countryCode: zod_exports.string().optional(),
  receiver: zod_exports.string().optional(),
  receiverName: zod_exports.string().optional(),
  sender: zod_exports.string().optional(),
  senderName: zod_exports.string().optional(),
  mailId: zod_exports.string().optional(),
  bookingId: zod_exports.string().optional(),
  temperatureMax: zod_exports.number().optional(),
  temperatureMin: zod_exports.number().optional(),
  plannedDateTime: zod_exports.string().optional(),
  palletGroupDescription: zod_exports.string().optional(),
  productDescription: zod_exports.string().optional()
});

// src/lib/schemas/discussionParticipant.schema.ts
var discussionParticipantSchema = zod_exports.object({
  id: zod_exports.string().max(50).optional(),
  organisationApplicationId: zod_exports.string().max(50),
  discussionId: zod_exports.string().max(50).optional(),
  userId: zod_exports.string().max(50).optional(),
  applicationRoleId: zod_exports.string().max(50).optional(),
  createdTime: zod_exports.date().optional(),
  createdBy: zod_exports.string().max(50).optional(),
  modifiedTime: zod_exports.date().optional().nullable(),
  modifiedBy: zod_exports.string().max(50).optional().nullable(),
  archived: zod_exports.number().optional()
});
var discussionParticipantRemoveSchema = zod_exports.object({
  discussionId: zod_exports.string().uuid(),
  userId: zod_exports.string().uuid().optional(),
  applicationRoleId: zod_exports.string().uuid().optional()
});
var discussionParticipantSummarySchema = zod_exports.object({
  id: zod_exports.string().uuid(),
  firstName: zod_exports.string().nullable().optional(),
  lastName: zod_exports.string().nullable().optional(),
  email: zod_exports.string().email(),
  avatar: zod_exports.string().nullable().optional(),
  phone: zod_exports.string().nullable().optional(),
  role: zod_exports.string().nullable().optional()
});

// src/lib/schemas/document.schema.ts
var documentSchema = zod_exports.object({
  id: zod_exports.string().uuid(),
  organisationApplicationId: zod_exports.string().uuid(),
  contextId: zod_exports.string().uuid(),
  documentTypeId: zod_exports.string().uuid(),
  tpDocumentNr: zod_exports.number(),
  order: zod_exports.number(),
  title: zod_exports.string().nullable(),
  description: zod_exports.string().nullable(),
  viewAdminOnly: zod_exports.number().default(0),
  url: zod_exports.string(),
  createdTime: zod_exports.coerce.date(),
  createdBy: zod_exports.string().uuid(),
  modifiedTime: zod_exports.coerce.date(),
  modifiedBy: zod_exports.string().uuid(),
  archived: zod_exports.number()
});
var createDocumentCMRSchema = zod_exports.array(
  documentSchema.extend({
    description: zod_exports.string().nullable().optional()
  })
);
var createDocumentTrailerPhotoSchema = zod_exports.array(
  documentSchema.omit({
    modifiedTime: true,
    modifiedBy: true,
    documentTypeId: true,
    tpDocumentNr: true
  }).extend({
    description: zod_exports.string().nullable().optional()
  })
);

// src/lib/schemas/driver.schema.ts
var driverSchema = zod_exports.object({
  id: zod_exports.string().uuid(),
  userId: zod_exports.string().uuid().nullable(),
  firstName: zod_exports.string(),
  lastName: zod_exports.string()
});

// src/lib/utils/date.ts
import dayjs from "dayjs";
import isoWeek from "dayjs/plugin/isoWeek.js";
import utc from "dayjs/plugin/utc.js";
dayjs.extend(utc);
dayjs.extend(isoWeek);
var getDateString = (date, format = "YYYY-MM-DD 00:00:00", utc2 = false) => {
  if (utc2) {
    return date ? dayjs(date).utc().format(format) : null;
  }
  return date ? dayjs(date).format(format) : null;
};
var getCurrentDateAndTime = () => {
  const now = /* @__PURE__ */ new Date();
  const currentDate = dayjs(now).format("YYYY-MM-DD") + " 00:00.000";
  const currentTime = "1900-01-01 " + dayjs(now).format("HH:mm:ss.SSS");
  return { currentDate, currentTime };
};
var getWeekFolder = (date) => {
  const year = dayjs(date).isoWeekYear();
  const week = String(dayjs(date).isoWeek()).padStart(2, "0");
  return `${year}-w${week}`;
};

// src/lib/utils/uuid.ts
import { v4 as uuidv4 } from "uuid";
var uuid = () => uuidv4();

// src/lib/schemas/epicStakeholder.schema.ts
var epicStakeholderSchema = zod_exports.object({
  id: zod_exports.string().uuid().optional(),
  epicId: zod_exports.string().uuid(),
  stakeholderId: zod_exports.string().uuid(),
  name: zod_exports.string().regex(stringRegex).optional().nullable(),
  startDate: zod_exports.date(),
  endDate: zod_exports.date().nullish(),
  createdTime: zod_exports.coerce.date().optional(),
  createdBy: zod_exports.string().uuid().optional(),
  modifiedTime: zod_exports.coerce.date().optional().nullable(),
  modifiedBy: zod_exports.string().uuid().optional().nullable(),
  archived: zod_exports.number().optional()
});
var epicStakeholderUpdateSchema = zod_exports.object({
  epicId: zod_exports.string(),
  stakeholderId: zod_exports.string(),
  startDate: zod_exports.coerce.date()
});
var epicStakeholderResponseSchema = zod_exports.object({
  stakeholderId: zod_exports.string().uuid(),
  name: zod_exports.string()
});
var epicStakeholdersSchema = zod_exports.array(epicStakeholderSchema);

// src/lib/schemas/stakeholder.schema.ts
var stakeholderSchema = zod_exports.object({
  id: zod_exports.string().uuid().optional(),
  organisationId: zod_exports.string().uuid().optional(),
  name: zod_exports.string().regex(stringRegex),
  description: optionalStringRegex,
  createdTime: zod_exports.coerce.date().optional(),
  createdBy: zod_exports.string().uuid().optional(),
  modifiedTime: zod_exports.coerce.date().optional().nullable(),
  modifiedBy: zod_exports.string().uuid().optional().nullable(),
  archived: zod_exports.number().optional()
});
var stakeholderCreateSchema = zod_exports.object({
  name: zod_exports.string().regex(nameRegex),
  description: optionalStringRegex,
  archived: zod_exports.number().optional()
});
var stakeholdersSchema = zod_exports.array(stakeholderSchema);

// src/lib/schemas/epic.schema.ts
var epicSchema = zod_exports.object({
  id: zod_exports.string().uuid(),
  name: zod_exports.string().regex(stringRegex),
  description: zod_exports.string().refine((desc) => desc === "" || stringRegex.test(desc), {
    message: "Invalid"
  }).optional().nullable(),
  organisationApplicationId: zod_exports.string().uuid(),
  createdTime: zod_exports.coerce.date().nullable(),
  createdBy: zod_exports.string().uuid().nullable(),
  modifiedTime: zod_exports.coerce.date().nullable(),
  modifiedBy: zod_exports.string().uuid().nullable(),
  archived: zod_exports.number(),
  totalNumberStories: zod_exports.number(),
  epicStakeholders: epicStakeholderSchema.array()
});
var epicUpdateSchema = zod_exports.object({
  id: zod_exports.string().uuid().optional(),
  name: zod_exports.string().regex(stringRegex).refine((name) => name.trim().length >= 1, {
    params: { i18n: { key: "errors.custom" } }
  }),
  description: zod_exports.string().refine((desc) => desc === "" || stringRegex.test(desc), {
    message: "Invalid"
  }).optional().nullable(),
  organisationApplicationId: zod_exports.string().uuid().optional(),
  createdTime: zod_exports.coerce.date().nullable().optional(),
  createdBy: zod_exports.string().uuid().nullable().optional(),
  modifiedTime: zod_exports.coerce.date().nullable().optional(),
  modifiedBy: zod_exports.string().uuid().nullable().optional(),
  epicStakeholders: zod_exports.string().uuid().array(),
  totalNumberStories: zod_exports.number().optional()
});
var epicsSchema = zod_exports.array(epicSchema);
var epicResponseSchema = zod_exports.object({
  epics: epicSchema.array(),
  stakeholders: stakeholderSchema.array()
});

// src/lib/schemas/epicUserStory.schema.ts
var epicUserStorySchema = zod_exports.object({
  id: zod_exports.string().uuid(),
  epicId: zod_exports.string().uuid(),
  userStoryId: zod_exports.string().uuid(),
  createdTime: zod_exports.coerce.date(),
  createdBy: zod_exports.string().uuid(),
  modifiedTime: zod_exports.coerce.date().optional(),
  modifiedBy: zod_exports.string().uuid().optional(),
  archived: zod_exports.number()
});

// src/lib/schemas/exception.schema.ts
var ExceptionSourceKey = /* @__PURE__ */ ((ExceptionSourceKey2) => {
  ExceptionSourceKey2["RESOURCE_COMBINATION"] = "sendMessageResourceCombination";
  ExceptionSourceKey2["STOP"] = "sendMessageStop";
  ExceptionSourceKey2["SHIPMENT"] = "sendMessageTripActivity";
  ExceptionSourceKey2["TRAILER"] = "trailerImageModal";
  ExceptionSourceKey2["TERMINAL"] = "sendMessageTerminal";
  ExceptionSourceKey2["TRUCK"] = "truckIssues";
  return ExceptionSourceKey2;
})(ExceptionSourceKey || {});
var ExceptionSeverity = /* @__PURE__ */ ((ExceptionSeverity2) => {
  ExceptionSeverity2[ExceptionSeverity2["INFO"] = 0] = "INFO";
  ExceptionSeverity2[ExceptionSeverity2["NEEDS_ACTIONS"] = 50] = "NEEDS_ACTIONS";
  ExceptionSeverity2[ExceptionSeverity2["CRITICAL"] = 100] = "CRITICAL";
  ExceptionSeverity2[ExceptionSeverity2["FATAL"] = 150] = "FATAL";
  return ExceptionSeverity2;
})(ExceptionSeverity || {});
var ExceptionStatus = /* @__PURE__ */ ((ExceptionStatus2) => {
  ExceptionStatus2[ExceptionStatus2["NEW"] = 0] = "NEW";
  ExceptionStatus2[ExceptionStatus2["TODO"] = 50] = "TODO";
  ExceptionStatus2[ExceptionStatus2["SOLVING"] = 100] = "SOLVING";
  ExceptionStatus2[ExceptionStatus2["WAITING"] = 150] = "WAITING";
  ExceptionStatus2[ExceptionStatus2["NO_ACTION"] = 200] = "NO_ACTION";
  ExceptionStatus2[ExceptionStatus2["SOLVED"] = 250] = "SOLVED";
  ExceptionStatus2[ExceptionStatus2["VISIBLE_TO_ALL"] = 300] = "VISIBLE_TO_ALL";
  return ExceptionStatus2;
})(ExceptionStatus || {});
var ExceptionOrder = /* @__PURE__ */ ((ExceptionOrder2) => {
  ExceptionOrder2["SEVERITY_DESC"] = "SEVERITY_DESC";
  ExceptionOrder2["SEVERITY_ASC"] = "SEVERITY_ASC";
  ExceptionOrder2["DATETIME_DESC"] = "DATETIME_DESC";
  ExceptionOrder2["DATETIME_ASC"] = "DATETIME_ASC";
  return ExceptionOrder2;
})(ExceptionOrder || {});
var ExceptionContractorInvoiceStatus = /* @__PURE__ */ ((ExceptionContractorInvoiceStatus2) => {
  ExceptionContractorInvoiceStatus2[ExceptionContractorInvoiceStatus2["NO"] = 0] = "NO";
  ExceptionContractorInvoiceStatus2[ExceptionContractorInvoiceStatus2["SENT"] = 50] = "SENT";
  ExceptionContractorInvoiceStatus2[ExceptionContractorInvoiceStatus2["PAID"] = 100] = "PAID";
  return ExceptionContractorInvoiceStatus2;
})(ExceptionContractorInvoiceStatus || {});
var ExceptionCostPaidByInsuranceStatus = /* @__PURE__ */ ((ExceptionCostPaidByInsuranceStatus2) => {
  ExceptionCostPaidByInsuranceStatus2[ExceptionCostPaidByInsuranceStatus2["NO"] = 0] = "NO";
  ExceptionCostPaidByInsuranceStatus2[ExceptionCostPaidByInsuranceStatus2["YES"] = 100] = "YES";
  return ExceptionCostPaidByInsuranceStatus2;
})(ExceptionCostPaidByInsuranceStatus || {});
var exceptionStatusSchema = zod_exports.nativeEnum(ExceptionStatus);
var exceptionSeveritySchema = zod_exports.nativeEnum(ExceptionSeverity);
var exceptionCostSchema = zod_exports.object({
  id: zod_exports.string().uuid(),
  organisationApplicationId: zod_exports.string().uuid(),
  exceptionId: zod_exports.string().uuid(),
  costDescription: zod_exports.string(),
  costAmount: zod_exports.number(),
  createdTime: zod_exports.coerce.date(),
  createdBy: zod_exports.string().uuid(),
  modifiedTime: zod_exports.coerce.date().nullable(),
  modifiedBy: zod_exports.string().uuid().nullable(),
  archived: zod_exports.number()
});
var exceptionCostPatchItemSchema = zod_exports.object({
  id: zod_exports.string().uuid().optional(),
  costDescription: zod_exports.string().trim().min(1),
  costAmount: zod_exports.number()
});
var exceptionCostPatchSchema = zod_exports.array(exceptionCostPatchItemSchema);
var exceptionSchema = zod_exports.object({
  id: zod_exports.string().uuid(),
  description: zod_exports.string().nullable(),
  exceptionFormId: zod_exports.string().uuid().nullable(),
  exceptionTypeId: zod_exports.string().uuid(),
  exceptionClassId: zod_exports.string().uuid(),
  exceptionReasonId: zod_exports.string().uuid(),
  tripActivityId: zod_exports.string().uuid().nullable().optional(),
  exceptionTypeName: zod_exports.string(),
  exceptionReasonName: zod_exports.string(),
  exceptionStatus: zod_exports.nativeEnum(ExceptionStatus),
  severity: zod_exports.nativeEnum(ExceptionSeverity),
  createdTime: zod_exports.string(),
  createdBy: zod_exports.string().uuid(),
  reporterName: zod_exports.string().nullable().optional(),
  modifiedTime: zod_exports.coerce.date(),
  trailer: zod_exports.string().nullable(),
  truck: zod_exports.string().nullable(),
  driver: zod_exports.string().nullable(),
  stop: zod_exports.string().nullable(),
  address: zod_exports.string().nullable(),
  assigneeUserId: zod_exports.string().uuid().nullable().optional(),
  reference: zod_exports.string().nullable().optional(),
  startTime: zod_exports.coerce.date().nullable(),
  resourceCombinationId: zod_exports.string().nullable(),
  palletGroupDescription: zod_exports.string().nullable().optional(),
  temperatureSetPoint: zod_exports.number().nullable().optional(),
  temperatureMin: zod_exports.number().nullable().optional(),
  temperatureMax: zod_exports.number().nullable().optional(),
  senderName: zod_exports.string().nullable().optional(),
  receiverName: zod_exports.string().nullable().optional(),
  planningNote: zod_exports.string().nullable().optional(),
  sender: zod_exports.string().nullable().optional(),
  receiver: zod_exports.string().nullable().optional(),
  bookingId: zod_exports.string().nullable().optional(),
  productDescription: zod_exports.string().nullable().optional(),
  tripIdentifier: zod_exports.string().nullable().optional(),
  exceptionCauseId: zod_exports.string().nullable().optional(),
  exceptionCauseDescription: zod_exports.string().nullable().optional(),
  exceptionWaitingReasonIds: zod_exports.preprocess((value) => {
    if (Array.isArray(value)) {
      return value;
    }
    if (typeof value === "string") {
      return value.split(";").map((item) => item.trim()).filter(Boolean);
    }
    return [];
  }, zod_exports.array(zod_exports.string())),
  causeOfIssue: zod_exports.string().nullable().optional(),
  waitingReason: zod_exports.string().nullable().optional(),
  exceptionClassName: zod_exports.string().nullable().optional(),
  paidByInsurance: zod_exports.nativeEnum(ExceptionCostPaidByInsuranceStatus).nullable().optional(),
  insuranceNumber: zod_exports.string().nullable().optional(),
  compensation: zod_exports.number().nullable().optional(),
  contractorAmount: zod_exports.number().nullable().optional(),
  contractorInvoice: zod_exports.nativeEnum(ExceptionContractorInvoiceStatus).nullable().optional(),
  exceptionCosts: zod_exports.array(exceptionCostSchema),
  mainContextId: zod_exports.string().nullable().optional(),
  mainContextType: zod_exports.nativeEnum(DiscussionContextType).nullable().optional(),
  discussionId: zod_exports.string().uuid().nullable().optional(),
  unreadMessageCount: zod_exports.number().optional()
});
var relatedExceptionSchema = exceptionSchema.omit({
  exceptionCosts: true,
  mainContextId: true,
  mainContextType: true,
  discussionId: true,
  unreadMessageCount: true
});
var exceptionCauseSchema = zod_exports.object({
  exceptionCauseId: zod_exports.string().uuid().nullable(),
  exceptionCauseDescription: zod_exports.string().max(500).nullable().optional()
});
var exceptionCreateSchema = zod_exports.object({
  exceptionTypeId: zod_exports.string().uuid(),
  exceptionReasonId: zod_exports.string().uuid(),
  exceptionStatus: zod_exports.number(),
  severity: zod_exports.number(),
  description: zod_exports.string().nullable(),
  reference: zod_exports.string().nullable().optional(),
  exceptionSourceKey: zod_exports.nativeEnum(ExceptionSourceKey).optional(),
  assigneeUserId: zod_exports.string().uuid().nullable().optional(),
  startTime: zod_exports.coerce.date().nullable().optional()
}).and(exceptionCauseSchema);
var exceptionInfoCreateSchema = zod_exports.object({
  exceptionId: zod_exports.string().uuid(),
  exceptionCauseId: zod_exports.string().uuid().nullable(),
  exceptionCauseDescription: zod_exports.string().max(500).nullable(),
  exceptionWaitingReasonIds: zod_exports.array(zod_exports.string().uuid()).nullable(),
  exceptionClassId: zod_exports.string().uuid().nullable(),
  exceptionTypeId: zod_exports.string().uuid().nullable(),
  exceptionReasonId: zod_exports.string().uuid().nullable(),
  reference: zod_exports.string().nullable().optional(),
  description: zod_exports.string().nullable(),
  startTime: zod_exports.coerce.date().nullable().optional()
});
var exceptionIssueInfoUpdateSchema = exceptionInfoCreateSchema.partial().extend({
  exceptionStatus: zod_exports.nativeEnum(ExceptionStatus).optional(),
  severity: zod_exports.nativeEnum(ExceptionSeverity).optional()
});
var exceptionUpdateSchema = zod_exports.object({
  exceptionTypeId: zod_exports.string().uuid().optional(),
  exceptionReasonId: zod_exports.string().uuid().optional(),
  exceptionStatus: zod_exports.number().optional(),
  severity: zod_exports.number().optional(),
  description: zod_exports.string().nullable().optional(),
  reference: zod_exports.string().nullable().optional(),
  assigneeUserId: zod_exports.string().uuid().nullable().optional(),
  paidByInsurance: zod_exports.nativeEnum(ExceptionCostPaidByInsuranceStatus).nullable().optional(),
  insuranceNumber: zod_exports.string().nullable().optional(),
  compensation: zod_exports.number().nullable().optional(),
  contractorAmount: zod_exports.number().nullable().optional(),
  contractorInvoice: zod_exports.nativeEnum(ExceptionContractorInvoiceStatus).nullable().optional(),
  startTime: zod_exports.coerce.date().nullable().optional()
}).and(exceptionCauseSchema.partial());
var exceptionRelatedContextSchema = zod_exports.object({
  id: zod_exports.string().uuid(),
  context: zod_exports.string(),
  mainContext: zod_exports.number(),
  organisationApplicationId: zod_exports.string().uuid(),
  exceptionId: zod_exports.string().uuid(),
  contextId: zod_exports.string().uuid().nullable(),
  description: zod_exports.string().nullable(),
  createdTime: zod_exports.coerce.date(),
  createdBy: zod_exports.string().uuid(),
  archived: zod_exports.number()
});
var exceptionContextItemSchema = zod_exports.object({
  context: zod_exports.string().trim().min(1),
  contextId: zod_exports.string().trim().min(1).optional(),
  description: zod_exports.string().trim().min(1)
});
var exceptionFormInstructionsSchema = zod_exports.object({
  id: zod_exports.string().uuid(),
  key: zod_exports.string(),
  instructions: zod_exports.string().max(1e3).nullable()
});
var exceptionContextsUpdateSchema = zod_exports.array(
  exceptionContextItemSchema
);
var exceptionCountsSchema = zod_exports.object({
  status: zod_exports.record(zod_exports.string(), zod_exports.number()),
  severity: zod_exports.record(zod_exports.string(), zod_exports.number()),
  assignee: zod_exports.record(zod_exports.string(), zod_exports.number()),
  reporter: zod_exports.record(zod_exports.string(), zod_exports.number())
});
var exceptionFiltersSchema = zod_exports.object({
  exceptionClassIds: zod_exports.string().nullable(),
  exceptionTypeIds: zod_exports.string().uuid().nullable(),
  exceptionReasonIds: zod_exports.string().uuid().nullable(),
  assigneeUserIds: zod_exports.string().nullable(),
  reporterUserIds: zod_exports.string().nullable(),
  referenceQuery: zod_exports.string().nullable(),
  truckLicenseQuery: zod_exports.string(),
  trailerLicenseQuery: zod_exports.string(),
  status: zod_exports.string(),
  severity: zod_exports.string(),
  order: zod_exports.string(),
  fromDate: zod_exports.string().datetime().nullable().optional(),
  toDate: zod_exports.string().datetime().nullable().optional()
});
var exceptionImagesUploadQuerySchema = zod_exports.object({
  resourceCombinationId: zod_exports.string(),
  viewAdminOnlyFlags: zod_exports.string()
});
var isExceptionSeverity = (value) => {
  return exceptionSeveritySchema.safeParse(value).success;
};
var isExceptionStatus = (value) => {
  return exceptionStatusSchema.safeParse(value).success;
};

// src/lib/schemas/exceptionAction.schema.ts
var EXCEPTION_COMMENT_MAX_BYTES = 971;
var getUtf8ByteLength = (value) => new TextEncoder().encode(value).length;
var exceptionCommentCreateSchema = zod_exports.object({
  comment: zod_exports.string().trim().min(1).refine((value) => getUtf8ByteLength(value) <= EXCEPTION_COMMENT_MAX_BYTES, {
    message: "Comment is too long"
  })
});
var exceptionActionSchema = zod_exports.object({
  id: zod_exports.string().uuid(),
  typeKey: zod_exports.nativeEnum(ExceptionActionTypeKey),
  comment: zod_exports.string().nullable(),
  previousValue: zod_exports.string().nullable(),
  newValue: zod_exports.string().nullable(),
  previousValueLabel: zod_exports.string().nullable(),
  newValueLabel: zod_exports.string().nullable(),
  template: zod_exports.string().nullable(),
  createdTime: zod_exports.coerce.date(),
  createdBy: zod_exports.string(),
  createdByName: zod_exports.string().nullable(),
  createdByAvatar: zod_exports.string().nullable(),
  createdByInitials: zod_exports.string().nullable()
});

// src/lib/schemas/translation.schema.ts
var nameTranslationSchema = zod_exports.object({
  id: zod_exports.string().uuid().optional(),
  term: zod_exports.string().regex(exceptionLocalizedTextRegex),
  key: zod_exports.string()
});

// src/lib/schemas/exceptionCause.schema.ts
var exceptionCauseNameSchema = nameTranslationSchema.extend({
  exceptionCauseId: zod_exports.string().uuid()
});
var exceptionCauseSchema2 = zod_exports.object({
  id: zod_exports.string(),
  name: zod_exports.string().regex(exceptionLocalizedTextRegex),
  nameTranslations: exceptionCauseNameSchema.array(),
  needsDescription: zod_exports.number().nullable(),
  archived: zod_exports.number()
});
var exceptionCauseCreateSchema = zod_exports.object({
  name: zod_exports.string().regex(exceptionLocalizedTextRegex),
  nameTranslations: nameTranslationSchema.array(),
  needsDescription: zod_exports.number().nullable()
});

// src/lib/schemas/exceptionReason.schema.ts
var instructionSchema = zod_exports.string().max(4e3).regex(multilineTextRegex).nullable();
var reasonTranslationSchema = nameTranslationSchema.extend({
  instruction: instructionSchema.optional()
});
var reasonNameSchema = reasonTranslationSchema.extend({
  exceptionReasonId: zod_exports.string().uuid()
});
var exceptionReasonSchema = zod_exports.object({
  id: zod_exports.string(),
  name: zod_exports.string().regex(exceptionLocalizedTextRegex),
  description: zod_exports.string().regex(stringRegex).nullable(),
  instruction: instructionSchema,
  responsibleUserId: zod_exports.string().uuid().nullable(),
  nameTranslations: reasonNameSchema.array(),
  defaultSeverity: zod_exports.number(),
  needsDescription: zod_exports.number().nullable(),
  needsImage: zod_exports.number().nullable(),
  archived: zod_exports.number()
});
var exceptionReasonCreateSchema = zod_exports.object({
  name: zod_exports.string().regex(exceptionLocalizedTextRegex),
  description: zod_exports.string().regex(stringRegex).nullable(),
  instruction: instructionSchema,
  responsibleUserId: zod_exports.string().uuid().nullable(),
  nameTranslations: reasonTranslationSchema.array(),
  defaultSeverity: zod_exports.number().nullable(),
  needsDescription: zod_exports.number().nullable(),
  needsImage: zod_exports.number().nullable()
});
var exceptionReasonOptionSchema = zod_exports.object({
  id: zod_exports.string().uuid(),
  name: zod_exports.string(),
  defaultSeverity: zod_exports.string().nullable(),
  needsDescription: zod_exports.number().nullable(),
  needsImage: zod_exports.number().nullable(),
  instruction: zod_exports.string().nullable(),
  responsibleUserName: zod_exports.string().nullable(),
  responsibleUserPhone: zod_exports.string().nullable()
});
var exceptionReasonResponseSchema = zod_exports.object({
  exceptionClassId: zod_exports.string().uuid(),
  exceptionTypeName: zod_exports.string(),
  exceptionReasons: zod_exports.array(exceptionReasonSchema)
});

// src/lib/schemas/exceptionReport.schema.ts
var ExceptionReportType = /* @__PURE__ */ ((ExceptionReportType2) => {
  ExceptionReportType2["COMPACT"] = "compact";
  ExceptionReportType2["FULL"] = "full";
  return ExceptionReportType2;
})(ExceptionReportType || {});
var exceptionReportTypeSchema = zod_exports.nativeEnum(ExceptionReportType);
var exceptionReportLabelsSchema = zod_exports.object({
  issueReport: zod_exports.string(),
  issueCountOne: zod_exports.string(),
  issueCountOther: zod_exports.string(),
  reportGeneratedOn: zod_exports.string(),
  truck: zod_exports.string(),
  trailer: zod_exports.string(),
  registerNo: zod_exports.string(),
  type: zod_exports.string(),
  issueClass: zod_exports.string(),
  issueType: zod_exports.string(),
  issueReason: zod_exports.string(),
  reportedBy: zod_exports.string(),
  assignedTo: zod_exports.string(),
  description: zod_exports.string(),
  reported: zod_exports.string(),
  resolved: zod_exports.string(),
  status: zod_exports.string(),
  statuses: zod_exports.record(zod_exports.string(), zod_exports.string())
});
var exceptionReportFiltersSchema = exceptionFiltersSchema.extend({
  exceptionTypeIds: zod_exports.string().nullable(),
  exceptionReasonIds: zod_exports.string().nullable()
});
var exceptionReportCreateSchema = zod_exports.object({
  reportType: exceptionReportTypeSchema,
  translation: zod_exports.string().min(1),
  timeZone: zod_exports.string().min(1),
  filters: exceptionReportFiltersSchema,
  labels: exceptionReportLabelsSchema
});

// src/lib/schemas/exceptionType.schema.ts
var exceptionTypeNameSchema = nameTranslationSchema.extend({
  id: zod_exports.string().uuid(),
  term: zod_exports.string().regex(exceptionLocalizedTextRegex),
  key: zod_exports.string(),
  exceptionTypeId: zod_exports.string().uuid()
});
var exceptionClassNameSchema = nameTranslationSchema.extend({
  id: zod_exports.string().uuid(),
  term: zod_exports.string().regex(exceptionLocalizedTextRegex),
  key: zod_exports.string(),
  exceptionClassId: zod_exports.string().uuid()
});
var exceptionClassSchema = zod_exports.object({
  id: zod_exports.string().uuid(),
  name: zod_exports.string().regex(exceptionLocalizedTextRegex),
  description: zod_exports.string().regex(stringRegex).nullable(),
  nameTranslations: exceptionClassNameSchema.array(),
  archived: zod_exports.number()
});
var exceptionTypeSchema = zod_exports.object({
  id: zod_exports.string().uuid(),
  name: zod_exports.string().regex(exceptionLocalizedTextRegex),
  description: zod_exports.string().regex(stringRegex).nullable(),
  exceptionClassId: zod_exports.string().uuid(),
  exceptionFormIds: zod_exports.string().nullable(),
  nameTranslations: exceptionTypeNameSchema.array(),
  archived: zod_exports.number()
});
var exceptionTypeCreateSchema = zod_exports.object({
  name: zod_exports.string().regex(exceptionLocalizedTextRegex),
  description: zod_exports.string().regex(stringRegex).nullable(),
  exceptionFormIds: zod_exports.string().uuid().array(),
  exceptionClassId: zod_exports.string().uuid(),
  nameTranslations: nameTranslationSchema.array()
});
var exceptionClassCreateSchema = zod_exports.object({
  name: zod_exports.string().regex(exceptionLocalizedTextRegex),
  description: zod_exports.string().regex(stringRegex).nullable(),
  nameTranslations: nameTranslationSchema.array()
});
var exceptionTypeOptionSchema = zod_exports.object({
  id: zod_exports.string().uuid(),
  name: zod_exports.string()
});

// src/lib/schemas/exceptionWaitingReason.schema.ts
var exceptionWaitingReasonSchema = zod_exports.object({
  id: zod_exports.string(),
  name: zod_exports.string().regex(exceptionLocalizedTextRegex),
  nameTranslations: nameTranslationSchema.array(),
  archived: zod_exports.number()
});
var exceptionWaitingReasonCreateSchema = zod_exports.object({
  name: zod_exports.string().regex(exceptionLocalizedTextRegex),
  nameTranslations: nameTranslationSchema.array()
});

// src/lib/schemas/extraShipment.schema.ts
var nullableTrimmedString = zod_exports.string().trim().nullable();
var extraShipmentBaseSchema = zod_exports.object({
  stopId: zod_exports.string().uuid(),
  plannedDateTime: zod_exports.coerce.date(),
  productDescription: nullableTrimmedString,
  productId: nullableTrimmedString,
  truckDescription: nullableTrimmedString,
  driverId: nullableTrimmedString,
  loadingAddressDescription: nullableTrimmedString,
  loadingAddressId: nullableTrimmedString,
  loadingMeter: zod_exports.number().nullable(),
  receiverAddressDescription: nullableTrimmedString,
  receiverAddressId: nullableTrimmedString,
  reference: nullableTrimmedString,
  senderAddressDescription: nullableTrimmedString,
  senderAddressId: nullableTrimmedString,
  terminalStockPlaceId: nullableTrimmedString,
  trailerDescription: nullableTrimmedString,
  driverDescription: nullableTrimmedString,
  trailerId: nullableTrimmedString,
  truckId: nullableTrimmedString,
  unitAmount: zod_exports.number().int().nullable(),
  unitDescription: nullableTrimmedString,
  unitId: nullableTrimmedString,
  unloadingAddressDescription: nullableTrimmedString,
  unloadingAddressId: nullableTrimmedString,
  description: zod_exports.string().trim().max(1e3).nullable()
});
var extraShipmentSchema = extraShipmentBaseSchema.extend({
  id: zod_exports.string().uuid(),
  endAddress: nullableTrimmedString,
  beginAddress: nullableTrimmedString,
  sender: nullableTrimmedString,
  receiver: nullableTrimmedString,
  driver: nullableTrimmedString,
  truck: nullableTrimmedString,
  trailer: nullableTrimmedString,
  unitCode: zod_exports.string(),
  product: nullableTrimmedString,
  temperatureSetPoint: zod_exports.number(),
  reporter: zod_exports.string(),
  status: zod_exports.nativeEnum(TripActivityStatus).nullable(),
  createdTime: zod_exports.coerce.date().nullish()
});
var extraShipmentUpdateSchema = zod_exports.object({
  terminalStockPlaceId: nullableTrimmedString,
  status: zod_exports.nativeEnum(TripActivityStatus)
}).partial();
var extraShipmentCreateSchema = extraShipmentBaseSchema.extend({
  terminalId: zod_exports.string().uuid()
});

// src/lib/schemas/feature.schema.ts
var featureSchema = zod_exports.object({
  id: zod_exports.string().uuid().optional(),
  applicationId: zod_exports.string().uuid().optional(),
  key: zod_exports.string().regex(keyRegex),
  name: zod_exports.string().regex(nameRegex),
  description: optionalStringRegex,
  createdTime: zod_exports.coerce.date().optional(),
  createdBy: zod_exports.string().uuid().optional(),
  modifiedTime: zod_exports.coerce.date().optional().nullable(),
  modifiedBy: zod_exports.string().uuid().optional().nullable(),
  archived: zod_exports.number().optional()
});
var featuresSchema = zod_exports.array(featureSchema);

// src/lib/schemas/language.schema.ts
var languageSchema = zod_exports.object({
  id: zod_exports.string().uuid(),
  name: zod_exports.string(),
  key: zod_exports.string(),
  archived: zod_exports.number()
});

// src/lib/schemas/notification.schema.ts
var notificationSchema = zod_exports.object({
  id: zod_exports.string().uuid(),
  archived: zod_exports.number(),
  confirmation: zod_exports.number(),
  contextId: zod_exports.string().uuid(),
  context: zod_exports.nativeEnum(NotificationContext),
  createdTime: zod_exports.string(),
  description: zod_exports.string().nullable(),
  notificationTypeDescription: zod_exports.string().nullable(),
  notificationTypeKey: zod_exports.nativeEnum(NotificationType),
  notificationTypeName: zod_exports.string(),
  viewedDateTime: zod_exports.coerce.date().nullable(),
  confirmedDateTime: zod_exports.coerce.date().nullable(),
  severity: zod_exports.number(),
  title: zod_exports.string(),
  trailerLicenceNumber: zod_exports.string().nullable()
});
var notificationResponseSchema = zod_exports.object({
  importantNotifications: zod_exports.array(notificationSchema),
  newNotifications: zod_exports.array(notificationSchema),
  readNotifications: zod_exports.array(notificationSchema)
});
var notificationRowSchema = zod_exports.object({
  id: zod_exports.string().uuid(),
  title: zod_exports.string(),
  contextId: zod_exports.string().uuid(),
  description: zod_exports.string().nullable(),
  createdTime: zod_exports.coerce.date(),
  archived: zod_exports.number(),
  rowTypeKey: zod_exports.string(),
  rowTypeName: zod_exports.string(),
  rowTypeDescription: zod_exports.string().nullable()
});
var notificationRowResSchema = zod_exports.object({
  contextId: zod_exports.string().uuid(),
  rowTypeKey: zod_exports.string(),
  notificationRows: zod_exports.array(notificationRowSchema)
}).array();
var notificationRecipientUpdateSchema = zod_exports.object({
  viewedDateTime: zod_exports.coerce.date(),
  confirmedDateTime: zod_exports.coerce.date()
}).partial();

// src/lib/schemas/organisationApplication.schema.ts
var organisationApplicationSchema = zod_exports.object({
  id: zod_exports.string().uuid(),
  organisationId: zod_exports.string().uuid(),
  applicationId: zod_exports.string().uuid(),
  startDate: zod_exports.coerce.date(),
  endDate: zod_exports.coerce.date(),
  logLevel: zod_exports.number(),
  daysToAutoArchive: zod_exports.number().nullable(),
  createdTime: zod_exports.coerce.date(),
  createdBy: zod_exports.coerce.date(),
  modifiedTime: zod_exports.coerce.date(),
  modifiedBy: zod_exports.string().uuid(),
  archived: zod_exports.boolean()
});

// src/lib/schemas/organisationApplicationFeature.schema.ts
var organisationApplicationFeatureSchema = zod_exports.object({
  id: zod_exports.string().uuid(),
  organisationApplicationId: zod_exports.string().uuid(),
  key: zod_exports.string(),
  name: zod_exports.string(),
  implemented: zod_exports.number(),
  createdTime: zod_exports.string(),
  createdBy: zod_exports.string().uuid(),
  modifiedTime: zod_exports.string().nullable(),
  modifiedBy: zod_exports.string().uuid().nullable(),
  archived: zod_exports.number()
});

// src/lib/schemas/payGroup.schema.ts
var payGroupSchema = zod_exports.object({
  id: zod_exports.string(),
  code: zod_exports.string(),
  name: zod_exports.string(),
  description: zod_exports.string().nullable(),
  archived: zod_exports.coerce.number()
});
var payGroupCreateSchema = zod_exports.object({
  code: zod_exports.string().trim().min(1).max(100).regex(keyRegex),
  name: zod_exports.string().trim().min(1).max(255).regex(exceptionLocalizedTextRegex),
  description: optionalStringRegex
});
var PayGroupMemberOrder = /* @__PURE__ */ ((PayGroupMemberOrder2) => {
  PayGroupMemberOrder2["NAME_ASC"] = "NAME_ASC";
  PayGroupMemberOrder2["NAME_DESC"] = "NAME_DESC";
  PayGroupMemberOrder2["VALID_FROM_ASC"] = "VALID_FROM_ASC";
  PayGroupMemberOrder2["VALID_FROM_DESC"] = "VALID_FROM_DESC";
  PayGroupMemberOrder2["VALID_TO_ASC"] = "VALID_TO_ASC";
  PayGroupMemberOrder2["VALID_TO_DESC"] = "VALID_TO_DESC";
  return PayGroupMemberOrder2;
})(PayGroupMemberOrder || {});
var payGroupMemberSchema = zod_exports.object({
  id: zod_exports.string(),
  userId: zod_exports.string(),
  firstName: zod_exports.string().nullable(),
  lastName: zod_exports.string().nullable(),
  title: zod_exports.string().nullable(),
  phone: zod_exports.string().nullable(),
  email: zod_exports.string(),
  avatar: zod_exports.string().nullable(),
  validFrom: zod_exports.string(),
  validTo: zod_exports.string().nullable()
});
var payGroupMembersAddSchema = zod_exports.object({
  userIds: zod_exports.string().array().min(1)
});

// src/lib/schemas/payrollType.schema.ts
var payrollTypeSchema = zod_exports.object({
  id: zod_exports.string(),
  code: zod_exports.string(),
  name: zod_exports.string(),
  description: zod_exports.string().nullable(),
  archived: zod_exports.coerce.number()
});
var payrollTypeCreateSchema = zod_exports.object({
  code: zod_exports.string().trim().min(1).max(100).regex(keyRegex),
  name: zod_exports.string().trim().min(1).max(255).regex(exceptionLocalizedTextRegex),
  description: optionalStringRegex
});

// src/lib/schemas/pushNotification.schema.ts
var subscriptionSchema = zod_exports.object({
  endpoint: zod_exports.string(),
  keys: zod_exports.object({ p256dh: zod_exports.string(), auth: zod_exports.string() })
});
var pushNotificationSchema = zod_exports.object({
  token: zod_exports.string().optional(),
  payload: zod_exports.string(),
  userId: zod_exports.string().uuid().optional()
});
var pushNotificationSubscriptionSchema = zod_exports.object({
  id: zod_exports.string().uuid().optional(),
  organisationApplicationId: zod_exports.string().uuid().optional(),
  userId: zod_exports.string().uuid(),
  expirationTime: zod_exports.coerce.date().optional(),
  userAgent: optionalStringRegex,
  subscription: zod_exports.string(),
  createdTime: zod_exports.coerce.date().optional(),
  createdBy: zod_exports.string().uuid().optional(),
  modifiedTime: zod_exports.coerce.date().optional(),
  modifiedBy: zod_exports.string().uuid().nullish(),
  archived: zod_exports.number().nonnegative().lte(1).optional()
});
var pushNotificationSubscriptionsSchema = zod_exports.array(
  pushNotificationSubscriptionSchema
);

// src/lib/schemas/shipmentLog.schema.ts
var shipmentLogStatusContextSchema = zod_exports.enum([
  "resourceCombination",
  "stop",
  "tripActivity"
]);
var shipmentLogStatusKeySchema = zod_exports.enum([
  "resourceCombinationDuration",
  "stopDuration",
  "stopDriving",
  "stopOnLocation",
  "stopUnloading",
  "stopLoading",
  "stopAutomaticWaiting",
  "stopWaiting",
  "tripActivityDuration",
  "tripActivityCmr"
]);
var locationSchema = zod_exports.object({
  latitude: zod_exports.string().optional(),
  longitude: zod_exports.string().optional()
}).nullable();
var shipmentLogStatusSchema = zod_exports.object({
  id: zod_exports.string().uuid(),
  key: shipmentLogStatusKeySchema,
  context: shipmentLogStatusContextSchema.optional(),
  name: zod_exports.string().optional(),
  createdTime: zod_exports.coerce.date(),
  createdBy: zod_exports.string().uuid(),
  modifiedTime: zod_exports.coerce.date().nullable(),
  modifiedBy: zod_exports.string().uuid().nullable(),
  archived: zod_exports.number()
});
var shipmentLogSchema = zod_exports.object({
  id: zod_exports.string().uuid(),
  contextId: zod_exports.string().uuid(),
  shipmentLogStatusId: zod_exports.string().uuid(),
  description: zod_exports.string().optional(),
  beginReason: zod_exports.string().optional(),
  beginTime: zod_exports.coerce.date().nullable(),
  beginLatitude: zod_exports.string().optional(),
  beginLongitude: zod_exports.string().optional(),
  endReason: zod_exports.string().optional(),
  endTime: zod_exports.coerce.date().nullable(),
  endLatitude: zod_exports.string().optional(),
  endLongitude: zod_exports.string().optional(),
  endedBy: zod_exports.string().uuid().optional(),
  createdTime: zod_exports.coerce.date(),
  createdBy: zod_exports.string().uuid(),
  modifiedTime: zod_exports.coerce.date().nullable(),
  modifiedBy: zod_exports.string().uuid().nullable(),
  archived: zod_exports.number()
});
var shipmentLogAddSchema = shipmentLogSchema.omit({
  id: true,
  modifiedTime: true,
  modifiedBy: true
});
var shipmentLogUpdateSchema = shipmentLogSchema.omit({
  createdTime: true,
  createdBy: true
});

// src/lib/schemas/shipment.schema.ts
var instructionSchema2 = zod_exports.object({
  contextId: zod_exports.string(),
  description: zod_exports.string().nullable(),
  image: zod_exports.string().nullable()
});
var palletGroupDescriptionSchema = zod_exports.object({
  activityCode: zod_exports.nativeEnum(ActivityStep),
  stops: zod_exports.number(),
  palletInfo: zod_exports.string()
});
var activeStopSchema = zod_exports.object({
  activeStopActivityStage: zod_exports.nativeEnum(ActivityStage).nullable(),
  activeStopActivityStageBeginTime: zod_exports.coerce.date().nullable(),
  activeStopAddressName: zod_exports.string().nullable(),
  activeStopId: zod_exports.string().uuid().nullable(),
  activeStopActivityStep: zod_exports.nativeEnum(ActivityStep).nullable(),
  activeStopStatus: zod_exports.nativeEnum(StopStatus).nullable(),
  activeStopDockPlace: zod_exports.string().nullable()
});
var shipmentVehicleSchema = zod_exports.object({
  id: zod_exports.string(),
  licenseNumber: zod_exports.string(),
  hasIssues: zod_exports.boolean()
});
var shipmentDriverSchema = zod_exports.object({
  id: zod_exports.string(),
  name: zod_exports.string(),
  avatarId: zod_exports.string().nullable(),
  avatarName: zod_exports.string()
});
var shipmentSchema = zod_exports.object({
  activeStop: activeStopSchema.nullable(),
  actualBeginTime: zod_exports.coerce.date().nullable(),
  beginDateTime: zod_exports.string().nullable(),
  calculatedDistance: zod_exports.number(),
  decouplingResourceCombinationId: zod_exports.string().nullable(),
  discussionId: zod_exports.string().uuid().nullable(),
  discussionCountryCode: zod_exports.string().max(3).nullable(),
  unreadMessageCount: zod_exports.number(),
  driverHasStartedOtherGig: zod_exports.boolean(),
  drivers: zod_exports.string().nullable(),
  endDateTime: zod_exports.string().nullable(),
  hasUnfinishedStops: zod_exports.boolean(),
  hasFinishedStops: zod_exports.boolean(),
  id: zod_exports.string().uuid(),
  instruction: zod_exports.string().nullable(),
  palletGroupDescription: palletGroupDescriptionSchema.array(),
  route: zod_exports.string(),
  status: zod_exports.nativeEnum(ShipmentStatus),
  temp1: zod_exports.number().nullable(),
  temp2: zod_exports.number().nullable(),
  temp3: zod_exports.number().nullable(),
  temp4: zod_exports.number().nullable(),
  tpResourceCombinationNr: zod_exports.number().nullable(),
  tpTripIdNr: zod_exports.number().nullable(),
  tpTripripId: zod_exports.number().nullable(),
  trailers: zod_exports.string().nullable(),
  tripIdentifier: zod_exports.string().nullable(),
  trucks: zod_exports.string().nullable(),
  tinNr: zod_exports.string().nullable(),
  hasPreviousReportedIssues: zod_exports.boolean().optional(),
  trailerVehicles: zod_exports.array(shipmentVehicleSchema).optional(),
  truckVehicles: zod_exports.array(shipmentVehicleSchema).optional(),
  shipmentDrivers: zod_exports.array(shipmentDriverSchema).optional()
});
var shipmentQuerySchema = shipmentSchema.merge(activeStopSchema);
var ShipmentResponseSchema = zod_exports.object({
  shipments: zod_exports.array(shipmentSchema)
});
var shipmentUpdateSchema = zod_exports.object({
  status: zod_exports.nativeEnum(ShipmentStatus).optional(),
  location: locationSchema.optional(),
  timeUpdate: zod_exports.string().datetime().optional()
});
var reportRestSchema = zod_exports.object({
  resourceCombinationId: zod_exports.string().uuid(),
  location: zod_exports.object({
    latitude: zod_exports.string(),
    longitude: zod_exports.string()
  }),
  restTime: zod_exports.string()
});

// src/lib/schemas/signup.schema.ts
var signUpSchema = zod_exports.object({
  identity: zod_exports.string().email()
});

// src/lib/schemas/stop.schema.ts
var stopSchema = zod_exports.object({
  id: zod_exports.string().uuid(),
  resourceCombinationId: zod_exports.string().uuid(),
  decouplingResourceCombinationId: zod_exports.string().uuid(),
  status: zod_exports.nativeEnum(StopStatus),
  sequence: zod_exports.number(),
  plannedDateTime: zod_exports.string().nullable(),
  calculatedDistance: zod_exports.number(),
  locationName: zod_exports.string().max(255).nullable(),
  locationAddress: zod_exports.string().max(255).nullable(),
  locationAddress2: zod_exports.string().max(255).nullable(),
  locationZipCode: zod_exports.string().max(255).nullable(),
  locationCityName: zod_exports.string().max(255).nullable(),
  addressId: zod_exports.string().uuid().optional(),
  dockPlace: zod_exports.string().nullable(),
  isWaiting: zod_exports.boolean(),
  canAutoContinueLoading: zod_exports.boolean().default(false),
  isAutomaticWaiting: zod_exports.boolean().optional(),
  hasUnfinishedActivities: zod_exports.boolean(),
  hasStartedActivities: zod_exports.boolean(),
  cargoSpaceEnabled: zod_exports.boolean(),
  cargoSpace: zod_exports.number().nullable(),
  cargoSpace1CumulativeLoadMeter: zod_exports.number().nullable(),
  cargoSpace2CumulativeLoadMeter: zod_exports.number().nullable(),
  discussionId: zod_exports.string().uuid().nullable(),
  unreadMessageCount: zod_exports.number(),
  activityCode: zod_exports.nativeEnum(ActivityStep),
  latitude: zod_exports.string(),
  longitude: zod_exports.string(),
  loadingMeter: zod_exports.number(),
  cumulativeLoadMeter: zod_exports.string(),
  previousCumulativeLoadMeter: zod_exports.string(),
  palletGroupDescription: zod_exports.string(),
  countryCode: zod_exports.string().max(3).nullable(),
  countryName: zod_exports.string().nullable(),
  beginDrivingTime: zod_exports.coerce.date().nullable(),
  beginOnLocationTime: zod_exports.coerce.date().nullable(),
  beginLoadingTime: zod_exports.coerce.date().nullable(),
  beginUnloadingTime: zod_exports.coerce.date().nullable(),
  beginWaitingTime: zod_exports.coerce.date().nullable(),
  ready: zod_exports.string().nullable(),
  reference: zod_exports.string().nullable(),
  instructions: zod_exports.string().nullable(),
  unloadingInstructions: zod_exports.array(zod_exports.string()).nullable(),
  trailerId: zod_exports.string().nullable(),
  tpResourceCombinationNr: zod_exports.number().nullable(),
  tpStopNr: zod_exports.number(),
  tpTripIdNr: zod_exports.number().nullable(),
  tpTripripId: zod_exports.number().nullable(),
  tripIdentifier: zod_exports.string().nullable(),
  imagesTaken: zod_exports.number(),
  hasUnfinishableActivities: zod_exports.boolean().optional(),
  hasFinishableActivities: zod_exports.boolean().optional(),
  hasPreviousReportedIssues: zod_exports.boolean().optional(),
  allowMassLoading: zod_exports.string().optional(),
  allowMassUnloading: zod_exports.string().optional(),
  doorCode: zod_exports.string().optional().nullable(),
  phone: zod_exports.string().optional().nullable(),
  applicationRolePhone: zod_exports.string().optional().nullable(),
  mobile: zod_exports.string().optional().nullable()
});
var stopRegistrationSchema = zod_exports.object({
  id: zod_exports.string(),
  activityCode: zod_exports.nativeEnum(ActivityStep),
  isWall: zod_exports.boolean(),
  unitAmount: zod_exports.number(),
  loadingMeter: zod_exports.number(),
  cargoSpace: zod_exports.number().int().refine((v) => v === 0 || v === 1).nullable(),
  staysInTrailer: zod_exports.number().nullable(),
  code: zod_exports.string(),
  reference: zod_exports.string().nullable(),
  sender: zod_exports.string().nullable(),
  receiver: zod_exports.string().nullable(),
  temperatureSetPoint: zod_exports.number().nullable(),
  description: zod_exports.string().nullable(),
  unloadingInstructions: zod_exports.string().nullable(),
  productDescription: zod_exports.string(),
  dockPlace: zod_exports.string().nullable()
});
var stopCurrentDateUpdateSchema = zod_exports.object({
  currentDate: zod_exports.string(),
  currentTime: zod_exports.string()
});
var stopUpdateSchema = zod_exports.object({
  status: zod_exports.nativeEnum(StopStatus).optional(),
  isWaiting: zod_exports.boolean().optional(),
  isAutomaticWaiting: zod_exports.boolean().optional()
});
var tpStopPartialSchema = zod_exports.object({
  id: zod_exports.string(),
  tpStopNr: zod_exports.number(),
  newStopSequence: zod_exports.number()
});
var tpActivitySchema = zod_exports.object({
  id: zod_exports.string(),
  tpTripActivityNr: zod_exports.number(),
  newTripActivitySequence: zod_exports.number()
});
var reorderTpStopsPayloadSchema = zod_exports.object({
  tpTripNr: zod_exports.number(),
  stops: tpStopPartialSchema.array(),
  activities: tpActivitySchema.array()
});
var reorderStopsBodySchema = zod_exports.object({
  currentStopId: zod_exports.string(),
  decouplingStopId: zod_exports.string(),
  isBeforeDecoupling: zod_exports.boolean(),
  previousStopId: zod_exports.string().optional()
});

// src/lib/schemas/terminal.schema.ts
var terminalAttributesSchema = zod_exports.object({
  id: zod_exports.string(),
  name: zod_exports.string().regex(nameRegex),
  organisationApplicationId: zod_exports.string().uuid(),
  archived: zod_exports.number(),
  instructions: zod_exports.string().nullable(),
  createdBy: zod_exports.string().nullable(),
  modifiedBy: zod_exports.string().nullable(),
  createdTime: zod_exports.coerce.date(),
  modifiedTime: zod_exports.coerce.date().nullable()
});
var terminalSchema = terminalAttributesSchema.omit({
  createdBy: true,
  modifiedBy: true,
  createdTime: true,
  modifiedTime: true
}).extend({
  addressIds: zod_exports.string().uuid().array()
});
var terminalCreateSchema = zod_exports.object({
  name: zod_exports.string().regex(nameRegex),
  instructions: zod_exports.string().nullable(),
  addressIds: zod_exports.string().uuid().array()
});
var terminalUpdateSchema = terminalCreateSchema.extend({
  id: zod_exports.string().uuid()
});

// src/lib/schemas/terminalActivity.schema.ts
var terminalActivitySchema = zod_exports.object({
  id: zod_exports.string().uuid(),
  resourceCombinationId: zod_exports.string().uuid().nullable(),
  terminalStopId: zod_exports.string().uuid(),
  cargoSpaceEnabled: zod_exports.boolean(),
  cumulativeLoadMeter: zod_exports.number().nullable(),
  cargoSpace: zod_exports.number().nullable(),
  cargoSpace1CumulativeLoadMeter: zod_exports.number().nullable(),
  cargoSpace2CumulativeLoadMeter: zod_exports.number().nullable(),
  beginAddress: zod_exports.string().nullable(),
  bookingNr: zod_exports.string().nullable(),
  combinedReference: zod_exports.string().nullable(),
  discussionId: zod_exports.string().uuid().nullable(),
  unreadMessageCount: zod_exports.number(),
  endAddress: zod_exports.string().nullable(),
  endAddressIsTerminal: zod_exports.boolean(),
  endCountryCode: zod_exports.string().nullable(),
  instruction: zod_exports.string().nullable(),
  isDividedCargo: zod_exports.boolean(),
  isDividedLeg: zod_exports.boolean(),
  isExtraGear: zod_exports.boolean(),
  isIssues: zod_exports.boolean(),
  isWall: zod_exports.boolean(),
  hasCMR: zod_exports.boolean(),
  isFinalDestination: zod_exports.boolean(),
  loadingMeter: zod_exports.number().nullable(),
  status: zod_exports.nativeEnum(TripActivityStatus).nullable(),
  terminalStopStatus: zod_exports.nativeEnum(StopStatus).nullable(),
  activityStep: zod_exports.nativeEnum(ActivityStep),
  mailId: zod_exports.string().nullable(),
  nextDriver: zod_exports.string().nullable(),
  nextTrailer: zod_exports.string().nullable(),
  nextTruck: zod_exports.string().nullable(),
  previousDriver: zod_exports.string().nullable(),
  previousTrailer: zod_exports.string().nullable(),
  previousTruck: zod_exports.string().nullable(),
  product: zod_exports.string().nullable(),
  productDescription: zod_exports.string().nullable(),
  receiver: zod_exports.string().nullable(),
  discussionCountryCode: zod_exports.string().nullable(),
  salesOrderLegId: zod_exports.string().uuid().nullable(),
  sender: zod_exports.string().nullable(),
  sequence: zod_exports.number(),
  staysInTrailer: zod_exports.boolean(),
  temperatureMax: zod_exports.number().nullable(),
  temperatureMin: zod_exports.number().nullable(),
  temperatureSetPoint: zod_exports.number().nullable(),
  terminalStockPlaceId: zod_exports.string().uuid().nullable(),
  terminalCmr: zod_exports.boolean(),
  stockPlaceName: zod_exports.string().nullable(),
  unitAmount: zod_exports.number().nullable(),
  unitCode: zod_exports.string().nullable(),
  missingShipmentDescription: zod_exports.string().nullable(),
  missingShipmentReporter: zod_exports.string().nullable(),
  missingShipmentReportedAt: zod_exports.coerce.date().nullable(),
  canBeFinished: zod_exports.boolean(),
  tripIdentifier: zod_exports.string().nullish(),
  currentDriver: zod_exports.string().nullish(),
  currentTruck: zod_exports.string().nullish(),
  currentTrailer: zod_exports.string().nullish(),
  unloadingInstructions: zod_exports.string().nullish(),
  pairedTerminalActivityId: zod_exports.string().uuid().nullish(),
  pairedTerminalStopId: zod_exports.string().uuid().nullish(),
  isReadyForLoading: zod_exports.boolean().nullish(),
  productId: zod_exports.string().uuid().nullish(),
  unitId: zod_exports.string().uuid().nullish(),
  senderId: zod_exports.string().uuid().nullish(),
  receiverId: zod_exports.string().uuid().nullish(),
  beginAddressId: zod_exports.string().uuid().nullish(),
  endAddressId: zod_exports.string().uuid().nullish()
});

// src/lib/schemas/terminalDock.schema.ts
var terminalDockSchema = zod_exports.object({
  id: zod_exports.string().uuid(),
  name: zod_exports.string(),
  instructions: zod_exports.string().nullable(),
  organisationApplicationId: zod_exports.string().uuid(),
  terminalId: zod_exports.string().uuid(),
  createdTime: zod_exports.coerce.date(),
  createdBy: zod_exports.string(),
  modifiedTime: zod_exports.coerce.date().nullable(),
  modifiedBy: zod_exports.string().nullable(),
  archived: zod_exports.number()
});
var terminalDockCreateSchema = terminalDockSchema.pick({
  terminalId: true,
  name: true,
  instructions: true
});
var terminalDockUpdateSchema = terminalDockSchema.pick({
  id: true,
  name: true,
  terminalId: true,
  instructions: true
});

// src/lib/schemas/terminalStockPlace.schema.ts
var stockPlaceSchema = zod_exports.object({
  id: zod_exports.string().uuid(),
  name: zod_exports.string(),
  instructions: zod_exports.string().nullable(),
  organisationApplicationId: zod_exports.string().uuid(),
  terminalId: zod_exports.string().uuid(),
  createdTime: zod_exports.coerce.date(),
  createdBy: zod_exports.string(),
  modifiedTime: zod_exports.coerce.date().nullable(),
  modifiedBy: zod_exports.string().nullable(),
  archived: zod_exports.number()
});
var stockPlaceCreateSchema = stockPlaceSchema.pick({
  terminalId: true,
  name: true,
  instructions: true
});
var stockPlaceUpdateSchema = stockPlaceSchema.pick({
  id: true,
  terminalId: true,
  name: true,
  instructions: true
});

// src/lib/schemas/terminalStops.schema.ts
var terminalStopSchema = zod_exports.object({
  id: zod_exports.string().uuid(),
  activityCode: zod_exports.nativeEnum(ActivityStep),
  countryCode: zod_exports.string().nullable(),
  locationName: zod_exports.string().nullable(),
  locationAddress: zod_exports.string().nullable(),
  locationAddress2: zod_exports.string().nullable(),
  locationZipCode: zod_exports.string().nullable(),
  locationCityName: zod_exports.string().nullable(),
  calculatedDistance: zod_exports.number().nullable(),
  beginDrivingTime: zod_exports.coerce.date().nullable(),
  beginOnLocationTime: zod_exports.coerce.date().nullable(),
  beginLoadingTime: zod_exports.coerce.date().nullable(),
  beginUnloadingTime: zod_exports.coerce.date().nullable(),
  beginWaitingTime: zod_exports.coerce.date().nullable(),
  isWaiting: zod_exports.boolean(),
  isAutomaticWaiting: zod_exports.boolean().optional(),
  archived: zod_exports.number(),
  discussionId: zod_exports.string().uuid().nullable(),
  unreadMessageCount: zod_exports.number(),
  truckId: zod_exports.string().uuid().nullable().optional(),
  truckLicense: zod_exports.string().nullable(),
  trailerId: zod_exports.string().uuid().nullable().optional(),
  trailer2Id: zod_exports.string().uuid().nullable().optional(),
  driverId: zod_exports.string().uuid().nullable(),
  driverName: zod_exports.string().nullable(),
  exceptionCount: zod_exports.number().nullable(),
  finishedLdm: zod_exports.number(),
  hasUnfinishedActivities: zod_exports.boolean(),
  loadingMeter: zod_exports.number(),
  plannedDateTime: zod_exports.coerce.date().nullable(),
  resourceCombinationId: zod_exports.string().uuid(),
  sequence: zod_exports.number(),
  status: zod_exports.nativeEnum(StopStatus),
  temp1: zod_exports.number().nullable(),
  temp2: zod_exports.number().nullable(),
  temp3: zod_exports.number().nullable(),
  temp4: zod_exports.number().nullable(),
  terminalDock: zod_exports.string().nullable(),
  terminalDockId: zod_exports.string().uuid().nullable(),
  tpStopNr: zod_exports.number(),
  tpTripId: zod_exports.number(),
  tpTripNr: zod_exports.number(),
  trailers: zod_exports.string(),
  tripIdentifier: zod_exports.string(),
  tripRemarks: zod_exports.string().nullable(),
  sameTrailer1LoadingStopId: zod_exports.string().uuid().nullable(),
  sameTrailer1LoadingTrailerNumber: zod_exports.string().nullable(),
  sameTrailer2LoadingStopId: zod_exports.string().uuid().nullable(),
  sameTrailer2LoadingTrailerNumber: zod_exports.string().nullable(),
  sameTruckLoadingStopId: zod_exports.string().uuid().nullable(),
  sameTruckLoadingTruckNumber: zod_exports.string().nullable(),
  sameTrailer1UnloadingStopId: zod_exports.string().uuid().nullable(),
  sameTrailer1UnloadingTrailerNumber: zod_exports.string().nullable(),
  sameTrailer2UnloadingStopId: zod_exports.string().uuid().nullable(),
  sameTrailer2UnloadingTrailerNumber: zod_exports.string().nullable(),
  sameTruckUnloadingStopId: zod_exports.string().uuid().nullable(),
  sameTruckUnloadingTruckNumber: zod_exports.string().nullable(),
  unloadingInstructions: zod_exports.array(zod_exports.string()).nullable()
});

// src/lib/schemas/tripActivity.schema.ts
var cargoSchema = zod_exports.object({
  loadingMeter: zod_exports.number(),
  unitAmount: zod_exports.number(),
  unit: zod_exports.object({ code: zod_exports.string() }),
  receiverName: zod_exports.string().optional(),
  senderName: zod_exports.string().optional(),
  productDescription: zod_exports.string().optional(),
  dividedCargo: zod_exports.boolean().optional()
});
var DeliveryStatus = /* @__PURE__ */ ((DeliveryStatus2) => {
  DeliveryStatus2[DeliveryStatus2["ON_LOCATION"] = 30] = "ON_LOCATION";
  DeliveryStatus2[DeliveryStatus2["LOADING_STARTED"] = 27] = "LOADING_STARTED";
  DeliveryStatus2[DeliveryStatus2["UNLOADING_STARTED"] = 28] = "UNLOADING_STARTED";
  DeliveryStatus2[DeliveryStatus2["WAITING"] = 29] = "WAITING";
  DeliveryStatus2[DeliveryStatus2["UNLOADING_FINAL_DESTINATION_DONE"] = 14] = "UNLOADING_FINAL_DESTINATION_DONE";
  DeliveryStatus2[DeliveryStatus2["UNLOADING_DONE"] = 10] = "UNLOADING_DONE";
  DeliveryStatus2[DeliveryStatus2["LOADING_FIRST_ORIGIN_DONE"] = 8] = "LOADING_FIRST_ORIGIN_DONE";
  DeliveryStatus2[DeliveryStatus2["LOADING_DONE"] = 12] = "LOADING_DONE";
  return DeliveryStatus2;
})(DeliveryStatus || {});
var tripActivityRelationsSchema = zod_exports.object({
  salesOrderLeg: zod_exports.object({ salesOrderCargo: cargoSchema }),
  status: zod_exports.number()
}).array();
var tripActivitySchema = zod_exports.object({
  id: zod_exports.string().uuid(),
  stopId: zod_exports.string().uuid(),
  salesOrderLegId: zod_exports.string().uuid(),
  resourceCombinationId: zod_exports.string().uuid(),
  salesOrderIdAndSequence: zod_exports.string(),
  status: zod_exports.nativeEnum(TripActivityStatus),
  productDescription: zod_exports.string(),
  plannedDateTime: zod_exports.coerce.date().nullable(),
  temperatureSetPoint: zod_exports.number().nullable(),
  temperatureMin: zod_exports.number().nullable(),
  temperatureMax: zod_exports.number().nullable(),
  orderReference: zod_exports.string(),
  combinedReference: zod_exports.string().nullable(),
  loadingMeter: zod_exports.number(),
  cumulativeLoadMeter: zod_exports.number().default(0),
  cargo: cargoSchema,
  activityCode: zod_exports.nativeEnum(ActivityStep),
  previousDriver: zod_exports.string().nullable(),
  nextDriver: zod_exports.string().nullable(),
  previousTruck: zod_exports.string().nullable(),
  nextTruck: zod_exports.string().nullable(),
  previousTrailer: zod_exports.string().nullable(),
  nextTrailer: zod_exports.string().nullable(),
  documentId: zod_exports.string().uuid().nullable(),
  isOwnDepot: zod_exports.boolean(),
  instructions: zod_exports.string().nullable(),
  unloadingInstructions: zod_exports.string().nullable(),
  staysInTrailer: zod_exports.number().nullable(),
  stockPlace: zod_exports.string().nullable(),
  salesOrderActivityReady: zod_exports.string().nullable(),
  salesOrderActivitySequence: zod_exports.number().nullable(),
  salesOrderActivity: zod_exports.object({
    sequence: zod_exports.number(),
    ready: zod_exports.string().nullable()
  }).optional(),
  beginSalesOrderActivityAddressId: zod_exports.string().optional(),
  beginSalesOrderActivityAddressName: zod_exports.string().optional(),
  beginSalesOrderActivityAddressCityName: zod_exports.string().optional(),
  beginSalesOrderActivityAddressCountryCode: zod_exports.string().optional(),
  beginSalesOrderActivityReference: zod_exports.string().optional(),
  endSalesOrderActivityAddressName: zod_exports.string().optional(),
  endSalesOrderActivityAddressCityName: zod_exports.string().optional(),
  endSalesOrderActivityAddressCountryCode: zod_exports.string().optional(),
  endSalesOrderActivityReference: zod_exports.string().optional(),
  isFinalDestination: zod_exports.boolean(),
  isAssetReturn: zod_exports.boolean(),
  isExtraGear: zod_exports.boolean(),
  isCmrRequired: zod_exports.boolean(),
  tpProductNr: zod_exports.number().nullable().optional(),
  isWall: zod_exports.boolean().optional(),
  depotAddressName: zod_exports.string().nullable(),
  discussionId: zod_exports.string().uuid().nullable().optional(),
  unreadMessageCount: zod_exports.number().optional(),
  canBeFinished: zod_exports.boolean().optional(),
  cargoSpace: zod_exports.number().int().refine((v) => v === 0 || v === 1).nullable(),
  cargoSpace1CumulativeLoadMeter: zod_exports.number().nullable(),
  cargoSpace2CumulativeLoadMeter: zod_exports.number().nullable(),
  missingShipmentDescription: zod_exports.string().optional().nullable(),
  hasPreviousReportedIssues: zod_exports.boolean().optional(),
  tpTripActivityNr: zod_exports.number().nullable(),
  tpStopNr: zod_exports.number().nullable(),
  tpResourceCombinationNr: zod_exports.number().nullable(),
  tpTripIdNr: zod_exports.number().nullable(),
  tpTripripId: zod_exports.number().nullable()
});
var tripActivityUpdateSchema = zod_exports.object({
  status: zod_exports.number().optional(),
  amountDifferenceReason: zod_exports.string().optional(),
  amountDifferenceAmount: zod_exports.string().optional(),
  location: locationSchema.optional(),
  activityCode: zod_exports.nativeEnum(ActivityStep).optional()
});

// src/lib/schemas/userCreditor.schema.ts
var userCreditorSchema = zod_exports.object({
  id: zod_exports.string().uuid().optional(),
  userId: zod_exports.string().uuid(),
  companyId: zod_exports.string().uuid(),
  createdTime: zod_exports.coerce.date().optional(),
  createdBy: zod_exports.string().uuid().optional(),
  modifiedTime: zod_exports.coerce.date().optional().nullable(),
  modifiedBy: zod_exports.string().uuid().optional().nullable(),
  archived: zod_exports.number().optional()
});
var userCreditorsSchema = zod_exports.array(userCreditorSchema);

// src/lib/schemas/user.schema.ts
var userAttributesSchema = zod_exports.object({
  id: zod_exports.string().uuid(),
  email: zod_exports.string().email(),
  firstName: zod_exports.string().regex(nameRegex),
  lastName: zod_exports.string().regex(nameRegex),
  title: optionalStringRegex,
  phone: optionalPhoneRegex,
  avatar: optionalStringRegex,
  language: zod_exports.string().nullable(),
  startDate: zod_exports.coerce.date(),
  endDate: zod_exports.coerce.date().nullish(),
  createdTime: zod_exports.coerce.date(),
  createdBy: zod_exports.string().uuid(),
  modifiedTime: zod_exports.coerce.date().nullable(),
  modifiedBy: zod_exports.string().uuid().nullable(),
  archived: zod_exports.string()
});
var userSchema = zod_exports.object({
  id: zod_exports.string().uuid().optional(),
  email: zod_exports.string().email(),
  firstName: zod_exports.string().regex(nameRegex).optional(),
  lastName: zod_exports.string().regex(nameRegex).optional(),
  drivers: driverSchema.array().optional(),
  driverIds: zod_exports.string().optional(),
  creditors: userCreditorSchema.array().optional(),
  creditorIds: zod_exports.string().optional(),
  title: optionalStringRegex,
  phone: optionalPhoneRegex,
  avatar: optionalStringRegex,
  language: zod_exports.string().nullable().optional(),
  startDate: zod_exports.coerce.date(),
  endDate: zod_exports.coerce.date().nullish(),
  createdTime: zod_exports.coerce.date().optional(),
  createdBy: zod_exports.string().uuid().optional(),
  modifiedTime: zod_exports.coerce.date().optional().nullable(),
  modifiedBy: zod_exports.string().uuid().optional().nullable(),
  archived: zod_exports.string().optional()
});
var userDetailsSchema = userAttributesSchema.pick({
  id: true,
  email: true,
  firstName: true,
  lastName: true,
  title: true,
  phone: true,
  avatar: true,
  startDate: true,
  endDate: true,
  archived: true
}).extend({
  roles: zod_exports.string().array(),
  stakeholders: zod_exports.string().array(),
  driverIds: zod_exports.string().array(),
  creditorIds: zod_exports.string().array()
});
var userCreateSchema = userAttributesSchema.pick({
  email: true,
  firstName: true,
  lastName: true,
  title: true,
  phone: true,
  avatar: true,
  startDate: true,
  endDate: true
}).extend({
  roles: zod_exports.string().optional(),
  stakeholders: zod_exports.string().optional(),
  driverIds: zod_exports.string().optional(),
  creditorIds: zod_exports.string().optional()
});
var userUpdateSchema = userAttributesSchema.pick({
  id: true,
  email: true,
  firstName: true,
  lastName: true,
  title: true,
  phone: true,
  avatar: true,
  startDate: true,
  endDate: true
}).extend({
  roles: zod_exports.string(),
  stakeholders: zod_exports.string(),
  driverIds: zod_exports.string(),
  creditorIds: zod_exports.string()
});
var usersSchema = zod_exports.array(userSchema);
var userEmailSchema = zod_exports.string().email();
var userLanguageSchema = zod_exports.string();

// src/lib/schemas/userApplicationRole.schema.ts
var userApplicationRoleSchema = zod_exports.object({
  id: zod_exports.string().uuid().optional(),
  userId: zod_exports.string().uuid(),
  applicationRoleId: zod_exports.string().uuid(),
  startDate: zod_exports.date(),
  endDate: zod_exports.date().nullish(),
  createdTime: zod_exports.coerce.date().optional(),
  createdBy: zod_exports.string().uuid().optional(),
  modifiedTime: zod_exports.coerce.date().optional().nullable(),
  modifiedBy: zod_exports.string().uuid().optional().nullable(),
  archived: zod_exports.number().optional()
});
var createUserApplicationRoleSchema = userApplicationRoleSchema.extend(
  {
    startDate: zod_exports.date().optional()
  }
);
var userApplicationRolesSchema = zod_exports.array(userApplicationRoleSchema);

// src/lib/schemas/useRight.schema.ts
var Permissions = /* @__PURE__ */ ((Permissions2) => {
  Permissions2["RIGHTS_ROLES_ADMIN"] = "roles_admin";
  Permissions2["RIGHTS_STAKEHOLDERS_ADMIN"] = "stakeholders_admin";
  Permissions2["RIGHTS_STAKEHOLDERS_USER"] = "stakeholders_user";
  Permissions2["RIGHTS_USE_RIGHTS_ADMIN"] = "useRights_admin";
  Permissions2["RIGHTS_USE_RIGHTS_USER"] = "useRights_user";
  Permissions2["RIGHTS_USERS_ADMIN"] = "users_admin";
  Permissions2["RIGHTS_USER_STORIES_ADMIN"] = "userStories_admin";
  Permissions2["RIGHTS_SHIPMENTS_USER"] = "shipments_user";
  Permissions2["RIGHTS_TERMINAL_USER"] = "terminal_user";
  Permissions2["RIGHTS_TERMINAL_ADMIN"] = "terminal_admin";
  Permissions2["RIGHTS_FEATURES_ADMIN"] = "features_admin";
  Permissions2["RIGHTS_FEATURES_USER"] = "features_user";
  Permissions2["RIGHTS_USERS_USER"] = "users_user";
  Permissions2["RIGHTS_ROLES_USER"] = "roles_user";
  Permissions2["RIGHTS_USER_STORIES_USER"] = "userStories_user";
  Permissions2["RIGHTS_PUSH_USER"] = "push_user";
  Permissions2["RIGHTS_SHIPMENTS_ADMIN"] = "shipments_admin";
  Permissions2["RIGHTS_SHIPMENTS_START_MULTIPLE_STOPS"] = "shipments_start_multiple_stops";
  Permissions2["RIGHTS_TRIP_ACTIVITY_RECOVERY"] = "shipments_tripactivity_recovery";
  Permissions2["RIGHTS_SHIPMENTS_SHOW_ALL_GIGS"] = "shipments_show_all_gigs";
  Permissions2["RIGHTS_EXCEPTION_TYPE_ADMIN"] = "exceptionType_admin";
  Permissions2["RIGHTS_EXCEPTIONS_USER"] = "exceptions_user";
  Permissions2["RIGHTS_EXCEPTIONS_ADMIN"] = "exceptions_admin";
  Permissions2["RIGHTS_HAILEY_HR"] = "haileyHr";
  Permissions2["RIGHTS_HOUR_REPORTING"] = "hourReporting";
  Permissions2["RIGHTS_PIHLAJALINNA"] = "pihlajalinna";
  Permissions2["RIGHTS_NEWSLETTER"] = "newsLetter";
  Permissions2["RIGHTS_SEND_SICK_LEAVE_CERTIFICATE"] = "sendSickLeaveCertificate";
  Permissions2["RIGHTS_OUTLOOK"] = "outlook";
  Permissions2["RIGHTS_SEND_RECEIPTS"] = "sendReceipts";
  Permissions2["RIGHTS_SEND_TRAFFIC_ACCIDENT_REPORT"] = "sendTrafficAccidentReport";
  Permissions2["RIGHTS_CHAT_USER"] = "chatUser";
  Permissions2["RIGHTS_CHAT_ADMIN"] = "chatAdmin";
  Permissions2["RIGHTS_PAYROLL_ADMIN"] = "payroll_admin";
  return Permissions2;
})(Permissions || {});
var useRightSchema = zod_exports.object({
  id: zod_exports.string().uuid().optional(),
  featureId: zod_exports.string().uuid(),
  key: zod_exports.string().regex(keyRegex),
  name: zod_exports.string().regex(nameRegex),
  description: optionalStringRegex,
  createdTime: zod_exports.coerce.date().optional(),
  createdBy: zod_exports.string().uuid().optional(),
  modifiedTime: zod_exports.coerce.date().nullable().optional(),
  modifiedBy: zod_exports.string().uuid().nullable().optional(),
  archived: zod_exports.number().optional()
});
var useRightsSchema = zod_exports.array(useRightSchema);
var useRightKeySchema = zod_exports.string().regex(keyRegex);

// src/lib/schemas/userStakeholder.schema.ts
var userStakeholderSchema = zod_exports.object({
  id: zod_exports.string().uuid().optional(),
  userId: zod_exports.string().uuid(),
  stakeholderId: zod_exports.string().uuid(),
  startDate: zod_exports.date(),
  endDate: zod_exports.date().nullish(),
  createdTime: zod_exports.coerce.date().optional(),
  createdBy: zod_exports.string().uuid().optional(),
  modifiedTime: zod_exports.coerce.date().optional().nullable(),
  modifiedBy: zod_exports.string().uuid().optional().nullable(),
  archived: zod_exports.number().optional()
});
var createUserStakeholderSchema = userStakeholderSchema.extend({
  startDate: zod_exports.date().optional()
});
var userStakeholdersSchema = zod_exports.array(userStakeholderSchema);

// src/lib/schemas/userStoryStatus.schema.ts
var UserStoryStatusKey = /* @__PURE__ */ ((UserStoryStatusKey2) => {
  UserStoryStatusKey2["NEW"] = "new";
  UserStoryStatusKey2["PRIO1"] = "prio1";
  UserStoryStatusKey2["PRIO2"] = "prio2";
  UserStoryStatusKey2["PRIO3"] = "prio3";
  UserStoryStatusKey2["LATER"] = "later";
  UserStoryStatusKey2["READY"] = "ready";
  UserStoryStatusKey2["REJECTED"] = "rejected";
  UserStoryStatusKey2["IN_PROGRESS"] = "inProgress";
  return UserStoryStatusKey2;
})(UserStoryStatusKey || {});
var userStoryStatusSchema = zod_exports.object({
  id: zod_exports.string().uuid().optional(),
  name: zod_exports.string().regex(stringRegex),
  key: zod_exports.nativeEnum(UserStoryStatusKey),
  description: optionalStringRegex,
  ordering: zod_exports.number().optional(),
  defaultForInitial: zod_exports.number().nonnegative().lte(1).nullish(),
  createdTime: zod_exports.coerce.date().optional(),
  createdBy: zod_exports.string().uuid().optional(),
  modifiedTime: zod_exports.coerce.date().optional().nullable(),
  modifiedBy: zod_exports.string().uuid().optional().nullable(),
  archived: zod_exports.boolean().optional()
});
var userStoryStatusesSchema = zod_exports.array(userStoryStatusSchema);

// src/lib/schemas/userStory.schema.ts
var userStorySchema = zod_exports.object({
  id: zod_exports.string().uuid().optional(),
  userId: zod_exports.string().uuid(),
  stakeholderId: zod_exports.string().uuid(),
  stakeholderName: optionalStringRegex,
  epicId: zod_exports.string().uuid().optional(),
  action: zod_exports.string().regex(stringRegex),
  reason: zod_exports.string().regex(stringRegex),
  userStoryStatusId: zod_exports.string().uuid().nullable(),
  epicUserStoryId: zod_exports.string().uuid().optional(),
  votesCount: zod_exports.number().nonnegative().optional(),
  createdTime: zod_exports.coerce.date().optional(),
  createdBy: zod_exports.string().uuid().optional(),
  modifiedTime: zod_exports.coerce.date().optional().nullable(),
  modifiedBy: zod_exports.string().uuid().optional().nullable(),
  archived: zod_exports.number().optional()
});
var userStoryCreateSchema = zod_exports.object({
  epicId: zod_exports.string().uuid(),
  stakeholderId: zod_exports.string(),
  userStoryStatusId: zod_exports.string(),
  action: zod_exports.string().regex(stringRegex),
  reason: zod_exports.string().regex(stringRegex)
});
var userStoryUpdateSchema = userStoryCreateSchema.extend({
  id: zod_exports.string().uuid()
});
var userStoriesSchema = zod_exports.array(userStorySchema);
var userStoryResponseSchema = zod_exports.object({
  id: zod_exports.string().uuid(),
  userId: zod_exports.string().uuid(),
  stakeholderId: zod_exports.string().uuid(),
  action: zod_exports.string(),
  reason: zod_exports.string(),
  userStoryStatusId: zod_exports.string().uuid(),
  userStoryVoteId: zod_exports.string().uuid(),
  status: zod_exports.nativeEnum(UserStoryStatusKey),
  epicUserStoryId: zod_exports.string().uuid(),
  votesCount: zod_exports.number(),
  stakeholderName: zod_exports.string(),
  archived: zod_exports.number(),
  createdTime: zod_exports.coerce.date().optional(),
  commentsCount: zod_exports.number()
});

// src/lib/schemas/userStoryComment.schema.ts
var USER_STORY_COMMENT_MAX_LENGTH = 500;
var userStoryCommentCreateSchema = zod_exports.object({
  userStoryId: zod_exports.string().uuid(),
  comment: zod_exports.string().trim().min(1).max(USER_STORY_COMMENT_MAX_LENGTH)
});
var userStoryCommentResponseSchema = zod_exports.object({
  id: zod_exports.string().uuid(),
  userStoryId: zod_exports.string().uuid(),
  userId: zod_exports.string().uuid(),
  comment: zod_exports.string(),
  createdTime: zod_exports.coerce.date(),
  userName: zod_exports.string(),
  avatar: zod_exports.string().nullable()
});
var userStoryCommentsResponseSchema = zod_exports.array(
  userStoryCommentResponseSchema
);

// src/lib/schemas/userStoryVote.schema.ts
var userStoryVoteSchema = zod_exports.object({
  id: zod_exports.string().uuid().optional(),
  userStoryId: zod_exports.string().uuid(),
  userId: zod_exports.string().uuid().optional(),
  vote: zod_exports.number().nonnegative().lte(1),
  createdTime: zod_exports.coerce.date().optional(),
  createdBy: zod_exports.string().uuid().optional(),
  modifiedTime: zod_exports.coerce.date().optional().nullable(),
  modifiedBy: zod_exports.string().uuid().optional().nullable(),
  archived: zod_exports.number()
});
var userStoryVoteRequestSchema = zod_exports.object({
  userStoryId: zod_exports.string().uuid(),
  vote: zod_exports.number().nonnegative().lte(1)
});
var userStoryVotesSchema = zod_exports.array(userStoryVoteSchema);

// src/lib/schemas/workType.schema.ts
var workTypeSchema = zod_exports.object({
  id: zod_exports.string(),
  code: zod_exports.string(),
  name: zod_exports.string(),
  description: zod_exports.string().nullable(),
  archived: zod_exports.coerce.number()
});
var workTypeCreateSchema = zod_exports.object({
  code: zod_exports.string().trim().min(1).max(100).regex(keyRegex),
  name: zod_exports.string().trim().min(1).max(255).regex(exceptionLocalizedTextRegex),
  description: optionalStringRegex
});
export {
  ActivityStage,
  ActivityStep,
  ApplicationMessageKey,
  DeliveryStatus,
  DiscussionContextType,
  DiscussionType,
  EXCEPTION_COMMENT_MAX_BYTES,
  ExceptionActionTypeKey,
  ExceptionContractorInvoiceStatus,
  ExceptionCostPaidByInsuranceStatus,
  ExceptionOrder,
  ExceptionReportType,
  ExceptionSeverity,
  ExceptionSourceKey,
  ExceptionStatus,
  InstructionKey,
  MassFunctionality,
  MessageTypeKey,
  NotificationContext,
  NotificationType,
  PayGroupMemberOrder,
  Permissions,
  QUERY_KEYS,
  SOCKET_EVENTS,
  ShipmentResponseSchema,
  ShipmentStatus,
  StopStatus,
  TranspasActivityStatus,
  TripActivityStatus,
  USER_STORY_COMMENT_MAX_LENGTH,
  UserStoryStatusKey,
  absenceTypeCreateSchema,
  absenceTypeSchema,
  activeStopSchema,
  addUsersToRoleSchema,
  applicationMessageSchema,
  applicationRoleSchema,
  applicationRoleUseRightSchema,
  applicationRoleUseRightsSchema,
  applicationRoleUseRightsUpdateItemSchema,
  applicationRoleUseRightsUpdateSchema,
  applicationRolesSchema,
  authSchema,
  bulkUpdateDocumentSchema,
  companiesSchema,
  companySchema,
  createDocumentCMRSchema,
  createDocumentTrailerPhotoSchema,
  createUserApplicationRoleSchema,
  createUserStakeholderSchema,
  discussionContextSchema,
  discussionCreateSchema,
  discussionMessagesSchema,
  discussionParticipantRemoveSchema,
  discussionParticipantSchema,
  discussionParticipantSummarySchema,
  discussionSchema,
  discussionSummarySchema,
  documentSchema,
  driverSchema,
  emailSchema,
  epicResponseSchema,
  epicSchema,
  epicStakeholderResponseSchema,
  epicStakeholderSchema,
  epicStakeholderUpdateSchema,
  epicStakeholdersSchema,
  epicUpdateSchema,
  epicUserStorySchema,
  epicsSchema,
  exceptionActionSchema,
  exceptionCauseCreateSchema,
  exceptionCauseNameSchema,
  exceptionCauseSchema2 as exceptionCauseSchema,
  exceptionClassCreateSchema,
  exceptionClassNameSchema,
  exceptionClassSchema,
  exceptionCommentCreateSchema,
  exceptionContextItemSchema,
  exceptionContextsUpdateSchema,
  exceptionCostPatchItemSchema,
  exceptionCostPatchSchema,
  exceptionCostSchema,
  exceptionCountsSchema,
  exceptionCreateSchema,
  exceptionFiltersSchema,
  exceptionFormInstructionsSchema,
  exceptionImagesUploadQuerySchema,
  exceptionInfoCreateSchema,
  exceptionIssueInfoUpdateSchema,
  exceptionLocalizedTextRegex,
  exceptionReasonCreateSchema,
  exceptionReasonOptionSchema,
  exceptionReasonResponseSchema,
  exceptionReasonSchema,
  exceptionRelatedContextSchema,
  exceptionReportCreateSchema,
  exceptionReportFiltersSchema,
  exceptionReportLabelsSchema,
  exceptionReportTypeSchema,
  exceptionSchema,
  exceptionSeveritySchema,
  exceptionStatusSchema,
  exceptionTypeCreateSchema,
  exceptionTypeNameSchema,
  exceptionTypeOptionSchema,
  exceptionTypeSchema,
  exceptionUpdateSchema,
  exceptionWaitingReasonCreateSchema,
  exceptionWaitingReasonSchema,
  extraShipmentCreateSchema,
  extraShipmentSchema,
  extraShipmentUpdateSchema,
  featureSchema,
  featuresSchema,
  getCurrentDateAndTime,
  getDateString,
  getUtf8ByteLength,
  getWeekFolder,
  idSchema,
  idsSchema,
  isExceptionSeverity,
  isExceptionStatus,
  keyRegex,
  langSchema,
  languageSchema,
  locationSchema,
  messageCreateSchema,
  messageSchema,
  messageSendResponseSchema,
  messageUpdateSchema,
  multilineTextRegex,
  nameRegex,
  notificationRecipientUpdateSchema,
  notificationResponseSchema,
  notificationRowResSchema,
  notificationRowSchema,
  notificationSchema,
  numberSchema,
  optionalExceptionLocalizedTextRegex,
  optionalPhoneRegex,
  optionalStringRegex,
  organisationApplicationFeatureSchema,
  organisationApplicationSchema,
  palletGroupDescriptionSchema,
  payGroupCreateSchema,
  payGroupMemberSchema,
  payGroupMembersAddSchema,
  payGroupSchema,
  payrollTypeCreateSchema,
  payrollTypeSchema,
  phoneRegex,
  pushNotificationSchema,
  pushNotificationSubscriptionSchema,
  pushNotificationSubscriptionsSchema,
  reasonNameSchema,
  reasonTranslationSchema,
  relatedContextCreateSchema,
  relatedExceptionSchema,
  reorderStopsBodySchema,
  reorderTpStopsPayloadSchema,
  reportRestSchema,
  roleCreateSchema,
  roleCreationAttributesSchema,
  roleGroupSchema,
  roleUpdateSchema,
  roleUserSchema,
  roleUsersSchema,
  shipmentDriverSchema,
  shipmentLogAddSchema,
  shipmentLogSchema,
  shipmentLogStatusSchema,
  shipmentLogUpdateSchema,
  shipmentQuerySchema,
  shipmentSchema,
  shipmentUpdateSchema,
  shipmentVehicleSchema,
  signUpSchema,
  stakeholderCreateSchema,
  stakeholderSchema,
  stakeholdersSchema,
  stockPlaceCreateSchema,
  stockPlaceSchema,
  stockPlaceUpdateSchema,
  stopCurrentDateUpdateSchema,
  stopRegistrationSchema,
  stopSchema,
  stopUpdateSchema,
  stringRegex,
  subscriptionSchema,
  terminalActivitySchema,
  terminalAttributesSchema,
  terminalCreateSchema,
  terminalDockCreateSchema,
  terminalDockSchema,
  terminalDockUpdateSchema,
  terminalSchema,
  terminalStopSchema,
  terminalUpdateSchema,
  tpActivitySchema,
  tpStopPartialSchema,
  trafficAccidentMessageSchema,
  tripActivityContextSchema,
  tripActivityRelationsSchema,
  tripActivitySchema,
  tripActivityUpdateSchema,
  tripContextSchema,
  updateLoadMetersQuery,
  useRightKeySchema,
  useRightSchema,
  useRightsSchema,
  userApplicationRoleSchema,
  userApplicationRolesSchema,
  userAttributesSchema,
  userCreateSchema,
  userCreditorSchema,
  userCreditorsSchema,
  userDetailsSchema,
  userEmailSchema,
  userLanguageSchema,
  userSchema,
  userStakeholderSchema,
  userStakeholdersSchema,
  userStoriesSchema,
  userStoryCommentCreateSchema,
  userStoryCommentResponseSchema,
  userStoryCommentsResponseSchema,
  userStoryCreateSchema,
  userStoryResponseSchema,
  userStorySchema,
  userStoryStatusSchema,
  userStoryStatusesSchema,
  userStoryUpdateSchema,
  userStoryVoteRequestSchema,
  userStoryVoteSchema,
  userStoryVotesSchema,
  userUpdateSchema,
  usersSchema,
  uuid,
  workTypeCreateSchema,
  workTypeSchema,
  zod_exports as z
};
